/**
 @typedef {Object} ScannedCode
 @property {string} prefix
 @property {string} barcode
 */
/**
 @typedef {Object.<any>} Property_Generic
 @property {string} value
 @property {string} error
 @property {string} type
 @property {bool} required
 @property {bool} update
 @property {string} label
 @property {string} helper
 @property {array} set
 @property {bool} searchable
 @property {bool} queryable
 @property {bool} visible
 @property {?string} override
 @property {?string} reference
 @property {Object} range
 @property {name} pkey
 */
/**
 @typedef {Object.<any>} Accolades
 @property {Accolades_Properties} properties
 @property {Accolades_Has} has
 @property {Accolades_Is} is
 @property {Accolades_Object} object
 */
/**
 @typedef {Object.<any>} Accolades_Properties
 @property {number|int} achievement
 @property {date|string} created
 @property {number|int} milestone
 @property {number|int} pkey
 @property {number|int} user
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Accolades_Has
 */
/**
 @typedef {Object.<any>} Accolades_Is
 @property {Achievements_Object} achievements
 @property {Milestones_Object} milestones
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Accolades_Object
 @property {?number|int} achievement
 @property {string} achievement_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} milestone
 @property {string} milestone_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Achievements_Object} achievements
 @property {Milestones_Object} milestones
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Accounts
 @property {Accounts_Properties} properties
 @property {Accounts_Has} has
 @property {Accounts_Is} is
 @property {Accounts_Object} object
 */
/**
 @typedef {Object.<any>} Accounts_Properties
 @property {email} email
 @property {text|string} name_first
 @property {text|string} name_last
 @property {string} password
 @property {number|int} pkey
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 @property {string} password_confirm
 @property {text|string} secure_auth
 @property {text|string} token
 @property {text|string} version
 */
/**
 @typedef {Object.<any>} Accounts_Has
 @property {Regions_Object[]} regions
 */
/**
 @typedef {Object.<any>} Accounts_Is
 */
/**
 @typedef {Object.<any>} Accounts_Object
 @property {?email} email
 @property {string} email_error
 @property {?text|string} name_first
 @property {string} name_first_error
 @property {?text|string} name_last
 @property {string} name_last_error
 @property {?string} password
 @property {string} password_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {?string} password_confirm
 @property {string} password_confirm_error
 @property {?text|string} secure_auth
 @property {string} secure_auth_error
 @property {?text|string} token
 @property {string} token_error
 @property {?text|string} version
 @property {string} version_error
 @property {Regions_Object[]} regions
 */
/**
 @typedef {Object.<any>} Actionable_Calendars
 @property {Actionable_Calendars_Properties} properties
 @property {Actionable_Calendars_Has} has
 @property {Actionable_Calendars_Is} is
 @property {Actionable_Calendars_Object} object
 */
/**
 @typedef {Object.<any>} Actionable_Calendars_Properties
 @property {boolean} actioned
 @property {number|int} actioned_by
 @property {date|string} actioned_on
 @property {number|int} calendarsPkey
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Actionable_Calendars_Has
 */
/**
 @typedef {Object.<any>} Actionable_Calendars_Is
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Actionable_Calendars_Object
 @property {?boolean} actioned
 @property {string} actioned_error
 @property {?number|int} actioned_by
 @property {string} actioned_by_error
 @property {?date|string} actioned_on
 @property {string} actioned_on_error
 @property {?number|int} calendarsPkey
 @property {string} calendarsPkey_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Activity_Logs
 @property {Activity_Logs_Properties} properties
 @property {Activity_Logs_Has} has
 @property {Activity_Logs_Is} is
 @property {Activity_Logs_Object} object
 */
/**
 @typedef {Object.<any>} Activity_Logs_Properties
 @property {number|int} activity_type
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Activity_Logs_Has
 */
/**
 @typedef {Object.<any>} Activity_Logs_Is
 @property {Activity_Types_Object} activity_types
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Activity_Logs_Object
 @property {?number|int} activity_type
 @property {string} activity_type_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Activity_Types_Object} activity_types
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Activity_Types
 @property {Activity_Types_Properties} properties
 @property {Activity_Types_Has} has
 @property {Activity_Types_Is} is
 @property {Activity_Types_Object} object
 */
/**
 @typedef {Object.<any>} Activity_Types_Properties
 @property {text|string} activity_name
 @property {number|int} pkey
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Activity_Types_Has
 */
/**
 @typedef {Object.<any>} Activity_Types_Is
 */
/**
 @typedef {Object.<any>} Activity_Types_Object
 @property {?text|string} activity_name
 @property {string} activity_name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Admins
 @property {Admins_Properties} properties
 @property {Admins_Has} has
 @property {Admins_Is} is
 @property {Admins_Object} object
 */
/**
 @typedef {Object.<any>} Admins_Properties
 @property {number|int} account
 @property {boolean} active
 @property {number|int} base_pay
 @property {boolean} calendarException
 @property {number|int} carrier
 @property {text|string} city
 @property {number|int} commission
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} dd_account
 @property {text|string} dd_routing
 @property {boolean} deep_sleep
 @property {email} email
 @property {text|string} eventColor
 @property {number|int} fe_work_order_amount
 @property {boolean} fill_hold
 @property {date|string} last_approved_week
 @property {text|string} last_day_calendars_linked
 @property {date|string} last_day_working
 @property {text|string} last_passwords
 @property {number|int|float} latitude
 @property {number|int|float} longitude
 @property {number|int} main_role
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name_first
 @property {text|string} name_last
 @property {text|string} name_middle
 @property {date|string} onboarding_date
 @property {string} password
 @property {date|string} password_updated_at
 @property {text|string} phone_cell
 @property {text|string} phone_home
 @property {text|string} phone_work
 @property {number|int} pkey
 @property {number|int} region
 @property {text|string} state
 @property {text|string} street_1
 @property {date|string} temp_fifth
 @property {text|string} workingDays
 @property {text|string} zip
 @property {text|string} auth_code
 @property {boolean} b_checkbox
 @property {text|string} business_name
 @property {text|string} code
 @property {text|string} code_hash
 @property {number|int} code_pkey
 @property {date|string} consumed_at
 @property {text|string} consumed_device
 @property {text|string} consumed_display_time
 @property {boolean} consumed_offline
 @property {boolean} dd_pending
 @property {boolean} delayed
 @property {string} dl_back
 @property {string} dl_front
 @property {text|string} ein
 @property {text|string} event_type
 @property {text|string} llc_class
 @property {text|string} main_role_name
 @property {text|string} name
 @property {date|string} occurred_at
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 @property {text|string} other
 @property {text|string} reason
 @property {array} roles
 @property {text|string} schedule
 @property {text|string} secure_auth
 @property {number|int|float} service_latitude
 @property {number|int|float} service_longitude
 @property {number|int} service_radius
 @property {text|string} ssn
 @property {number|int} target_user
 @property {number|int} tax_classification
 @property {text|string} token
 @property {boolean} tos_checkbox
 @property {text|string} tos_signature
 @property {number|int} user
 @property {text|string} w9
 @property {text|string} w9_signature
 */
/**
 @typedef {Object.<any>} Admins_Has
 @property {Users_Roles_Object[]} users_roless
 */
/**
 @typedef {Object.<any>} Admins_Is
 @property {Accounts_Object} accounts
 @property {Carriers_Object} carriers
 @property {Regions_Object} regions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Admins_Object
 @property {?number|int} account
 @property {string} account_error
 @property {?boolean} active
 @property {string} active_error
 @property {?number|int} base_pay
 @property {string} base_pay_error
 @property {?boolean} calendarException
 @property {string} calendarException_error
 @property {?number|int} carrier
 @property {string} carrier_error
 @property {?text|string} city
 @property {string} city_error
 @property {?number|int} commission
 @property {string} commission_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} dd_account
 @property {string} dd_account_error
 @property {?text|string} dd_routing
 @property {string} dd_routing_error
 @property {?boolean} deep_sleep
 @property {string} deep_sleep_error
 @property {?email} email
 @property {string} email_error
 @property {?text|string} eventColor
 @property {string} eventColor_error
 @property {?number|int} fe_work_order_amount
 @property {string} fe_work_order_amount_error
 @property {?boolean} fill_hold
 @property {string} fill_hold_error
 @property {?date|string} last_approved_week
 @property {string} last_approved_week_error
 @property {?text|string} last_day_calendars_linked
 @property {string} last_day_calendars_linked_error
 @property {?date|string} last_day_working
 @property {string} last_day_working_error
 @property {?text|string} last_passwords
 @property {string} last_passwords_error
 @property {?number|int|float} latitude
 @property {string} latitude_error
 @property {?number|int|float} longitude
 @property {string} longitude_error
 @property {?number|int} main_role
 @property {string} main_role_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name_first
 @property {string} name_first_error
 @property {?text|string} name_last
 @property {string} name_last_error
 @property {?text|string} name_middle
 @property {string} name_middle_error
 @property {?date|string} onboarding_date
 @property {string} onboarding_date_error
 @property {?string} password
 @property {string} password_error
 @property {?date|string} password_updated_at
 @property {string} password_updated_at_error
 @property {?text|string} phone_cell
 @property {string} phone_cell_error
 @property {?text|string} phone_home
 @property {string} phone_home_error
 @property {?text|string} phone_work
 @property {string} phone_work_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} region
 @property {string} region_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?date|string} temp_fifth
 @property {string} temp_fifth_error
 @property {?text|string} workingDays
 @property {string} workingDays_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {?text|string} auth_code
 @property {string} auth_code_error
 @property {?boolean} b_checkbox
 @property {string} b_checkbox_error
 @property {?text|string} business_name
 @property {string} business_name_error
 @property {?text|string} code
 @property {string} code_error
 @property {?text|string} code_hash
 @property {string} code_hash_error
 @property {?number|int} code_pkey
 @property {string} code_pkey_error
 @property {?date|string} consumed_at
 @property {string} consumed_at_error
 @property {?text|string} consumed_device
 @property {string} consumed_device_error
 @property {?text|string} consumed_display_time
 @property {string} consumed_display_time_error
 @property {?boolean} consumed_offline
 @property {string} consumed_offline_error
 @property {?boolean} dd_pending
 @property {string} dd_pending_error
 @property {?boolean} delayed
 @property {string} delayed_error
 @property {?string} dl_back
 @property {string} dl_back_error
 @property {?string} dl_front
 @property {string} dl_front_error
 @property {?text|string} ein
 @property {string} ein_error
 @property {?text|string} event_type
 @property {string} event_type_error
 @property {?text|string} llc_class
 @property {string} llc_class_error
 @property {?text|string} main_role_name
 @property {string} main_role_name_error
 @property {?text|string} name
 @property {string} name_error
 @property {?date|string} occurred_at
 @property {string} occurred_at_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {?text|string} other
 @property {string} other_error
 @property {?text|string} reason
 @property {string} reason_error
 @property {?array} roles
 @property {string} roles_error
 @property {?text|string} schedule
 @property {string} schedule_error
 @property {?text|string} secure_auth
 @property {string} secure_auth_error
 @property {?number|int|float} service_latitude
 @property {string} service_latitude_error
 @property {?number|int|float} service_longitude
 @property {string} service_longitude_error
 @property {?number|int} service_radius
 @property {string} service_radius_error
 @property {?text|string} ssn
 @property {string} ssn_error
 @property {?number|int} target_user
 @property {string} target_user_error
 @property {?number|int} tax_classification
 @property {string} tax_classification_error
 @property {?text|string} token
 @property {string} token_error
 @property {?boolean} tos_checkbox
 @property {string} tos_checkbox_error
 @property {?text|string} tos_signature
 @property {string} tos_signature_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} w9
 @property {string} w9_error
 @property {?text|string} w9_signature
 @property {string} w9_signature_error
 @property {Users_Roles_Object[]} users_roless
 @property {Accounts_Object} accounts
 @property {Carriers_Object} carriers
 @property {Regions_Object} regions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Alerts
 @property {Alerts_Properties} properties
 @property {Alerts_Has} has
 @property {Alerts_Is} is
 @property {Alerts_Object} object
 */
/**
 @typedef {Object.<any>} Alerts_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} message
 @property {date|string} modified
 @property {number|int} modifier
 @property {date|string} open_time
 @property {boolean} opened
 @property {number|int} pkey
 @property {number|int} user_receiving
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Alerts_Has
 */
/**
 @typedef {Object.<any>} Alerts_Is
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Alerts_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} message
 @property {string} message_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?date|string} open_time
 @property {string} open_time_error
 @property {?boolean} opened
 @property {string} opened_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} user_receiving
 @property {string} user_receiving_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Auth_Codes
 @property {Auth_Codes_Properties} properties
 @property {Auth_Codes_Has} has
 @property {Auth_Codes_Is} is
 @property {Auth_Codes_Object} object
 */
/**
 @typedef {Object.<any>} Auth_Codes_Properties
 @property {text|string} code
 @property {date|string} created
 @property {number|int} pkey
 @property {number|int} user
 @property {boolean} verified
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Auth_Codes_Has
 */
/**
 @typedef {Object.<any>} Auth_Codes_Is
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Auth_Codes_Object
 @property {?text|string} code
 @property {string} code_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} user
 @property {string} user_error
 @property {?boolean} verified
 @property {string} verified_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Automated_Emails
 @property {Automated_Emails_Properties} properties
 @property {Automated_Emails_Has} has
 @property {Automated_Emails_Is} is
 @property {Automated_Emails_Object} object
 */
/**
 @typedef {Object.<any>} Automated_Emails_Properties
 @property {text|string} body
 @property {date|string} created
 @property {number|int} customer
 @property {text|string} customer_name
 @property {text|string} email_kind
 @property {date|string} email_opened
 @property {boolean} has_snapshot
 @property {number|int} pkey
 @property {text|string} sent_to
 @property {text|string} subject
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Automated_Emails_Has
 */
/**
 @typedef {Object.<any>} Automated_Emails_Is
 @property {Customers_Object} customers
 */
/**
 @typedef {Object.<any>} Automated_Emails_Object
 @property {?text|string} body
 @property {string} body_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} customer_name
 @property {string} customer_name_error
 @property {?text|string} email_kind
 @property {string} email_kind_error
 @property {?date|string} email_opened
 @property {string} email_opened_error
 @property {?boolean} has_snapshot
 @property {string} has_snapshot_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} sent_to
 @property {string} sent_to_error
 @property {?text|string} subject
 @property {string} subject_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Customers_Object} customers
 */
/**
 @typedef {Object.<any>} Av_Center
 @property {Av_Center_Properties} properties
 @property {Av_Center_Has} has
 @property {Av_Center_Is} is
 @property {Av_Center_Object} object
 */
/**
 @typedef {Object.<any>} Av_Center_Properties
 @property {number|int} pkey
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Av_Center_Has
 */
/**
 @typedef {Object.<any>} Av_Center_Is
 */
/**
 @typedef {Object.<any>} Av_Center_Object
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Av_Center_Audit
 @property {Av_Center_Audit_Properties} properties
 @property {Av_Center_Audit_Has} has
 @property {Av_Center_Audit_Is} is
 @property {Av_Center_Audit_Object} object
 */
/**
 @typedef {Object.<any>} Av_Center_Audit_Properties
 @property {text|string} action
 @property {boolean} actor_is_admin
 @property {number|int} actor_user
 @property {number|int} automated_email
 @property {number|int} av_key
 @property {date|string} created
 @property {number|int} customer
 @property {text|string} detail
 @property {text|string} outcome
 @property {number|int} pkey
 @property {text|string} stripe_subscription_id
 @property {number|int} stripe_subscription_renewal_log
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Av_Center_Audit_Has
 */
/**
 @typedef {Object.<any>} Av_Center_Audit_Is
 @property {Automated_Emails_Object} automated_emails
 @property {Av_Keys_Object} av_keys
 @property {Customers_Object} customers
 @property {Stripe_Subscription_Renewal_Logs_Object} stripe_subscription_renewal_logs
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Av_Center_Audit_Object
 @property {?text|string} action
 @property {string} action_error
 @property {?boolean} actor_is_admin
 @property {string} actor_is_admin_error
 @property {?number|int} actor_user
 @property {string} actor_user_error
 @property {?number|int} automated_email
 @property {string} automated_email_error
 @property {?number|int} av_key
 @property {string} av_key_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} detail
 @property {string} detail_error
 @property {?text|string} outcome
 @property {string} outcome_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} stripe_subscription_id
 @property {string} stripe_subscription_id_error
 @property {?number|int} stripe_subscription_renewal_log
 @property {string} stripe_subscription_renewal_log_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Automated_Emails_Object} automated_emails
 @property {Av_Keys_Object} av_keys
 @property {Customers_Object} customers
 @property {Stripe_Subscription_Renewal_Logs_Object} stripe_subscription_renewal_logs
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Av_Keys
 @property {Av_Keys_Properties} properties
 @property {Av_Keys_Has} has
 @property {Av_Keys_Is} is
 @property {Av_Keys_Object} object
 */
/**
 @typedef {Object.<any>} Av_Keys_Properties
 @property {text|string} activation_key
 @property {number|int} customer
 @property {date|string} email_sent
 @property {text|string} email_to
 @property {date|string} expiration_date
 @property {text|string} license_code
 @property {text|string} order_number
 @property {number|int} pkey
 @property {text|string} product_name
 @property {date|string} purchase_date
 @property {date|string} sold_date
 @property {text|string} stripe_renewal_invoice_id
 @property {text|string} stripe_subscription_id
 @property {boolean} used
 @property {number|int} user_who_sold
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Av_Keys_Has
 */
/**
 @typedef {Object.<any>} Av_Keys_Is
 @property {Customers_Object} customers
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Av_Keys_Object
 @property {?text|string} activation_key
 @property {string} activation_key_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?date|string} email_sent
 @property {string} email_sent_error
 @property {?text|string} email_to
 @property {string} email_to_error
 @property {?date|string} expiration_date
 @property {string} expiration_date_error
 @property {?text|string} license_code
 @property {string} license_code_error
 @property {?text|string} order_number
 @property {string} order_number_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} product_name
 @property {string} product_name_error
 @property {?date|string} purchase_date
 @property {string} purchase_date_error
 @property {?date|string} sold_date
 @property {string} sold_date_error
 @property {?text|string} stripe_renewal_invoice_id
 @property {string} stripe_renewal_invoice_id_error
 @property {?text|string} stripe_subscription_id
 @property {string} stripe_subscription_id_error
 @property {?boolean} used
 @property {string} used_error
 @property {?number|int} user_who_sold
 @property {string} user_who_sold_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Customers_Object} customers
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Av_Links
 @property {Av_Links_Properties} properties
 @property {Av_Links_Has} has
 @property {Av_Links_Is} is
 @property {Av_Links_Object} object
 */
/**
 @typedef {Object.<any>} Av_Links_Properties
 @property {number|int} av_fkey
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} link
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 @property {number|int} av_pkey
 @property {number|int} customer
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Av_Links_Has
 */
/**
 @typedef {Object.<any>} Av_Links_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Av_Links_Object
 @property {?number|int} av_fkey
 @property {string} av_fkey_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} link
 @property {string} link_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} av_pkey
 @property {string} av_pkey_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Av_Upcoming_Renewals
 @property {Av_Upcoming_Renewals_Properties} properties
 @property {Av_Upcoming_Renewals_Has} has
 @property {Av_Upcoming_Renewals_Is} is
 @property {Av_Upcoming_Renewals_Object} object
 */
/**
 @typedef {Object.<any>} Av_Upcoming_Renewals_Properties
 @property {number|int} av_key
 @property {boolean} cancel_at_period_end
 @property {boolean} contacted
 @property {date|string} contacted_at
 @property {number|int} contacted_by
 @property {number|int} customer
 @property {number|int} days_to_expire
 @property {date|string} last_synced
 @property {text|string} outreach_notes
 @property {date|string} period_end
 @property {number|int} pkey
 @property {text|string} product_name
 @property {text|string} product_type
 @property {number|int} stripe_charge
 @property {text|string} stripe_customer_id
 @property {text|string} stripe_status
 @property {text|string} stripe_subscription_id
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Av_Upcoming_Renewals_Has
 */
/**
 @typedef {Object.<any>} Av_Upcoming_Renewals_Is
 @property {Av_Keys_Object} av_keys
 @property {Customers_Object} customers
 @property {Stripe_Charges_Object} stripe_charges
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Av_Upcoming_Renewals_Object
 @property {?number|int} av_key
 @property {string} av_key_error
 @property {?boolean} cancel_at_period_end
 @property {string} cancel_at_period_end_error
 @property {?boolean} contacted
 @property {string} contacted_error
 @property {?date|string} contacted_at
 @property {string} contacted_at_error
 @property {?number|int} contacted_by
 @property {string} contacted_by_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?number|int} days_to_expire
 @property {string} days_to_expire_error
 @property {?date|string} last_synced
 @property {string} last_synced_error
 @property {?text|string} outreach_notes
 @property {string} outreach_notes_error
 @property {?date|string} period_end
 @property {string} period_end_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} product_name
 @property {string} product_name_error
 @property {?text|string} product_type
 @property {string} product_type_error
 @property {?number|int} stripe_charge
 @property {string} stripe_charge_error
 @property {?text|string} stripe_customer_id
 @property {string} stripe_customer_id_error
 @property {?text|string} stripe_status
 @property {string} stripe_status_error
 @property {?text|string} stripe_subscription_id
 @property {string} stripe_subscription_id_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Av_Keys_Object} av_keys
 @property {Customers_Object} customers
 @property {Stripe_Charges_Object} stripe_charges
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Business_Cards
 @property {Business_Cards_Properties} properties
 @property {Business_Cards_Has} has
 @property {Business_Cards_Is} is
 @property {Business_Cards_Object} object
 */
/**
 @typedef {Object.<any>} Business_Cards_Properties
 @property {boolean} approved
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} notes
 @property {number|int} pkey
 @property {text|string} requested_address
 @property {boolean} sent
 @property {text|string} city
 @property {text|string} current_address
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 @property {text|string} state
 @property {text|string} status
 @property {text|string} street_1
 @property {text|string} zip
 */
/**
 @typedef {Object.<any>} Business_Cards_Has
 */
/**
 @typedef {Object.<any>} Business_Cards_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Business_Cards_Object
 @property {?boolean} approved
 @property {string} approved_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} requested_address
 @property {string} requested_address_error
 @property {?boolean} sent
 @property {string} sent_error
 @property {?text|string} city
 @property {string} city_error
 @property {?text|string} current_address
 @property {string} current_address_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} status
 @property {string} status_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Calendar
 @property {Calendar_Properties} properties
 @property {Calendar_Has} has
 @property {Calendar_Is} is
 @property {Calendar_Object} object
 */
/**
 @typedef {Object.<any>} Calendar_Properties
 @property {number|int} actionable_calendar
 @property {boolean} allDay
 @property {boolean} block
 @property {text|string} color
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} description
 @property {date|string} end
 @property {number|int} field_engineer
 @property {text|string} location_override_coords
 @property {text|string} map_address
 @property {boolean} mapped
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 @property {date|string} start
 @property {number|int} temp_fifth_calendar
 @property {number|int} ticket
 @property {text|string} time_slot
 @property {text|string} title
 @property {boolean} actionable
 @property {boolean} actioned
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 @property {boolean} temp_fifth
 */
/**
 @typedef {Object.<any>} Calendar_Has
 */
/**
 @typedef {Object.<any>} Calendar_Is
 @property {Actionable_Calendars_Object} actionable_calendars
 @property {Temp_Fifth_Days_Object} temp_fifth_days
 @property {Tickets_Object} tickets
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Calendar_Object
 @property {?number|int} actionable_calendar
 @property {string} actionable_calendar_error
 @property {?boolean} allDay
 @property {string} allDay_error
 @property {?boolean} block
 @property {string} block_error
 @property {?text|string} color
 @property {string} color_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} description
 @property {string} description_error
 @property {?date|string} end
 @property {string} end_error
 @property {?number|int} field_engineer
 @property {string} field_engineer_error
 @property {?text|string} location_override_coords
 @property {string} location_override_coords_error
 @property {?text|string} map_address
 @property {string} map_address_error
 @property {?boolean} mapped
 @property {string} mapped_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?date|string} start
 @property {string} start_error
 @property {?number|int} temp_fifth_calendar
 @property {string} temp_fifth_calendar_error
 @property {?number|int} ticket
 @property {string} ticket_error
 @property {?text|string} time_slot
 @property {string} time_slot_error
 @property {?text|string} title
 @property {string} title_error
 @property {?boolean} actionable
 @property {string} actionable_error
 @property {?boolean} actioned
 @property {string} actioned_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {?boolean} temp_fifth
 @property {string} temp_fifth_error
 @property {Actionable_Calendars_Object} actionable_calendars
 @property {Temp_Fifth_Days_Object} temp_fifth_days
 @property {Tickets_Object} tickets
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Calendar_Alerts
 @property {Calendar_Alerts_Properties} properties
 @property {Calendar_Alerts_Has} has
 @property {Calendar_Alerts_Is} is
 @property {Calendar_Alerts_Object} object
 */
/**
 @typedef {Object.<any>} Calendar_Alerts_Properties
 @property {number|int} alert_status
 @property {number|int} calendars
 @property {number|int} field_engineer
 @property {number|int} pkey
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Calendar_Alerts_Has
 */
/**
 @typedef {Object.<any>} Calendar_Alerts_Is
 @property {Calendar_Object} calendar
 @property {Calendar_Alert_Status_Object} calendar_alert_status
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Calendar_Alerts_Object
 @property {?number|int} alert_status
 @property {string} alert_status_error
 @property {?number|int} calendars
 @property {string} calendars_error
 @property {?number|int} field_engineer
 @property {string} field_engineer_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Calendar_Object} calendar
 @property {Calendar_Alert_Status_Object} calendar_alert_status
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Calendar_Help_Desk_Checked
 @property {Calendar_Help_Desk_Checked_Properties} properties
 @property {Calendar_Help_Desk_Checked_Has} has
 @property {Calendar_Help_Desk_Checked_Is} is
 @property {Calendar_Help_Desk_Checked_Object} object
 */
/**
 @typedef {Object.<any>} Calendar_Help_Desk_Checked_Properties
 @property {number|int} calendars
 @property {boolean} checked
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Calendar_Help_Desk_Checked_Has
 */
/**
 @typedef {Object.<any>} Calendar_Help_Desk_Checked_Is
 @property {Calendar_Object} calendar
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Calendar_Help_Desk_Checked_Object
 @property {?number|int} calendars
 @property {string} calendars_error
 @property {?boolean} checked
 @property {string} checked_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Calendar_Object} calendar
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Calendar_Help_Desk_Notes
 @property {Calendar_Help_Desk_Notes_Properties} properties
 @property {Calendar_Help_Desk_Notes_Has} has
 @property {Calendar_Help_Desk_Notes_Is} is
 @property {Calendar_Help_Desk_Notes_Object} object
 */
/**
 @typedef {Object.<any>} Calendar_Help_Desk_Notes_Properties
 @property {boolean} acknowledged
 @property {number|int} calendars
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} notes
 @property {number|int} pkey
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Calendar_Help_Desk_Notes_Has
 */
/**
 @typedef {Object.<any>} Calendar_Help_Desk_Notes_Is
 @property {Calendar_Object} calendar
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Calendar_Help_Desk_Notes_Object
 @property {?boolean} acknowledged
 @property {string} acknowledged_error
 @property {?number|int} calendars
 @property {string} calendars_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Calendar_Object} calendar
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Calendar_Logs
 @property {Calendar_Logs_Properties} properties
 @property {Calendar_Logs_Has} has
 @property {Calendar_Logs_Is} is
 @property {Calendar_Logs_Object} object
 */
/**
 @typedef {Object.<any>} Calendar_Logs_Properties
 @property {number|int} calendars
 @property {date|string} date
 @property {text|string} display_new
 @property {text|string} display_original
 @property {text|string} field
 @property {text|string} note
 @property {number|int} pkey
 @property {number|int} user
 @property {text|string} value_new
 @property {text|string} value_original
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Calendar_Logs_Has
 */
/**
 @typedef {Object.<any>} Calendar_Logs_Is
 @property {Calendar_Object} calendar
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Calendar_Logs_Object
 @property {?number|int} calendars
 @property {string} calendars_error
 @property {?date|string} date
 @property {string} date_error
 @property {?text|string} display_new
 @property {string} display_new_error
 @property {?text|string} display_original
 @property {string} display_original_error
 @property {?text|string} field
 @property {string} field_error
 @property {?text|string} note
 @property {string} note_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} value_new
 @property {string} value_new_error
 @property {?text|string} value_original
 @property {string} value_original_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Calendar_Object} calendar
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Calendar_Resources
 @property {Calendar_Resources_Properties} properties
 @property {Calendar_Resources_Has} has
 @property {Calendar_Resources_Is} is
 @property {Calendar_Resources_Object} object
 */
/**
 @typedef {Object.<any>} Calendar_Resources_Properties
 @property {boolean} active
 @property {boolean} calendarException
 @property {text|string} city
 @property {boolean} deep_sleep
 @property {number|int} driving_count
 @property {text|string} eventColor
 @property {number|int} fe_work_order_amount
 @property {date|string} last_day_working
 @property {text|string} last_status
 @property {text|string} latitude
 @property {text|string} longitude
 @property {number|int} main_role
 @property {number|int} most_recent_ticket_type
 @property {number|int} offsite_count
 @property {date|string} onboarding_date
 @property {number|int} onsite_count
 @property {number|int} pkey
 @property {number|int} region
 @property {text|string} resourceId
 @property {text|string} resourceTitle
 @property {text|string} state
 @property {text|string} street_1
 @property {text|string} temp_fifth
 @property {number|int} total_count
 @property {number|int} total_tickets
 @property {text|string} workingDays
 @property {text|string} zip
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Calendar_Resources_Has
 */
/**
 @typedef {Object.<any>} Calendar_Resources_Is
 @property {Regions_Object} regions
 */
/**
 @typedef {Object.<any>} Calendar_Resources_Object
 @property {?boolean} active
 @property {string} active_error
 @property {?boolean} calendarException
 @property {string} calendarException_error
 @property {?text|string} city
 @property {string} city_error
 @property {?boolean} deep_sleep
 @property {string} deep_sleep_error
 @property {?number|int} driving_count
 @property {string} driving_count_error
 @property {?text|string} eventColor
 @property {string} eventColor_error
 @property {?number|int} fe_work_order_amount
 @property {string} fe_work_order_amount_error
 @property {?date|string} last_day_working
 @property {string} last_day_working_error
 @property {?text|string} last_status
 @property {string} last_status_error
 @property {?text|string} latitude
 @property {string} latitude_error
 @property {?text|string} longitude
 @property {string} longitude_error
 @property {?number|int} main_role
 @property {string} main_role_error
 @property {?number|int} most_recent_ticket_type
 @property {string} most_recent_ticket_type_error
 @property {?number|int} offsite_count
 @property {string} offsite_count_error
 @property {?date|string} onboarding_date
 @property {string} onboarding_date_error
 @property {?number|int} onsite_count
 @property {string} onsite_count_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} region
 @property {string} region_error
 @property {?text|string} resourceId
 @property {string} resourceId_error
 @property {?text|string} resourceTitle
 @property {string} resourceTitle_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} temp_fifth
 @property {string} temp_fifth_error
 @property {?number|int} total_count
 @property {string} total_count_error
 @property {?number|int} total_tickets
 @property {string} total_tickets_error
 @property {?text|string} workingDays
 @property {string} workingDays_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Regions_Object} regions
 */
/**
 @typedef {Object.<any>} Call_Types
 @property {Call_Types_Properties} properties
 @property {Call_Types_Has} has
 @property {Call_Types_Is} is
 @property {Call_Types_Object} object
 */
/**
 @typedef {Object.<any>} Call_Types_Properties
 @property {number|int} pkey
 @property {text|string} type
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Call_Types_Has
 */
/**
 @typedef {Object.<any>} Call_Types_Is
 */
/**
 @typedef {Object.<any>} Call_Types_Object
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} type
 @property {string} type_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Candidate_Statuses
 @property {Candidate_Statuses_Properties} properties
 @property {Candidate_Statuses_Has} has
 @property {Candidate_Statuses_Is} is
 @property {Candidate_Statuses_Object} object
 */
/**
 @typedef {Object.<any>} Candidate_Statuses_Properties
 @property {text|string} name
 @property {number|int} pkey
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Candidate_Statuses_Has
 */
/**
 @typedef {Object.<any>} Candidate_Statuses_Is
 */
/**
 @typedef {Object.<any>} Candidate_Statuses_Object
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Candidates_Notes
 @property {Candidates_Notes_Properties} properties
 @property {Candidates_Notes_Has} has
 @property {Candidates_Notes_Is} is
 @property {Candidates_Notes_Object} object
 */
/**
 @typedef {Object.<any>} Candidates_Notes_Properties
 @property {number|int} candidate
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} note
 @property {number|int} pkey
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Candidates_Notes_Has
 */
/**
 @typedef {Object.<any>} Candidates_Notes_Is
 @property {Candidates_Object} candidates
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Candidates_Notes_Object
 @property {?number|int} candidate
 @property {string} candidate_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} note
 @property {string} note_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Candidates_Object} candidates
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Carbonite_Sales
 @property {Carbonite_Sales_Properties} properties
 @property {Carbonite_Sales_Has} has
 @property {Carbonite_Sales_Is} is
 @property {Carbonite_Sales_Object} object
 */
/**
 @typedef {Object.<any>} Carbonite_Sales_Properties
 @property {text|string} email
 @property {number|int} field_engineer
 @property {text|string} fresh_ticket
 @property {number|int} pkey
 @property {number|int|float} price
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Carbonite_Sales_Has
 */
/**
 @typedef {Object.<any>} Carbonite_Sales_Is
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Carbonite_Sales_Object
 @property {?text|string} email
 @property {string} email_error
 @property {?number|int} field_engineer
 @property {string} field_engineer_error
 @property {?text|string} fresh_ticket
 @property {string} fresh_ticket_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} price
 @property {string} price_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Carriers
 @property {Carriers_Properties} properties
 @property {Carriers_Has} has
 @property {Carriers_Is} is
 @property {Carriers_Object} object
 */
/**
 @typedef {Object.<any>} Carriers_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} domain
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int} pkey
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Carriers_Has
 */
/**
 @typedef {Object.<any>} Carriers_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Carriers_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} domain
 @property {string} domain_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Categories
 @property {Categories_Properties} properties
 @property {Categories_Has} has
 @property {Categories_Is} is
 @property {Categories_Object} object
 */
/**
 @typedef {Object.<any>} Categories_Properties
 @property {text|string} name
 @property {number|int} pkey
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Categories_Has
 */
/**
 @typedef {Object.<any>} Categories_Is
 */
/**
 @typedef {Object.<any>} Categories_Object
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Categories_Subs
 @property {Categories_Subs_Properties} properties
 @property {Categories_Subs_Has} has
 @property {Categories_Subs_Is} is
 @property {Categories_Subs_Object} object
 */
/**
 @typedef {Object.<any>} Categories_Subs_Properties
 @property {number|int} category
 @property {text|string} name
 @property {number|int} pkey
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Categories_Subs_Has
 */
/**
 @typedef {Object.<any>} Categories_Subs_Is
 @property {Categories_Object} categories
 */
/**
 @typedef {Object.<any>} Categories_Subs_Object
 @property {?number|int} category
 @property {string} category_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Categories_Object} categories
 */
/**
 @typedef {Object.<any>} Copyables
 @property {Copyables_Properties} properties
 @property {Copyables_Has} has
 @property {Copyables_Is} is
 @property {Copyables_Object} object
 */
/**
 @typedef {Object.<any>} Copyables_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} information
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 @property {number|int} region
 @property {text|string} title
 @property {text|string} user_accesses
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Copyables_Has
 */
/**
 @typedef {Object.<any>} Copyables_Is
 @property {Regions_Object} regions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Copyables_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} information
 @property {string} information_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} region
 @property {string} region_error
 @property {?text|string} title
 @property {string} title_error
 @property {?text|string} user_accesses
 @property {string} user_accesses_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Regions_Object} regions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Count_Variables
 @property {Count_Variables_Properties} properties
 @property {Count_Variables_Has} has
 @property {Count_Variables_Is} is
 @property {Count_Variables_Object} object
 */
/**
 @typedef {Object.<any>} Count_Variables_Properties
 @property {number|int} amount
 @property {text|string} json
 @property {text|string} name
 @property {number|int} pkey
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Count_Variables_Has
 */
/**
 @typedef {Object.<any>} Count_Variables_Is
 */
/**
 @typedef {Object.<any>} Count_Variables_Object
 @property {?number|int} amount
 @property {string} amount_error
 @property {?text|string} json
 @property {string} json_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Customers
 @property {Customers_Properties} properties
 @property {Customers_Has} has
 @property {Customers_Is} is
 @property {Customers_Object} object
 */
/**
 @typedef {Object.<any>} Customers_Properties
 @property {boolean} blacklisted
 @property {date|string} blacklisted_date
 @property {string} blacklisted_reason
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} email
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {string} notes
 @property {text|string} phone
 @property {text|string} phone_alt
 @property {number|int} pkey
 @property {text|string} referer
 @property {text|string} stripe_id
 @property {boolean} web10
 @property {number|int} web10_ticket
 @property {text|string} city
 @property {number|int|float} latitude
 @property {number|int|float} longitude
 @property {text|string} name
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 @property {text|string} phone
 @property {text|string} point_of_contact
 @property {number|int} region
 @property {text|string} state
 @property {text|string} street_1
 @property {text|string} zip
 */
/**
 @typedef {Object.<any>} Customers_Has
 @property {Customers_Locations_Object[]} customers_locationss
 */
/**
 @typedef {Object.<any>} Customers_Is
 @property {Regions_Object} regions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Customers_Object
 @property {?boolean} blacklisted
 @property {string} blacklisted_error
 @property {?date|string} blacklisted_date
 @property {string} blacklisted_date_error
 @property {?string} blacklisted_reason
 @property {string} blacklisted_reason_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} email
 @property {string} email_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?string} notes
 @property {string} notes_error
 @property {?text|string} phone
 @property {string} phone_error
 @property {?text|string} phone_alt
 @property {string} phone_alt_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} referer
 @property {string} referer_error
 @property {?text|string} stripe_id
 @property {string} stripe_id_error
 @property {?boolean} web10
 @property {string} web10_error
 @property {?number|int} web10_ticket
 @property {string} web10_ticket_error
 @property {?text|string} city
 @property {string} city_error
 @property {?number|int|float} latitude
 @property {string} latitude_error
 @property {?number|int|float} longitude
 @property {string} longitude_error
 @property {?text|string} name
 @property {string} name_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {?text|string} phone
 @property {string} phone_error
 @property {?text|string} point_of_contact
 @property {string} point_of_contact_error
 @property {?number|int} region
 @property {string} region_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {Customers_Locations_Object[]} customers_locationss
 @property {Regions_Object} regions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Customers_Changes
 @property {Customers_Changes_Properties} properties
 @property {Customers_Changes_Has} has
 @property {Customers_Changes_Is} is
 @property {Customers_Changes_Object} object
 */
/**
 @typedef {Object.<any>} Customers_Changes_Properties
 @property {boolean} blacklisted
 @property {number|int} customer
 @property {text|string} email
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {string} notes
 @property {text|string} phone
 @property {text|string} phone_alt
 @property {number|int} pkey
 @property {text|string} referer
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Customers_Changes_Has
 */
/**
 @typedef {Object.<any>} Customers_Changes_Is
 @property {Customers_Object} customers
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Customers_Changes_Object
 @property {?boolean} blacklisted
 @property {string} blacklisted_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} email
 @property {string} email_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?string} notes
 @property {string} notes_error
 @property {?text|string} phone
 @property {string} phone_error
 @property {?text|string} phone_alt
 @property {string} phone_alt_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} referer
 @property {string} referer_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Customers_Object} customers
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Customers_Locations
 @property {Customers_Locations_Properties} properties
 @property {Customers_Locations_Has} has
 @property {Customers_Locations_Is} is
 @property {Customers_Locations_Object} object
 */
/**
 @typedef {Object.<any>} Customers_Locations_Properties
 @property {text|string} city
 @property {date|string} created
 @property {number|int} creator
 @property {number|int} customer
 @property {boolean} inactive
 @property {date|string} inactive_date
 @property {number|int|float} latitude
 @property {number|int|float} longitude
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {text|string} phone
 @property {number|int} pkey
 @property {text|string} point_of_contact
 @property {number|int} region
 @property {text|string} state
 @property {text|string} street_1
 @property {text|string} zip
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Customers_Locations_Has
 */
/**
 @typedef {Object.<any>} Customers_Locations_Is
 @property {Customers_Object} customers
 @property {Regions_Object} regions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Customers_Locations_Object
 @property {?text|string} city
 @property {string} city_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?boolean} inactive
 @property {string} inactive_error
 @property {?date|string} inactive_date
 @property {string} inactive_date_error
 @property {?number|int|float} latitude
 @property {string} latitude_error
 @property {?number|int|float} longitude
 @property {string} longitude_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?text|string} phone
 @property {string} phone_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} point_of_contact
 @property {string} point_of_contact_error
 @property {?number|int} region
 @property {string} region_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Customers_Object} customers
 @property {Regions_Object} regions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Customers_Locations_Logs
 @property {Customers_Locations_Logs_Properties} properties
 @property {Customers_Locations_Logs_Has} has
 @property {Customers_Locations_Logs_Is} is
 @property {Customers_Locations_Logs_Object} object
 */
/**
 @typedef {Object.<any>} Customers_Locations_Logs_Properties
 @property {number|int} customer
 @property {date|string} date
 @property {text|string} field
 @property {number|int} location
 @property {text|string} note
 @property {number|int} pkey
 @property {number|int} user
 @property {text|string} value_new
 @property {text|string} value_original
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Customers_Locations_Logs_Has
 */
/**
 @typedef {Object.<any>} Customers_Locations_Logs_Is
 @property {Customers_Object} customers
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Customers_Locations_Logs_Object
 @property {?number|int} customer
 @property {string} customer_error
 @property {?date|string} date
 @property {string} date_error
 @property {?text|string} field
 @property {string} field_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} note
 @property {string} note_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} value_new
 @property {string} value_new_error
 @property {?text|string} value_original
 @property {string} value_original_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Customers_Object} customers
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Customers_Logs
 @property {Customers_Logs_Properties} properties
 @property {Customers_Logs_Has} has
 @property {Customers_Logs_Is} is
 @property {Customers_Logs_Object} object
 */
/**
 @typedef {Object.<any>} Customers_Logs_Properties
 @property {number|int} customer
 @property {date|string} date
 @property {text|string} field
 @property {text|string} note
 @property {number|int} pkey
 @property {number|int} user
 @property {text|string} value_new
 @property {text|string} value_original
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Customers_Logs_Has
 */
/**
 @typedef {Object.<any>} Customers_Logs_Is
 @property {Customers_Object} customers
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Customers_Logs_Object
 @property {?number|int} customer
 @property {string} customer_error
 @property {?date|string} date
 @property {string} date_error
 @property {?text|string} field
 @property {string} field_error
 @property {?text|string} note
 @property {string} note_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} value_new
 @property {string} value_new_error
 @property {?text|string} value_original
 @property {string} value_original_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Customers_Object} customers
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Department_Overrides
 @property {Department_Overrides_Properties} properties
 @property {Department_Overrides_Has} has
 @property {Department_Overrides_Is} is
 @property {Department_Overrides_Object} object
 */
/**
 @typedef {Object.<any>} Department_Overrides_Properties
 @property {number|int} pkey
 @property {text|string} role_name
 @property {number|int} user
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Department_Overrides_Has
 */
/**
 @typedef {Object.<any>} Department_Overrides_Is
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Department_Overrides_Object
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} role_name
 @property {string} role_name_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Dispatch
 @property {Dispatch_Properties} properties
 @property {Dispatch_Has} has
 @property {Dispatch_Is} is
 @property {Dispatch_Object} object
 */
/**
 @typedef {Object.<any>} Dispatch_Properties
 @property {number|int} pkey
 @property {number|int} user
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Dispatch_Has
 */
/**
 @typedef {Object.<any>} Dispatch_Is
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Dispatch_Object
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Dispatch_Calendars
 @property {Dispatch_Calendars_Properties} properties
 @property {Dispatch_Calendars_Has} has
 @property {Dispatch_Calendars_Is} is
 @property {Dispatch_Calendars_Object} object
 */
/**
 @typedef {Object.<any>} Dispatch_Calendars_Properties
 @property {text|string} days
 @property {number|int} dispatcher
 @property {number|int} pkey
 @property {text|string} time
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Dispatch_Calendars_Has
 */
/**
 @typedef {Object.<any>} Dispatch_Calendars_Is
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Dispatch_Calendars_Object
 @property {?text|string} days
 @property {string} days_error
 @property {?number|int} dispatcher
 @property {string} dispatcher_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} time
 @property {string} time_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Dispatch_Daily_Workflow
 @property {Dispatch_Daily_Workflow_Properties} properties
 @property {Dispatch_Daily_Workflow_Has} has
 @property {Dispatch_Daily_Workflow_Is} is
 @property {Dispatch_Daily_Workflow_Object} object
 */
/**
 @typedef {Object.<any>} Dispatch_Daily_Workflow_Properties
 @property {text|string} activity
 @property {date|string} activity_time
 @property {number|int} pkey
 @property {number|int} user
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Dispatch_Daily_Workflow_Has
 */
/**
 @typedef {Object.<any>} Dispatch_Daily_Workflow_Is
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Dispatch_Daily_Workflow_Object
 @property {?text|string} activity
 @property {string} activity_error
 @property {?date|string} activity_time
 @property {string} activity_time_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Dispatch_Scores
 @property {Dispatch_Scores_Properties} properties
 @property {Dispatch_Scores_Has} has
 @property {Dispatch_Scores_Is} is
 @property {Dispatch_Scores_Object} object
 */
/**
 @typedef {Object.<any>} Dispatch_Scores_Properties
 @property {number|int|float} book_percentage
 @property {number|int} calls_per_hour
 @property {date|string} created
 @property {number|int} pkey
 @property {number|int|float} total_score
 @property {number|int} user
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Dispatch_Scores_Has
 */
/**
 @typedef {Object.<any>} Dispatch_Scores_Is
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Dispatch_Scores_Object
 @property {?number|int|float} book_percentage
 @property {string} book_percentage_error
 @property {?number|int} calls_per_hour
 @property {string} calls_per_hour_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} total_score
 @property {string} total_score_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Engineer_Scores
 @property {Engineer_Scores_Properties} properties
 @property {Engineer_Scores_Has} has
 @property {Engineer_Scores_Is} is
 @property {Engineer_Scores_Object} object
 */
/**
 @typedef {Object.<any>} Engineer_Scores_Properties
 @property {number|int} av_chars
 @property {number|int} av_images
 @property {number|int|float} av_score
 @property {number|int} backup_chars
 @property {number|int} backup_images
 @property {number|int|float} backup_score
 @property {date|string} created
 @property {number|int} generic_chars
 @property {number|int} generic_images
 @property {number|int|float} generic_score
 @property {number|int} hdd_chars
 @property {number|int} hdd_images
 @property {number|int|float} hdd_score
 @property {number|int} network_chars
 @property {number|int} network_images
 @property {number|int|float} network_score
 @property {number|int} notes_chars
 @property {number|int} notes_images
 @property {number|int|float} notes_score
 @property {number|int} pkey
 @property {boolean} skip_calc
 @property {number|int} tasks_amount
 @property {number|int} tasks_comp_chars
 @property {number|int} tasks_desc_chars
 @property {number|int|float} tasks_score
 @property {number|int} ticket
 @property {number|int|float} time_score
 @property {number|int|float} time_value
 @property {number|int|float} total_score
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Engineer_Scores_Has
 */
/**
 @typedef {Object.<any>} Engineer_Scores_Is
 @property {Tickets_Object} tickets
 */
/**
 @typedef {Object.<any>} Engineer_Scores_Object
 @property {?number|int} av_chars
 @property {string} av_chars_error
 @property {?number|int} av_images
 @property {string} av_images_error
 @property {?number|int|float} av_score
 @property {string} av_score_error
 @property {?number|int} backup_chars
 @property {string} backup_chars_error
 @property {?number|int} backup_images
 @property {string} backup_images_error
 @property {?number|int|float} backup_score
 @property {string} backup_score_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} generic_chars
 @property {string} generic_chars_error
 @property {?number|int} generic_images
 @property {string} generic_images_error
 @property {?number|int|float} generic_score
 @property {string} generic_score_error
 @property {?number|int} hdd_chars
 @property {string} hdd_chars_error
 @property {?number|int} hdd_images
 @property {string} hdd_images_error
 @property {?number|int|float} hdd_score
 @property {string} hdd_score_error
 @property {?number|int} network_chars
 @property {string} network_chars_error
 @property {?number|int} network_images
 @property {string} network_images_error
 @property {?number|int|float} network_score
 @property {string} network_score_error
 @property {?number|int} notes_chars
 @property {string} notes_chars_error
 @property {?number|int} notes_images
 @property {string} notes_images_error
 @property {?number|int|float} notes_score
 @property {string} notes_score_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?boolean} skip_calc
 @property {string} skip_calc_error
 @property {?number|int} tasks_amount
 @property {string} tasks_amount_error
 @property {?number|int} tasks_comp_chars
 @property {string} tasks_comp_chars_error
 @property {?number|int} tasks_desc_chars
 @property {string} tasks_desc_chars_error
 @property {?number|int|float} tasks_score
 @property {string} tasks_score_error
 @property {?number|int} ticket
 @property {string} ticket_error
 @property {?number|int|float} time_score
 @property {string} time_score_error
 @property {?number|int|float} time_value
 @property {string} time_value_error
 @property {?number|int|float} total_score
 @property {string} total_score_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Tickets_Object} tickets
 */
/**
 @typedef {Object.<any>} Engineer_Stats
 @property {Engineer_Stats_Properties} properties
 @property {Engineer_Stats_Has} has
 @property {Engineer_Stats_Is} is
 @property {Engineer_Stats_Object} object
 */
/**
 @typedef {Object.<any>} Engineer_Stats_Properties
 @property {number|int|float} anti_virus_30day
 @property {number|int|float} carbonite_30day
 @property {number|int|float} daily_total
 @property {number|int} pkey
 @property {number|int|float} total_stats_30day
 @property {number|int|float} total_stats_7day
 @property {number|int|float} total_stats_today
 @property {number|int|float} total_stats_yesterday
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Engineer_Stats_Has
 */
/**
 @typedef {Object.<any>} Engineer_Stats_Is
 */
/**
 @typedef {Object.<any>} Engineer_Stats_Object
 @property {?number|int|float} anti_virus_30day
 @property {string} anti_virus_30day_error
 @property {?number|int|float} carbonite_30day
 @property {string} carbonite_30day_error
 @property {?number|int|float} daily_total
 @property {string} daily_total_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} total_stats_30day
 @property {string} total_stats_30day_error
 @property {?number|int|float} total_stats_7day
 @property {string} total_stats_7day_error
 @property {?number|int|float} total_stats_today
 @property {string} total_stats_today_error
 @property {?number|int|float} total_stats_yesterday
 @property {string} total_stats_yesterday_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Engineers_Reviews
 @property {Engineers_Reviews_Properties} properties
 @property {Engineers_Reviews_Has} has
 @property {Engineers_Reviews_Is} is
 @property {Engineers_Reviews_Object} object
 */
/**
 @typedef {Object.<any>} Engineers_Reviews_Properties
 @property {number|int} bb_count
 @property {date|string} created
 @property {number|int} creator
 @property {number|int} engineer
 @property {number|int} facebook_count
 @property {number|int} google_count
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 @property {number|int} total_count
 @property {date|string} week
 @property {number|int} yelp_count
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Engineers_Reviews_Has
 */
/**
 @typedef {Object.<any>} Engineers_Reviews_Is
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Engineers_Reviews_Object
 @property {?number|int} bb_count
 @property {string} bb_count_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int} engineer
 @property {string} engineer_error
 @property {?number|int} facebook_count
 @property {string} facebook_count_error
 @property {?number|int} google_count
 @property {string} google_count_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} total_count
 @property {string} total_count_error
 @property {?date|string} week
 @property {string} week_error
 @property {?number|int} yelp_count
 @property {string} yelp_count_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Engineers_Service_Regions
 @property {Engineers_Service_Regions_Properties} properties
 @property {Engineers_Service_Regions_Has} has
 @property {Engineers_Service_Regions_Is} is
 @property {Engineers_Service_Regions_Object} object
 */
/**
 @typedef {Object.<any>} Engineers_Service_Regions_Properties
 @property {number|int} engineer
 @property {number|int|float} latitude
 @property {number|int|float} longitude
 @property {number|int} pkey
 @property {number|int} radius
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Engineers_Service_Regions_Has
 */
/**
 @typedef {Object.<any>} Engineers_Service_Regions_Is
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Engineers_Service_Regions_Object
 @property {?number|int} engineer
 @property {string} engineer_error
 @property {?number|int|float} latitude
 @property {string} latitude_error
 @property {?number|int|float} longitude
 @property {string} longitude_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} radius
 @property {string} radius_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Engineers_Status
 @property {Engineers_Status_Properties} properties
 @property {Engineers_Status_Has} has
 @property {Engineers_Status_Is} is
 @property {Engineers_Status_Object} object
 */
/**
 @typedef {Object.<any>} Engineers_Status_Properties
 @property {number|int} pkey
 @property {text|string} status
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Engineers_Status_Has
 */
/**
 @typedef {Object.<any>} Engineers_Status_Is
 */
/**
 @typedef {Object.<any>} Engineers_Status_Object
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} status
 @property {string} status_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Engineers_Ticket_Status
 @property {Engineers_Ticket_Status_Properties} properties
 @property {Engineers_Ticket_Status_Has} has
 @property {Engineers_Ticket_Status_Is} is
 @property {Engineers_Ticket_Status_Object} object
 */
/**
 @typedef {Object.<any>} Engineers_Ticket_Status_Properties
 @property {date|string} created
 @property {number|int} engineer
 @property {date|string} occurred_at
 @property {number|int} pkey
 @property {number|int} status
 @property {number|int} ticket
 @property {text|string} current_coords
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Engineers_Ticket_Status_Has
 */
/**
 @typedef {Object.<any>} Engineers_Ticket_Status_Is
 @property {Engineers_Status_Object} engineers_status
 @property {Tickets_Object} tickets
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Engineers_Ticket_Status_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} engineer
 @property {string} engineer_error
 @property {?date|string} occurred_at
 @property {string} occurred_at_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} status
 @property {string} status_error
 @property {?number|int} ticket
 @property {string} ticket_error
 @property {?text|string} current_coords
 @property {string} current_coords_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Engineers_Status_Object} engineers_status
 @property {Tickets_Object} tickets
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Executives
 @property {Executives_Properties} properties
 @property {Executives_Has} has
 @property {Executives_Is} is
 @property {Executives_Object} object
 */
/**
 @typedef {Object.<any>} Executives_Properties
 @property {number|int} pkey
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Executives_Has
 */
/**
 @typedef {Object.<any>} Executives_Is
 */
/**
 @typedef {Object.<any>} Executives_Object
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Fe_Metrics
 @property {Fe_Metrics_Properties} properties
 @property {Fe_Metrics_Has} has
 @property {Fe_Metrics_Is} is
 @property {Fe_Metrics_Object} object
 */
/**
 @typedef {Object.<any>} Fe_Metrics_Properties
 @property {number|int} amount
 @property {text|string} amount_input
 @property {text|string} anchor_date
 @property {text|string} category
 @property {number|int} field_engineer
 @property {text|string} interval_key
 @property {text|string} notes
 @property {text|string} period_end
 @property {text|string} period_start
 @property {number|int} pkey
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Fe_Metrics_Has
 */
/**
 @typedef {Object.<any>} Fe_Metrics_Is
 */
/**
 @typedef {Object.<any>} Fe_Metrics_Object
 @property {?number|int} amount
 @property {string} amount_error
 @property {?text|string} amount_input
 @property {string} amount_input_error
 @property {?text|string} anchor_date
 @property {string} anchor_date_error
 @property {?text|string} category
 @property {string} category_error
 @property {?number|int} field_engineer
 @property {string} field_engineer_error
 @property {?text|string} interval_key
 @property {string} interval_key_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?text|string} period_end
 @property {string} period_end_error
 @property {?text|string} period_start
 @property {string} period_start_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Feedback_Locations
 @property {Feedback_Locations_Properties} properties
 @property {Feedback_Locations_Has} has
 @property {Feedback_Locations_Is} is
 @property {Feedback_Locations_Object} object
 */
/**
 @typedef {Object.<any>} Feedback_Locations_Properties
 @property {text|string} description
 @property {text|string} display
 @property {number|int} feedback_type
 @property {text|string} last_checked
 @property {text|string} last_review
 @property {text|string} last_review_customer
 @property {text|string} last_review_date
 @property {number|int} pkey
 @property {number|int} region
 @property {text|string} sub_header
 @property {text|string} url
 @property {boolean} working
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Feedback_Locations_Has
 */
/**
 @typedef {Object.<any>} Feedback_Locations_Is
 @property {Feedback_Types_Object} feedback_types
 @property {Regions_Object} regions
 */
/**
 @typedef {Object.<any>} Feedback_Locations_Object
 @property {?text|string} description
 @property {string} description_error
 @property {?text|string} display
 @property {string} display_error
 @property {?number|int} feedback_type
 @property {string} feedback_type_error
 @property {?text|string} last_checked
 @property {string} last_checked_error
 @property {?text|string} last_review
 @property {string} last_review_error
 @property {?text|string} last_review_customer
 @property {string} last_review_customer_error
 @property {?text|string} last_review_date
 @property {string} last_review_date_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} region
 @property {string} region_error
 @property {?text|string} sub_header
 @property {string} sub_header_error
 @property {?text|string} url
 @property {string} url_error
 @property {?boolean} working
 @property {string} working_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Feedback_Types_Object} feedback_types
 @property {Regions_Object} regions
 */
/**
 @typedef {Object.<any>} Feedback_Responses
 @property {Feedback_Responses_Properties} properties
 @property {Feedback_Responses_Has} has
 @property {Feedback_Responses_Is} is
 @property {Feedback_Responses_Object} object
 */
/**
 @typedef {Object.<any>} Feedback_Responses_Properties
 @property {date|string} created
 @property {number|int} feedback_link_log
 @property {text|string} message
 @property {number|int} pkey
 @property {number|int} stars_clicked
 @property {number|int} ticket
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Feedback_Responses_Has
 */
/**
 @typedef {Object.<any>} Feedback_Responses_Is
 @property {Feedback_Link_Logs_Object} feedback_link_logs
 @property {Tickets_Object} tickets
 */
/**
 @typedef {Object.<any>} Feedback_Responses_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} feedback_link_log
 @property {string} feedback_link_log_error
 @property {?text|string} message
 @property {string} message_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} stars_clicked
 @property {string} stars_clicked_error
 @property {?number|int} ticket
 @property {string} ticket_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Feedback_Link_Logs_Object} feedback_link_logs
 @property {Tickets_Object} tickets
 */
/**
 @typedef {Object.<any>} Financial_Edits
 @property {Financial_Edits_Properties} properties
 @property {Financial_Edits_Has} has
 @property {Financial_Edits_Is} is
 @property {Financial_Edits_Object} object
 */
/**
 @typedef {Object.<any>} Financial_Edits_Properties
 @property {boolean} approved
 @property {date|string} created
 @property {number|int} creator
 @property {number|int} financial
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} notes
 @property {text|string} original_json
 @property {number|int} pkey
 @property {text|string} requested_json
 @property {number|int} ticket
 @property {text|string} approver
 @property {text|string} customer
 @property {text|string} engineer
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 @property {text|string} status
 */
/**
 @typedef {Object.<any>} Financial_Edits_Has
 */
/**
 @typedef {Object.<any>} Financial_Edits_Is
 @property {Tickets_Object} tickets
 @property {Tickets_Financials_Object} tickets_financials
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Financial_Edits_Object
 @property {?boolean} approved
 @property {string} approved_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int} financial
 @property {string} financial_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?text|string} original_json
 @property {string} original_json_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} requested_json
 @property {string} requested_json_error
 @property {?number|int} ticket
 @property {string} ticket_error
 @property {?text|string} approver
 @property {string} approver_error
 @property {?text|string} customer
 @property {string} customer_error
 @property {?text|string} engineer
 @property {string} engineer_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {?text|string} status
 @property {string} status_error
 @property {Tickets_Object} tickets
 @property {Tickets_Financials_Object} tickets_financials
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Financials
 @property {Financials_Properties} properties
 @property {Financials_Has} has
 @property {Financials_Is} is
 @property {Financials_Object} object
 */
/**
 @typedef {Object.<any>} Financials_Properties
 @property {number|int} base_pay
 @property {boolean} bonus
 @property {number|int} commission
 @property {number|int} feedback
 @property {number|int} gas_credits
 @property {text|string} notes
 @property {number|int} pkey
 @property {number|int} subtractions
 @property {number|int} total_pay
 @property {number|int} user
 @property {array} financial_data
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Financials_Has
 */
/**
 @typedef {Object.<any>} Financials_Is
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Financials_Object
 @property {?number|int} base_pay
 @property {string} base_pay_error
 @property {?boolean} bonus
 @property {string} bonus_error
 @property {?number|int} commission
 @property {string} commission_error
 @property {?number|int} feedback
 @property {string} feedback_error
 @property {?number|int} gas_credits
 @property {string} gas_credits_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} subtractions
 @property {string} subtractions_error
 @property {?number|int} total_pay
 @property {string} total_pay_error
 @property {?number|int} user
 @property {string} user_error
 @property {?array} financial_data
 @property {string} financial_data_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Financials_Invoice
 @property {Financials_Invoice_Properties} properties
 @property {Financials_Invoice_Has} has
 @property {Financials_Invoice_Is} is
 @property {Financials_Invoice_Object} object
 */
/**
 @typedef {Object.<any>} Financials_Invoice_Properties
 @property {boolean} approved
 @property {number|int|float} base_pay
 @property {boolean} bonus
 @property {number|int|float} commission
 @property {date|string} created
 @property {number|int} creator
 @property {number|int} feedback
 @property {number|int} gas_credits
 @property {number|int|float} hardware
 @property {text|string} hardware_items
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} notes
 @property {number|int} pkey
 @property {boolean} rejected
 @property {text|string} signature
 @property {number|int} total_pay
 @property {number|int} user
 @property {date|string} week_start_date
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 @property {string} signature_data
 */
/**
 @typedef {Object.<any>} Financials_Invoice_Has
 */
/**
 @typedef {Object.<any>} Financials_Invoice_Is
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Financials_Invoice_Object
 @property {?boolean} approved
 @property {string} approved_error
 @property {?number|int|float} base_pay
 @property {string} base_pay_error
 @property {?boolean} bonus
 @property {string} bonus_error
 @property {?number|int|float} commission
 @property {string} commission_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int} feedback
 @property {string} feedback_error
 @property {?number|int} gas_credits
 @property {string} gas_credits_error
 @property {?number|int|float} hardware
 @property {string} hardware_error
 @property {?text|string} hardware_items
 @property {string} hardware_items_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?boolean} rejected
 @property {string} rejected_error
 @property {?text|string} signature
 @property {string} signature_error
 @property {?number|int} total_pay
 @property {string} total_pay_error
 @property {?number|int} user
 @property {string} user_error
 @property {?date|string} week_start_date
 @property {string} week_start_date_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {?string} signature_data
 @property {string} signature_data_error
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Forms
 @property {Forms_Properties} properties
 @property {Forms_Has} has
 @property {Forms_Is} is
 @property {Forms_Object} object
 */
/**
 @typedef {Object.<any>} Forms_Properties
 @property {text|string} file
 @property {text|string} model
 @property {text|string} name
 @property {number|int} pkey
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Forms_Has
 */
/**
 @typedef {Object.<any>} Forms_Is
 */
/**
 @typedef {Object.<any>} Forms_Object
 @property {?text|string} file
 @property {string} file_error
 @property {?text|string} model
 @property {string} model_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Forms_All
 @property {Forms_All_Properties} properties
 @property {Forms_All_Has} has
 @property {Forms_All_Is} is
 @property {Forms_All_Object} object
 */
/**
 @typedef {Object.<any>} Forms_All_Properties
 @property {boolean} active
 @property {date|string} created_date
 @property {number|int} customer
 @property {number|int} form
 @property {number|int} pkey
 @property {string} results
 @property {string} signature
 @property {number|int} ticket
 @property {boolean} active
 @property {text|string} computer
 @property {text|string} date_signed
 @property {text|string} form_name
 @property {text|string} form_pdf
 @property {text|string} items
 @property {text|string} name
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 @property {text|string} password
 @property {text|string} phone
 @property {boolean} warranty
 */
/**
 @typedef {Object.<any>} Forms_All_Has
 @property {Customers_Object[]} customers
 */
/**
 @typedef {Object.<any>} Forms_All_Is
 @property {Customers_Object} customers
 @property {Forms_Object} forms
 @property {Tickets_Object} tickets
 */
/**
 @typedef {Object.<any>} Forms_All_Object
 @property {?boolean} active
 @property {string} active_error
 @property {?date|string} created_date
 @property {string} created_date_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?number|int} form
 @property {string} form_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?string} results
 @property {string} results_error
 @property {?string} signature
 @property {string} signature_error
 @property {?number|int} ticket
 @property {string} ticket_error
 @property {?boolean} active
 @property {string} active_error
 @property {?text|string} computer
 @property {string} computer_error
 @property {?text|string} date_signed
 @property {string} date_signed_error
 @property {?text|string} form_name
 @property {string} form_name_error
 @property {?text|string} form_pdf
 @property {string} form_pdf_error
 @property {?text|string} items
 @property {string} items_error
 @property {?text|string} name
 @property {string} name_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {?text|string} password
 @property {string} password_error
 @property {?text|string} phone
 @property {string} phone_error
 @property {?boolean} warranty
 @property {string} warranty_error
 @property {Customers_Object[]} customers
 @property {Customers_Object} customers
 @property {Forms_Object} forms
 @property {Tickets_Object} tickets
 */
/**
 @typedef {Object.<any>} Forms_Results
 @property {Forms_Results_Properties} properties
 @property {Forms_Results_Has} has
 @property {Forms_Results_Is} is
 @property {Forms_Results_Object} object
 */
/**
 @typedef {Object.<any>} Forms_Results_Properties
 @property {boolean} active
 @property {date|string} created_date
 @property {number|int} customer
 @property {number|int} form
 @property {date|string} occurred_at
 @property {number|int} pkey
 @property {string} results
 @property {string} signature
 @property {number|int} ticket
 @property {text|string} address
 @property {boolean} check
 @property {text|string} date_signed
 @property {email} email
 @property {string} form_results
 @property {text|string} fresh_desk
 @property {text|string} name
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 @property {text|string} phone
 @property {text|string} requestedForm
 */
/**
 @typedef {Object.<any>} Forms_Results_Has
 @property {Customers_Object[]} customers
 */
/**
 @typedef {Object.<any>} Forms_Results_Is
 @property {Customers_Object} customers
 @property {Forms_Object} forms
 @property {Tickets_Object} tickets
 */
/**
 @typedef {Object.<any>} Forms_Results_Object
 @property {?boolean} active
 @property {string} active_error
 @property {?date|string} created_date
 @property {string} created_date_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?number|int} form
 @property {string} form_error
 @property {?date|string} occurred_at
 @property {string} occurred_at_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?string} results
 @property {string} results_error
 @property {?string} signature
 @property {string} signature_error
 @property {?number|int} ticket
 @property {string} ticket_error
 @property {?text|string} address
 @property {string} address_error
 @property {?boolean} check
 @property {string} check_error
 @property {?text|string} date_signed
 @property {string} date_signed_error
 @property {?email} email
 @property {string} email_error
 @property {?string} form_results
 @property {string} form_results_error
 @property {?text|string} fresh_desk
 @property {string} fresh_desk_error
 @property {?text|string} name
 @property {string} name_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {?text|string} phone
 @property {string} phone_error
 @property {?text|string} requestedForm
 @property {string} requestedForm_error
 @property {Customers_Object[]} customers
 @property {Customers_Object} customers
 @property {Forms_Object} forms
 @property {Tickets_Object} tickets
 */
/**
 @typedef {Object.<any>} Freshdesk_Counts
 @property {Freshdesk_Counts_Properties} properties
 @property {Freshdesk_Counts_Has} has
 @property {Freshdesk_Counts_Is} is
 @property {Freshdesk_Counts_Object} object
 */
/**
 @typedef {Object.<any>} Freshdesk_Counts_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {number|int} dispatch_count
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pending_count
 @property {number|int} pkey
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Freshdesk_Counts_Has
 */
/**
 @typedef {Object.<any>} Freshdesk_Counts_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Freshdesk_Counts_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int} dispatch_count
 @property {string} dispatch_count_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pending_count
 @property {string} pending_count_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Freshdesk_Merge_Subjects
 @property {Freshdesk_Merge_Subjects_Properties} properties
 @property {Freshdesk_Merge_Subjects_Has} has
 @property {Freshdesk_Merge_Subjects_Is} is
 @property {Freshdesk_Merge_Subjects_Object} object
 */
/**
 @typedef {Object.<any>} Freshdesk_Merge_Subjects_Properties
 @property {boolean} active
 @property {text|string} pattern
 @property {text|string} phone_parser
 @property {number|int} pkey
 @property {number|int} sort_order
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Freshdesk_Merge_Subjects_Has
 */
/**
 @typedef {Object.<any>} Freshdesk_Merge_Subjects_Is
 */
/**
 @typedef {Object.<any>} Freshdesk_Merge_Subjects_Object
 @property {?boolean} active
 @property {string} active_error
 @property {?text|string} pattern
 @property {string} pattern_error
 @property {?text|string} phone_parser
 @property {string} phone_parser_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} sort_order
 @property {string} sort_order_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Geo_Coords
 @property {Geo_Coords_Properties} properties
 @property {Geo_Coords_Has} has
 @property {Geo_Coords_Is} is
 @property {Geo_Coords_Object} object
 */
/**
 @typedef {Object.<any>} Geo_Coords_Properties
 @property {date|string} created
 @property {number|int|float} latitude
 @property {number|int|float} longitude
 @property {number|int} pkey
 @property {number|int} requester
 @property {number|int} user
 @property {text|string} coords
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Geo_Coords_Has
 */
/**
 @typedef {Object.<any>} Geo_Coords_Is
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Geo_Coords_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int|float} latitude
 @property {string} latitude_error
 @property {?number|int|float} longitude
 @property {string} longitude_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} requester
 @property {string} requester_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} coords
 @property {string} coords_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Help_Desks
 @property {Help_Desks_Properties} properties
 @property {Help_Desks_Has} has
 @property {Help_Desks_Is} is
 @property {Help_Desks_Object} object
 */
/**
 @typedef {Object.<any>} Help_Desks_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} notes
 @property {number|int} pkey
 @property {boolean} resolved
 @property {number|int} ticket
 @property {number|int} user_assigned
 @property {boolean} hasTicket
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Help_Desks_Has
 */
/**
 @typedef {Object.<any>} Help_Desks_Is
 @property {Tickets_Object} tickets
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Help_Desks_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?boolean} resolved
 @property {string} resolved_error
 @property {?number|int} ticket
 @property {string} ticket_error
 @property {?number|int} user_assigned
 @property {string} user_assigned_error
 @property {?boolean} hasTicket
 @property {string} hasTicket_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Tickets_Object} tickets
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Help_Desks_Contacted
 @property {Help_Desks_Contacted_Properties} properties
 @property {Help_Desks_Contacted_Has} has
 @property {Help_Desks_Contacted_Is} is
 @property {Help_Desks_Contacted_Object} object
 */
/**
 @typedef {Object.<any>} Help_Desks_Contacted_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} date_contacted
 @property {number|int} engineer_contacted
 @property {text|string} notes
 @property {number|int} pkey
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Help_Desks_Contacted_Has
 */
/**
 @typedef {Object.<any>} Help_Desks_Contacted_Is
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Help_Desks_Contacted_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} date_contacted
 @property {string} date_contacted_error
 @property {?number|int} engineer_contacted
 @property {string} engineer_contacted_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Helpdesk_Scores
 @property {Helpdesk_Scores_Properties} properties
 @property {Helpdesk_Scores_Has} has
 @property {Helpdesk_Scores_Is} is
 @property {Helpdesk_Scores_Object} object
 */
/**
 @typedef {Object.<any>} Helpdesk_Scores_Properties
 @property {number|int|float} call_note_length
 @property {date|string} created
 @property {number|int} financial_reviewed
 @property {number|int} metro_walk
 @property {number|int|float} note_length
 @property {number|int} phone_calls
 @property {number|int} pkey
 @property {number|int|float} project_notes
 @property {number|int} tickets_generated
 @property {number|int|float} total_score
 @property {number|int} user
 @property {number|int} wo_checked
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Helpdesk_Scores_Has
 */
/**
 @typedef {Object.<any>} Helpdesk_Scores_Is
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Helpdesk_Scores_Object
 @property {?number|int|float} call_note_length
 @property {string} call_note_length_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} financial_reviewed
 @property {string} financial_reviewed_error
 @property {?number|int} metro_walk
 @property {string} metro_walk_error
 @property {?number|int|float} note_length
 @property {string} note_length_error
 @property {?number|int} phone_calls
 @property {string} phone_calls_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} project_notes
 @property {string} project_notes_error
 @property {?number|int} tickets_generated
 @property {string} tickets_generated_error
 @property {?number|int|float} total_score
 @property {string} total_score_error
 @property {?number|int} user
 @property {string} user_error
 @property {?number|int} wo_checked
 @property {string} wo_checked_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Hiring
 @property {Hiring_Properties} properties
 @property {Hiring_Has} has
 @property {Hiring_Is} is
 @property {Hiring_Object} object
 */
/**
 @typedef {Object.<any>} Hiring_Properties
 */
/**
 @typedef {Object.<any>} Hiring_Has
 */
/**
 @typedef {Object.<any>} Hiring_Is
 */
/**
 @typedef {Object.<any>} Hiring_Object
 */
/**
 @typedef {Object.<any>} Hiring_Candidate
 @property {Hiring_Candidate_Properties} properties
 @property {Hiring_Candidate_Has} has
 @property {Hiring_Candidate_Is} is
 @property {Hiring_Candidate_Object} object
 */
/**
 @typedef {Object.<any>} Hiring_Candidate_Properties
 @property {text|string} base_pay
 @property {number|int} candidate_status
 @property {text|string} city
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} email
 @property {boolean} ignored
 @property {date|string} interview_date
 @property {number|int|float} latitude
 @property {number|int|float} longitude
 @property {text|string} name_first
 @property {text|string} name_last
 @property {text|string} name_middle
 @property {text|string} notes
 @property {text|string} phone
 @property {number|int} pkey
 @property {number|int} rating
 @property {number|int} region
 @property {text|string} resume
 @property {text|string} salary
 @property {date|string} start_date
 @property {text|string} state
 @property {date|string} status_changed_on
 @property {text|string} street_1
 @property {text|string} zip
 @property {text|string} new_note
 @property {number|int} next_pkey
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 @property {boolean} user_created
 */
/**
 @typedef {Object.<any>} Hiring_Candidate_Has
 */
/**
 @typedef {Object.<any>} Hiring_Candidate_Is
 @property {Candidate_Statuses_Object} candidate_statuses
 @property {Regions_Object} regions
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Hiring_Candidate_Object
 @property {?text|string} base_pay
 @property {string} base_pay_error
 @property {?number|int} candidate_status
 @property {string} candidate_status_error
 @property {?text|string} city
 @property {string} city_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} email
 @property {string} email_error
 @property {?boolean} ignored
 @property {string} ignored_error
 @property {?date|string} interview_date
 @property {string} interview_date_error
 @property {?number|int|float} latitude
 @property {string} latitude_error
 @property {?number|int|float} longitude
 @property {string} longitude_error
 @property {?text|string} name_first
 @property {string} name_first_error
 @property {?text|string} name_last
 @property {string} name_last_error
 @property {?text|string} name_middle
 @property {string} name_middle_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?text|string} phone
 @property {string} phone_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} rating
 @property {string} rating_error
 @property {?number|int} region
 @property {string} region_error
 @property {?text|string} resume
 @property {string} resume_error
 @property {?text|string} salary
 @property {string} salary_error
 @property {?date|string} start_date
 @property {string} start_date_error
 @property {?text|string} state
 @property {string} state_error
 @property {?date|string} status_changed_on
 @property {string} status_changed_on_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {?text|string} new_note
 @property {string} new_note_error
 @property {?number|int} next_pkey
 @property {string} next_pkey_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {?boolean} user_created
 @property {string} user_created_error
 @property {Candidate_Statuses_Object} candidate_statuses
 @property {Regions_Object} regions
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Hiring_Zone
 @property {Hiring_Zone_Properties} properties
 @property {Hiring_Zone_Has} has
 @property {Hiring_Zone_Is} is
 @property {Hiring_Zone_Object} object
 */
/**
 @typedef {Object.<any>} Hiring_Zone_Properties
 @property {text|string} coords
 @property {text|string} name
 @property {boolean} pause
 @property {number|int} pkey
 @property {number|int} region
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Hiring_Zone_Has
 */
/**
 @typedef {Object.<any>} Hiring_Zone_Is
 @property {Regions_Object} regions
 */
/**
 @typedef {Object.<any>} Hiring_Zone_Object
 @property {?text|string} coords
 @property {string} coords_error
 @property {?text|string} name
 @property {string} name_error
 @property {?boolean} pause
 @property {string} pause_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} region
 @property {string} region_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Regions_Object} regions
 */
/**
 @typedef {Object.<any>} Hiring_Scores
 @property {Hiring_Scores_Properties} properties
 @property {Hiring_Scores_Has} has
 @property {Hiring_Scores_Is} is
 @property {Hiring_Scores_Object} object
 */
/**
 @typedef {Object.<any>} Hiring_Scores_Properties
 @property {date|string} created
 @property {number|int} demotion
 @property {number|int|float} heatmap
 @property {number|int} new_candidate
 @property {number|int|float} notes_length
 @property {number|int} pkey
 @property {number|int|float} project_notes
 @property {number|int} promotion
 @property {number|int|float} search
 @property {number|int|float} total_score
 @property {number|int} user
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Hiring_Scores_Has
 */
/**
 @typedef {Object.<any>} Hiring_Scores_Is
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Hiring_Scores_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} demotion
 @property {string} demotion_error
 @property {?number|int|float} heatmap
 @property {string} heatmap_error
 @property {?number|int} new_candidate
 @property {string} new_candidate_error
 @property {?number|int|float} notes_length
 @property {string} notes_length_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} project_notes
 @property {string} project_notes_error
 @property {?number|int} promotion
 @property {string} promotion_error
 @property {?number|int|float} search
 @property {string} search_error
 @property {?number|int|float} total_score
 @property {string} total_score_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Inactive_Av_Subscriptions
 @property {Inactive_Av_Subscriptions_Properties} properties
 @property {Inactive_Av_Subscriptions_Has} has
 @property {Inactive_Av_Subscriptions_Is} is
 @property {Inactive_Av_Subscriptions_Object} object
 */
/**
 @typedef {Object.<any>} Inactive_Av_Subscriptions_Properties
 @property {boolean} cancel_at_period_end
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} dismissal_reason
 @property {text|string} message
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} notes
 @property {number|int} pkey
 @property {boolean} resolved
 @property {number|int} stripe_charge
 @property {text|string} stripe_status
 @property {text|string} stripe_subscription_id
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Inactive_Av_Subscriptions_Has
 */
/**
 @typedef {Object.<any>} Inactive_Av_Subscriptions_Is
 @property {Stripe_Charges_Object} stripe_charges
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Inactive_Av_Subscriptions_Object
 @property {?boolean} cancel_at_period_end
 @property {string} cancel_at_period_end_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} dismissal_reason
 @property {string} dismissal_reason_error
 @property {?text|string} message
 @property {string} message_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?boolean} resolved
 @property {string} resolved_error
 @property {?number|int} stripe_charge
 @property {string} stripe_charge_error
 @property {?text|string} stripe_status
 @property {string} stripe_status_error
 @property {?text|string} stripe_subscription_id
 @property {string} stripe_subscription_id_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Stripe_Charges_Object} stripe_charges
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Kpi_Metrics
 @property {Kpi_Metrics_Properties} properties
 @property {Kpi_Metrics_Has} has
 @property {Kpi_Metrics_Is} is
 @property {Kpi_Metrics_Object} object
 */
/**
 @typedef {Object.<any>} Kpi_Metrics_Properties
 @property {number|int} daily
 @property {number|int} hourly
 @property {number|int|float} multiplier
 @property {number|int} pkey
 @property {number|int} role
 @property {number|int|float} additional_data
 @property {number|int|float} book_percent_day
 @property {number|int|float} letter_score_day
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 @property {number|int} score_day
 @property {number|int} score_hour
 @property {text|string} user
 */
/**
 @typedef {Object.<any>} Kpi_Metrics_Has
 */
/**
 @typedef {Object.<any>} Kpi_Metrics_Is
 @property {Roles_Object} roles
 */
/**
 @typedef {Object.<any>} Kpi_Metrics_Object
 @property {?number|int} daily
 @property {string} daily_error
 @property {?number|int} hourly
 @property {string} hourly_error
 @property {?number|int|float} multiplier
 @property {string} multiplier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} role
 @property {string} role_error
 @property {?number|int|float} additional_data
 @property {string} additional_data_error
 @property {?number|int|float} book_percent_day
 @property {string} book_percent_day_error
 @property {?number|int|float} letter_score_day
 @property {string} letter_score_day_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {?number|int} score_day
 @property {string} score_day_error
 @property {?number|int} score_hour
 @property {string} score_hour_error
 @property {?text|string} user
 @property {string} user_error
 @property {Roles_Object} roles
 */
/**
 @typedef {Object.<any>} Links
 @property {Links_Properties} properties
 @property {Links_Has} has
 @property {Links_Is} is
 @property {Links_Object} object
 */
/**
 @typedef {Object.<any>} Links_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} data_to_be_set
 @property {text|string} pathname
 @property {number|int} pkey
 @property {text|string} preference
 @property {text|string} uuid
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Links_Has
 */
/**
 @typedef {Object.<any>} Links_Is
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Links_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} data_to_be_set
 @property {string} data_to_be_set_error
 @property {?text|string} pathname
 @property {string} pathname_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} preference
 @property {string} preference_error
 @property {?text|string} uuid
 @property {string} uuid_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Manager_Logs
 @property {Manager_Logs_Properties} properties
 @property {Manager_Logs_Has} has
 @property {Manager_Logs_Is} is
 @property {Manager_Logs_Object} object
 */
/**
 @typedef {Object.<any>} Manager_Logs_Properties
 @property {text|string} actual_field
 @property {number|int} pkey
 @property {text|string} shown_field
 @property {number|int} ticket
 @property {number|int} user
 @property {text|string} value_new
 @property {text|string} value_old
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Manager_Logs_Has
 */
/**
 @typedef {Object.<any>} Manager_Logs_Is
 @property {Tickets_Object} tickets
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Manager_Logs_Object
 @property {?text|string} actual_field
 @property {string} actual_field_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} shown_field
 @property {string} shown_field_error
 @property {?number|int} ticket
 @property {string} ticket_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} value_new
 @property {string} value_new_error
 @property {?text|string} value_old
 @property {string} value_old_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Tickets_Object} tickets
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Manager_Tasks
 @property {Manager_Tasks_Properties} properties
 @property {Manager_Tasks_Has} has
 @property {Manager_Tasks_Is} is
 @property {Manager_Tasks_Object} object
 */
/**
 @typedef {Object.<any>} Manager_Tasks_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} date_done
 @property {text|string} description
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 @property {number|int} task_role
 @property {text|string} title
 @property {array} notify_users
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Manager_Tasks_Has
 */
/**
 @typedef {Object.<any>} Manager_Tasks_Is
 @property {Roles_Object} roles
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Manager_Tasks_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} date_done
 @property {string} date_done_error
 @property {?text|string} description
 @property {string} description_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} task_role
 @property {string} task_role_error
 @property {?text|string} title
 @property {string} title_error
 @property {?array} notify_users
 @property {string} notify_users_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Roles_Object} roles
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Manager_Tasks_Comments
 @property {Manager_Tasks_Comments_Properties} properties
 @property {Manager_Tasks_Comments_Has} has
 @property {Manager_Tasks_Comments_Is} is
 @property {Manager_Tasks_Comments_Object} object
 */
/**
 @typedef {Object.<any>} Manager_Tasks_Comments_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} description
 @property {number|int} parent
 @property {number|int} pkey
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Manager_Tasks_Comments_Has
 */
/**
 @typedef {Object.<any>} Manager_Tasks_Comments_Is
 @property {Manager_Tasks_Object} manager_tasks
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Manager_Tasks_Comments_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} description
 @property {string} description_error
 @property {?number|int} parent
 @property {string} parent_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Manager_Tasks_Object} manager_tasks
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Managers
 @property {Managers_Properties} properties
 @property {Managers_Has} has
 @property {Managers_Is} is
 @property {Managers_Object} object
 */
/**
 @typedef {Object.<any>} Managers_Properties
 @property {number|int} pkey
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Managers_Has
 */
/**
 @typedef {Object.<any>} Managers_Is
 */
/**
 @typedef {Object.<any>} Managers_Object
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Missing_Financial_Workflows
 @property {Missing_Financial_Workflows_Properties} properties
 @property {Missing_Financial_Workflows_Has} has
 @property {Missing_Financial_Workflows_Is} is
 @property {Missing_Financial_Workflows_Object} object
 */
/**
 @typedef {Object.<any>} Missing_Financial_Workflows_Properties
 @property {number|int} missing_ticket
 @property {number|int} pkey
 @property {text|string} status
 @property {number|int} trigger_ticket
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Missing_Financial_Workflows_Has
 */
/**
 @typedef {Object.<any>} Missing_Financial_Workflows_Is
 */
/**
 @typedef {Object.<any>} Missing_Financial_Workflows_Object
 @property {?number|int} missing_ticket
 @property {string} missing_ticket_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} status
 @property {string} status_error
 @property {?number|int} trigger_ticket
 @property {string} trigger_ticket_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Notification_Types
 @property {Notification_Types_Properties} properties
 @property {Notification_Types_Has} has
 @property {Notification_Types_Is} is
 @property {Notification_Types_Object} object
 */
/**
 @typedef {Object.<any>} Notification_Types_Properties
 @property {text|string} message
 @property {number|int} pkey
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Notification_Types_Has
 */
/**
 @typedef {Object.<any>} Notification_Types_Is
 */
/**
 @typedef {Object.<any>} Notification_Types_Object
 @property {?text|string} message
 @property {string} message_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Notifications
 @property {Notifications_Properties} properties
 @property {Notifications_Has} has
 @property {Notifications_Is} is
 @property {Notifications_Object} object
 */
/**
 @typedef {Object.<any>} Notifications_Properties
 @property {date|string} created
 @property {text|string} data
 @property {number|int} pkey
 @property {number|int} ticket
 @property {number|int} type
 @property {number|int} user
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Notifications_Has
 */
/**
 @typedef {Object.<any>} Notifications_Is
 @property {Notification_Types_Object} notification_types
 @property {Tickets_Object} tickets
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Notifications_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?text|string} data
 @property {string} data_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} ticket
 @property {string} ticket_error
 @property {?number|int} type
 @property {string} type_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Notification_Types_Object} notification_types
 @property {Tickets_Object} tickets
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Outstanding_Invoices
 @property {Outstanding_Invoices_Properties} properties
 @property {Outstanding_Invoices_Has} has
 @property {Outstanding_Invoices_Is} is
 @property {Outstanding_Invoices_Object} object
 */
/**
 @typedef {Object.<any>} Outstanding_Invoices_Properties
 @property {text|string} client
 @property {boolean} collections
 @property {date|string} created
 @property {number|int} creator
 @property {boolean} final_email
 @property {boolean} first_email
 @property {text|string} fresh_ticket
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} notes
 @property {boolean} paid
 @property {boolean} phone
 @property {number|int} pkey
 @property {text|string} reason
 @property {text|string} square_url
 @property {number|int} ticket
 @property {text|string} total_invoice
 @property {boolean} valid
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Outstanding_Invoices_Has
 */
/**
 @typedef {Object.<any>} Outstanding_Invoices_Is
 @property {Tickets_Object} tickets
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Outstanding_Invoices_Object
 @property {?text|string} client
 @property {string} client_error
 @property {?boolean} collections
 @property {string} collections_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?boolean} final_email
 @property {string} final_email_error
 @property {?boolean} first_email
 @property {string} first_email_error
 @property {?text|string} fresh_ticket
 @property {string} fresh_ticket_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?boolean} paid
 @property {string} paid_error
 @property {?boolean} phone
 @property {string} phone_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} reason
 @property {string} reason_error
 @property {?text|string} square_url
 @property {string} square_url_error
 @property {?number|int} ticket
 @property {string} ticket_error
 @property {?text|string} total_invoice
 @property {string} total_invoice_error
 @property {?boolean} valid
 @property {string} valid_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Tickets_Object} tickets
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Payment_Pay
 @property {Payment_Pay_Properties} properties
 @property {Payment_Pay_Has} has
 @property {Payment_Pay_Is} is
 @property {Payment_Pay_Object} object
 */
/**
 @typedef {Object.<any>} Payment_Pay_Properties
 */
/**
 @typedef {Object.<any>} Payment_Pay_Has
 */
/**
 @typedef {Object.<any>} Payment_Pay_Is
 */
/**
 @typedef {Object.<any>} Payment_Pay_Object
 */
/**
 @typedef {Object.<any>} Payments
 @property {Payments_Properties} properties
 @property {Payments_Has} has
 @property {Payments_Is} is
 @property {Payments_Object} object
 */
/**
 @typedef {Object.<any>} Payments_Properties
 @property {number|int|float} amount
 @property {text|string} approval_code
 @property {text|string} attempt_uuid
 @property {date|string} authorized_at
 @property {number|int} batch_no
 @property {text|string} card_type
 @property {date|string} created
 @property {number|int} creator
 @property {number|int} customer
 @property {number|int} financial
 @property {text|string} host_transaction_id
 @property {number|int} invoice_no
 @property {text|string} kind
 @property {text|string} last4
 @property {number|int} outstanding_invoice
 @property {number|int} payment_link
 @property {number|int} pkey
 @property {text|string} reference_id
 @property {text|string} rrn
 @property {text|string} status
 @property {number|int} ticket
 @property {number|int|float} tip
 @property {text|string} tpn
 @property {text|string} transaction_id
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Payments_Has
 */
/**
 @typedef {Object.<any>} Payments_Is
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Payments_Object
 @property {?number|int|float} amount
 @property {string} amount_error
 @property {?text|string} approval_code
 @property {string} approval_code_error
 @property {?text|string} attempt_uuid
 @property {string} attempt_uuid_error
 @property {?date|string} authorized_at
 @property {string} authorized_at_error
 @property {?number|int} batch_no
 @property {string} batch_no_error
 @property {?text|string} card_type
 @property {string} card_type_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?number|int} financial
 @property {string} financial_error
 @property {?text|string} host_transaction_id
 @property {string} host_transaction_id_error
 @property {?number|int} invoice_no
 @property {string} invoice_no_error
 @property {?text|string} kind
 @property {string} kind_error
 @property {?text|string} last4
 @property {string} last4_error
 @property {?number|int} outstanding_invoice
 @property {string} outstanding_invoice_error
 @property {?number|int} payment_link
 @property {string} payment_link_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} reference_id
 @property {string} reference_id_error
 @property {?text|string} rrn
 @property {string} rrn_error
 @property {?text|string} status
 @property {string} status_error
 @property {?number|int} ticket
 @property {string} ticket_error
 @property {?number|int|float} tip
 @property {string} tip_error
 @property {?text|string} tpn
 @property {string} tpn_error
 @property {?text|string} transaction_id
 @property {string} transaction_id_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Phone_Logs
 @property {Phone_Logs_Properties} properties
 @property {Phone_Logs_Has} has
 @property {Phone_Logs_Is} is
 @property {Phone_Logs_Object} object
 */
/**
 @typedef {Object.<any>} Phone_Logs_Properties
 @property {number|int} call_type
 @property {boolean} customer_contacted
 @property {text|string} notes
 @property {text|string} phone_number
 @property {number|int} pkey
 @property {number|int} region
 @property {number|int} user
 @property {text|string} zip
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Phone_Logs_Has
 */
/**
 @typedef {Object.<any>} Phone_Logs_Is
 @property {Call_Types_Object} call_types
 @property {Regions_Object} regions
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Phone_Logs_Object
 @property {?number|int} call_type
 @property {string} call_type_error
 @property {?boolean} customer_contacted
 @property {string} customer_contacted_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?text|string} phone_number
 @property {string} phone_number_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} region
 @property {string} region_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Call_Types_Object} call_types
 @property {Regions_Object} regions
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Phone_Logs_Regions
 @property {Phone_Logs_Regions_Properties} properties
 @property {Phone_Logs_Regions_Has} has
 @property {Phone_Logs_Regions_Is} is
 @property {Phone_Logs_Regions_Object} object
 */
/**
 @typedef {Object.<any>} Phone_Logs_Regions_Properties
 @property {number|int} call_type
 @property {text|string} notes
 @property {text|string} phone_number
 @property {number|int} pkey
 @property {number|int} region
 @property {number|int} user
 @property {text|string} zip
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Phone_Logs_Regions_Has
 */
/**
 @typedef {Object.<any>} Phone_Logs_Regions_Is
 @property {Call_Types_Object} call_types
 @property {Regions_Object} regions
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Phone_Logs_Regions_Object
 @property {?number|int} call_type
 @property {string} call_type_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?text|string} phone_number
 @property {string} phone_number_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} region
 @property {string} region_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Call_Types_Object} call_types
 @property {Regions_Object} regions
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Phone_Logs_Users
 @property {Phone_Logs_Users_Properties} properties
 @property {Phone_Logs_Users_Has} has
 @property {Phone_Logs_Users_Is} is
 @property {Phone_Logs_Users_Object} object
 */
/**
 @typedef {Object.<any>} Phone_Logs_Users_Properties
 @property {number|int} call_type
 @property {text|string} notes
 @property {text|string} phone_number
 @property {number|int} pkey
 @property {number|int} region
 @property {number|int} user
 @property {text|string} zip
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Phone_Logs_Users_Has
 */
/**
 @typedef {Object.<any>} Phone_Logs_Users_Is
 @property {Call_Types_Object} call_types
 @property {Regions_Object} regions
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Phone_Logs_Users_Object
 @property {?number|int} call_type
 @property {string} call_type_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?text|string} phone_number
 @property {string} phone_number_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} region
 @property {string} region_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Call_Types_Object} call_types
 @property {Regions_Object} regions
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Recurring_Tasks
 @property {Recurring_Tasks_Properties} properties
 @property {Recurring_Tasks_Has} has
 @property {Recurring_Tasks_Is} is
 @property {Recurring_Tasks_Object} object
 */
/**
 @typedef {Object.<any>} Recurring_Tasks_Properties
 @property {boolean} active
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} description
 @property {text|string} link
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 @property {text|string} roles_array
 @property {text|string} title
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Recurring_Tasks_Has
 */
/**
 @typedef {Object.<any>} Recurring_Tasks_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Recurring_Tasks_Object
 @property {?boolean} active
 @property {string} active_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} description
 @property {string} description_error
 @property {?text|string} link
 @property {string} link_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} roles_array
 @property {string} roles_array_error
 @property {?text|string} title
 @property {string} title_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Recurring_Tasks_Clicked
 @property {Recurring_Tasks_Clicked_Properties} properties
 @property {Recurring_Tasks_Clicked_Has} has
 @property {Recurring_Tasks_Clicked_Is} is
 @property {Recurring_Tasks_Clicked_Object} object
 */
/**
 @typedef {Object.<any>} Recurring_Tasks_Clicked_Properties
 @property {date|string} created
 @property {number|int} pkey
 @property {number|int} task
 @property {number|int} user
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Recurring_Tasks_Clicked_Has
 */
/**
 @typedef {Object.<any>} Recurring_Tasks_Clicked_Is
 @property {Recurring_Tasks_Object} recurring_tasks
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Recurring_Tasks_Clicked_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} task
 @property {string} task_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Recurring_Tasks_Object} recurring_tasks
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Recurring_Tasks_Logs
 @property {Recurring_Tasks_Logs_Properties} properties
 @property {Recurring_Tasks_Logs_Has} has
 @property {Recurring_Tasks_Logs_Is} is
 @property {Recurring_Tasks_Logs_Object} object
 */
/**
 @typedef {Object.<any>} Recurring_Tasks_Logs_Properties
 @property {date|string} date
 @property {text|string} field
 @property {text|string} note
 @property {number|int} pkey
 @property {number|int} task
 @property {number|int} user
 @property {text|string} value_new
 @property {text|string} value_original
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Recurring_Tasks_Logs_Has
 */
/**
 @typedef {Object.<any>} Recurring_Tasks_Logs_Is
 @property {Recurring_Tasks_Object} recurring_tasks
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Recurring_Tasks_Logs_Object
 @property {?date|string} date
 @property {string} date_error
 @property {?text|string} field
 @property {string} field_error
 @property {?text|string} note
 @property {string} note_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} task
 @property {string} task_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} value_new
 @property {string} value_new_error
 @property {?text|string} value_original
 @property {string} value_original_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Recurring_Tasks_Object} recurring_tasks
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Recurring_Tasks_Order
 @property {Recurring_Tasks_Order_Properties} properties
 @property {Recurring_Tasks_Order_Has} has
 @property {Recurring_Tasks_Order_Is} is
 @property {Recurring_Tasks_Order_Object} object
 */
/**
 @typedef {Object.<any>} Recurring_Tasks_Order_Properties
 @property {text|string} current_order
 @property {number|int} pkey
 @property {text|string} role
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Recurring_Tasks_Order_Has
 */
/**
 @typedef {Object.<any>} Recurring_Tasks_Order_Is
 */
/**
 @typedef {Object.<any>} Recurring_Tasks_Order_Object
 @property {?text|string} current_order
 @property {string} current_order_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} role
 @property {string} role_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Refunds
 @property {Refunds_Properties} properties
 @property {Refunds_Has} has
 @property {Refunds_Is} is
 @property {Refunds_Object} object
 */
/**
 @typedef {Object.<any>} Refunds_Properties
 @property {number|int|float} amount
 @property {date|string} created
 @property {number|int} creator
 @property {number|int} customer
 @property {number|int} field_engineer
 @property {text|string} notes
 @property {number|int} pkey
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Refunds_Has
 */
/**
 @typedef {Object.<any>} Refunds_Is
 @property {Customers_Object} customers
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_field_engineer
 */
/**
 @typedef {Object.<any>} Refunds_Object
 @property {?number|int|float} amount
 @property {string} amount_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?number|int} field_engineer
 @property {string} field_engineer_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Customers_Object} customers
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_field_engineer
 */
/**
 @typedef {Object.<any>} Regions
 @property {Regions_Properties} properties
 @property {Regions_Has} has
 @property {Regions_Is} is
 @property {Regions_Object} object
 */
/**
 @typedef {Object.<any>} Regions_Properties
 @property {text|string} abbreviation
 @property {number|int|float} latitude
 @property {number|int|float} longitude
 @property {number|int} metro_walk_ranking
 @property {text|string} name
 @property {number|int} pkey
 @property {number|int} radius
 @property {number|int} ranking
 @property {boolean} active_zone
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Regions_Has
 */
/**
 @typedef {Object.<any>} Regions_Is
 */
/**
 @typedef {Object.<any>} Regions_Object
 @property {?text|string} abbreviation
 @property {string} abbreviation_error
 @property {?number|int|float} latitude
 @property {string} latitude_error
 @property {?number|int|float} longitude
 @property {string} longitude_error
 @property {?number|int} metro_walk_ranking
 @property {string} metro_walk_ranking_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} radius
 @property {string} radius_error
 @property {?number|int} ranking
 @property {string} ranking_error
 @property {?boolean} active_zone
 @property {string} active_zone_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Regions_Feedback
 @property {Regions_Feedback_Properties} properties
 @property {Regions_Feedback_Has} has
 @property {Regions_Feedback_Is} is
 @property {Regions_Feedback_Object} object
 */
/**
 @typedef {Object.<any>} Regions_Feedback_Properties
 @property {text|string} coords
 @property {number|int} feedback_location
 @property {text|string} link
 @property {text|string} name
 @property {number|int} pkey
 @property {text|string} pretty_name
 @property {number|int} ranking
 @property {number|int} region
 @property {number|int} stat_clicked
 @property {number|int} stat_stars_1_4
 @property {number|int} stat_stars_5
 @property {number|int} stat_viewed
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Regions_Feedback_Has
 */
/**
 @typedef {Object.<any>} Regions_Feedback_Is
 @property {Feedback_Locations_Object} feedback_locations
 @property {Regions_Object} regions
 */
/**
 @typedef {Object.<any>} Regions_Feedback_Object
 @property {?text|string} coords
 @property {string} coords_error
 @property {?number|int} feedback_location
 @property {string} feedback_location_error
 @property {?text|string} link
 @property {string} link_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} pretty_name
 @property {string} pretty_name_error
 @property {?number|int} ranking
 @property {string} ranking_error
 @property {?number|int} region
 @property {string} region_error
 @property {?number|int} stat_clicked
 @property {string} stat_clicked_error
 @property {?number|int} stat_stars_1_4
 @property {string} stat_stars_1_4_error
 @property {?number|int} stat_stars_5
 @property {string} stat_stars_5_error
 @property {?number|int} stat_viewed
 @property {string} stat_viewed_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Feedback_Locations_Object} feedback_locations
 @property {Regions_Object} regions
 */
/**
 @typedef {Object.<any>} Reviews
 @property {Reviews_Properties} properties
 @property {Reviews_Has} has
 @property {Reviews_Is} is
 @property {Reviews_Object} object
 */
/**
 @typedef {Object.<any>} Reviews_Properties
 @property {text|string} coords
 @property {number|int} feedback_location
 @property {text|string} link
 @property {text|string} name
 @property {number|int} pkey
 @property {text|string} pretty_name
 @property {number|int} ranking
 @property {number|int} region
 @property {number|int} stat_clicked
 @property {number|int} stat_stars_1_4
 @property {number|int} stat_stars_5
 @property {number|int} stat_viewed
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Reviews_Has
 */
/**
 @typedef {Object.<any>} Reviews_Is
 @property {Feedback_Locations_Object} feedback_locations
 @property {Regions_Object} regions
 */
/**
 @typedef {Object.<any>} Reviews_Object
 @property {?text|string} coords
 @property {string} coords_error
 @property {?number|int} feedback_location
 @property {string} feedback_location_error
 @property {?text|string} link
 @property {string} link_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} pretty_name
 @property {string} pretty_name_error
 @property {?number|int} ranking
 @property {string} ranking_error
 @property {?number|int} region
 @property {string} region_error
 @property {?number|int} stat_clicked
 @property {string} stat_clicked_error
 @property {?number|int} stat_stars_1_4
 @property {string} stat_stars_1_4_error
 @property {?number|int} stat_stars_5
 @property {string} stat_stars_5_error
 @property {?number|int} stat_viewed
 @property {string} stat_viewed_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Feedback_Locations_Object} feedback_locations
 @property {Regions_Object} regions
 */
/**
 @typedef {Object.<any>} Roles
 @property {Roles_Properties} properties
 @property {Roles_Has} has
 @property {Roles_Is} is
 @property {Roles_Object} object
 */
/**
 @typedef {Object.<any>} Roles_Properties
 @property {number|int} afk_timer
 @property {text|string} freshdesk_id
 @property {text|string} name
 @property {number|int} pkey
 @property {number|int} value
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Roles_Has
 */
/**
 @typedef {Object.<any>} Roles_Is
 */
/**
 @typedef {Object.<any>} Roles_Object
 @property {?number|int} afk_timer
 @property {string} afk_timer_error
 @property {?text|string} freshdesk_id
 @property {string} freshdesk_id_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} value
 @property {string} value_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Schedule_Approvals
 @property {Schedule_Approvals_Properties} properties
 @property {Schedule_Approvals_Has} has
 @property {Schedule_Approvals_Is} is
 @property {Schedule_Approvals_Object} object
 */
/**
 @typedef {Object.<any>} Schedule_Approvals_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} data_obj
 @property {number|int} pkey
 @property {text|string} signature
 @property {number|int} user
 @property {date|string} week_of
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 @property {text|string} original_data
 @property {string} signature_data
 */
/**
 @typedef {Object.<any>} Schedule_Approvals_Has
 */
/**
 @typedef {Object.<any>} Schedule_Approvals_Is
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Schedule_Approvals_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} data_obj
 @property {string} data_obj_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} signature
 @property {string} signature_error
 @property {?number|int} user
 @property {string} user_error
 @property {?date|string} week_of
 @property {string} week_of_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {?text|string} original_data
 @property {string} original_data_error
 @property {?string} signature_data
 @property {string} signature_data_error
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Schedules
 @property {Schedules_Properties} properties
 @property {Schedules_Has} has
 @property {Schedules_Is} is
 @property {Schedules_Object} object
 */
/**
 @typedef {Object.<any>} Schedules_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} data_obj
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 @property {number|int} user
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Schedules_Has
 */
/**
 @typedef {Object.<any>} Schedules_Is
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Schedules_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} data_obj
 @property {string} data_obj_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Scores
 @property {Scores_Properties} properties
 @property {Scores_Has} has
 @property {Scores_Is} is
 @property {Scores_Object} object
 */
/**
 @typedef {Object.<any>} Scores_Properties
 @property {date|string} created
 @property {number|int} pkey
 @property {number|int|float} score
 @property {number|int} score_type
 @property {number|int} user
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Scores_Has
 */
/**
 @typedef {Object.<any>} Scores_Is
 @property {Score_Types_Object} score_types
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Scores_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} score
 @property {string} score_error
 @property {?number|int} score_type
 @property {string} score_type_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Score_Types_Object} score_types
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Scores_Highs
 @property {Scores_Highs_Properties} properties
 @property {Scores_Highs_Has} has
 @property {Scores_Highs_Is} is
 @property {Scores_Highs_Object} object
 */
/**
 @typedef {Object.<any>} Scores_Highs_Properties
 @property {date|string} created
 @property {boolean} is_daily
 @property {number|int} name
 @property {number|int} pkey
 @property {number|int|float} score
 @property {number|int} user
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Scores_Highs_Has
 */
/**
 @typedef {Object.<any>} Scores_Highs_Is
 @property {Score_Names_Object} score_names
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Scores_Highs_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?boolean} is_daily
 @property {string} is_daily_error
 @property {?number|int} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} score
 @property {string} score_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Score_Names_Object} score_names
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Scores_Names
 @property {Scores_Names_Properties} properties
 @property {Scores_Names_Has} has
 @property {Scores_Names_Is} is
 @property {Scores_Names_Object} object
 */
/**
 @typedef {Object.<any>} Scores_Names_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name
 @property {number|int} pkey
 @property {number|int|float} weight
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Scores_Names_Has
 */
/**
 @typedef {Object.<any>} Scores_Names_Is
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Scores_Names_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} weight
 @property {string} weight_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Scores_Parts
 @property {Scores_Parts_Properties} properties
 @property {Scores_Parts_Has} has
 @property {Scores_Parts_Is} is
 @property {Scores_Parts_Object} object
 */
/**
 @typedef {Object.<any>} Scores_Parts_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} metric_info
 @property {text|string} metric_name
 @property {text|string} metric_type
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} name
 @property {number|int} pkey
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Scores_Parts_Has
 */
/**
 @typedef {Object.<any>} Scores_Parts_Is
 @property {Score_Names_Object} score_names
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Scores_Parts_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} metric_info
 @property {string} metric_info_error
 @property {?text|string} metric_name
 @property {string} metric_name_error
 @property {?text|string} metric_type
 @property {string} metric_type_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Score_Names_Object} score_names
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Stripe
 @property {Stripe_Properties} properties
 @property {Stripe_Has} has
 @property {Stripe_Is} is
 @property {Stripe_Object} object
 */
/**
 @typedef {Object.<any>} Stripe_Properties
 @property {text|string} description
 @property {text|string} name
 @property {boolean} payment_subscription
 @property {number|int} pkey
 @property {text|string} stripe_price
 @property {text|string} stripe_product
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Stripe_Has
 */
/**
 @typedef {Object.<any>} Stripe_Is
 */
/**
 @typedef {Object.<any>} Stripe_Object
 @property {?text|string} description
 @property {string} description_error
 @property {?text|string} name
 @property {string} name_error
 @property {?boolean} payment_subscription
 @property {string} payment_subscription_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} stripe_price
 @property {string} stripe_price_error
 @property {?text|string} stripe_product
 @property {string} stripe_product_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Stripe_Charges
 @property {Stripe_Charges_Properties} properties
 @property {Stripe_Charges_Has} has
 @property {Stripe_Charges_Is} is
 @property {Stripe_Charges_Object} object
 */
/**
 @typedef {Object.<any>} Stripe_Charges_Properties
 @property {number|int|float} amount
 @property {number|int} av_key
 @property {date|string} created
 @property {number|int} customer
 @property {text|string} email_to
 @property {number|int} pkey
 @property {text|string} session_id
 @property {text|string} signup_url
 @property {number|int} stripe_product
 @property {boolean} av_center
 @property {boolean} av_center_repush
 @property {text|string} city
 @property {text|string} customer_email
 @property {text|string} email
 @property {text|string} name_company
 @property {text|string} name_first
 @property {text|string} name_last
 @property {text|string} name_legal
 @property {text|string} phone
 @property {number|int} pkey
 @property {number|int} quantity
 @property {text|string} state
 @property {text|string} street_1
 @property {text|string} street_2
 @property {text|string} stripe_invoice_id
 @property {text|string} stripe_price_id
 @property {text|string} stripe_subscription_id
 @property {text|string} token
 @property {text|string} zip
 */
/**
 @typedef {Object.<any>} Stripe_Charges_Has
 */
/**
 @typedef {Object.<any>} Stripe_Charges_Is
 @property {Av_Keys_Object} av_keys
 @property {Customers_Object} customers
 @property {Stripe_Products_Object} stripe_products
 */
/**
 @typedef {Object.<any>} Stripe_Charges_Object
 @property {?number|int|float} amount
 @property {string} amount_error
 @property {?number|int} av_key
 @property {string} av_key_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} email_to
 @property {string} email_to_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} session_id
 @property {string} session_id_error
 @property {?text|string} signup_url
 @property {string} signup_url_error
 @property {?number|int} stripe_product
 @property {string} stripe_product_error
 @property {?boolean} av_center
 @property {string} av_center_error
 @property {?boolean} av_center_repush
 @property {string} av_center_repush_error
 @property {?text|string} city
 @property {string} city_error
 @property {?text|string} customer_email
 @property {string} customer_email_error
 @property {?text|string} email
 @property {string} email_error
 @property {?text|string} name_company
 @property {string} name_company_error
 @property {?text|string} name_first
 @property {string} name_first_error
 @property {?text|string} name_last
 @property {string} name_last_error
 @property {?text|string} name_legal
 @property {string} name_legal_error
 @property {?text|string} phone
 @property {string} phone_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} quantity
 @property {string} quantity_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?text|string} street_2
 @property {string} street_2_error
 @property {?text|string} stripe_invoice_id
 @property {string} stripe_invoice_id_error
 @property {?text|string} stripe_price_id
 @property {string} stripe_price_id_error
 @property {?text|string} stripe_subscription_id
 @property {string} stripe_subscription_id_error
 @property {?text|string} token
 @property {string} token_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {Av_Keys_Object} av_keys
 @property {Customers_Object} customers
 @property {Stripe_Products_Object} stripe_products
 */
/**
 @typedef {Object.<any>} Stripe_Products
 @property {Stripe_Products_Properties} properties
 @property {Stripe_Products_Has} has
 @property {Stripe_Products_Is} is
 @property {Stripe_Products_Object} object
 */
/**
 @typedef {Object.<any>} Stripe_Products_Properties
 @property {text|string} description
 @property {text|string} name
 @property {boolean} payment_subscription
 @property {number|int} pkey
 @property {text|string} stripe_price
 @property {text|string} stripe_product
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Stripe_Products_Has
 */
/**
 @typedef {Object.<any>} Stripe_Products_Is
 */
/**
 @typedef {Object.<any>} Stripe_Products_Object
 @property {?text|string} description
 @property {string} description_error
 @property {?text|string} name
 @property {string} name_error
 @property {?boolean} payment_subscription
 @property {string} payment_subscription_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} stripe_price
 @property {string} stripe_price_error
 @property {?text|string} stripe_product
 @property {string} stripe_product_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Stripe_Av_Unmatched
 @property {Stripe_Av_Unmatched_Properties} properties
 @property {Stripe_Av_Unmatched_Has} has
 @property {Stripe_Av_Unmatched_Is} is
 @property {Stripe_Av_Unmatched_Object} object
 */
/**
 @typedef {Object.<any>} Stripe_Av_Unmatched_Properties
 @property {number|int|float} amount
 @property {boolean} cancel_at_period_end
 @property {date|string} created
 @property {text|string} dismissal_reason
 @property {date|string} last_synced
 @property {text|string} link_status
 @property {date|string} linked_at
 @property {number|int} linked_av_key
 @property {number|int} linked_by
 @property {number|int} linked_customer
 @property {number|int} linked_stripe_charge
 @property {text|string} notes
 @property {date|string} period_end
 @property {date|string} period_start
 @property {number|int} pkey
 @property {text|string} product_name
 @property {text|string} product_type
 @property {text|string} stripe_customer_email
 @property {text|string} stripe_customer_id
 @property {text|string} stripe_customer_name
 @property {text|string} stripe_customer_phone
 @property {text|string} stripe_status
 @property {text|string} stripe_subscription_id
 @property {number|int} suggested_customer
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Stripe_Av_Unmatched_Has
 */
/**
 @typedef {Object.<any>} Stripe_Av_Unmatched_Is
 @property {Av_Keys_Object} av_keys
 @property {Customers_Object} customers
 @property {Stripe_Charges_Object} stripe_charges
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Stripe_Av_Unmatched_Object
 @property {?number|int|float} amount
 @property {string} amount_error
 @property {?boolean} cancel_at_period_end
 @property {string} cancel_at_period_end_error
 @property {?date|string} created
 @property {string} created_error
 @property {?text|string} dismissal_reason
 @property {string} dismissal_reason_error
 @property {?date|string} last_synced
 @property {string} last_synced_error
 @property {?text|string} link_status
 @property {string} link_status_error
 @property {?date|string} linked_at
 @property {string} linked_at_error
 @property {?number|int} linked_av_key
 @property {string} linked_av_key_error
 @property {?number|int} linked_by
 @property {string} linked_by_error
 @property {?number|int} linked_customer
 @property {string} linked_customer_error
 @property {?number|int} linked_stripe_charge
 @property {string} linked_stripe_charge_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?date|string} period_end
 @property {string} period_end_error
 @property {?date|string} period_start
 @property {string} period_start_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} product_name
 @property {string} product_name_error
 @property {?text|string} product_type
 @property {string} product_type_error
 @property {?text|string} stripe_customer_email
 @property {string} stripe_customer_email_error
 @property {?text|string} stripe_customer_id
 @property {string} stripe_customer_id_error
 @property {?text|string} stripe_customer_name
 @property {string} stripe_customer_name_error
 @property {?text|string} stripe_customer_phone
 @property {string} stripe_customer_phone_error
 @property {?text|string} stripe_status
 @property {string} stripe_status_error
 @property {?text|string} stripe_subscription_id
 @property {string} stripe_subscription_id_error
 @property {?number|int} suggested_customer
 @property {string} suggested_customer_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Av_Keys_Object} av_keys
 @property {Customers_Object} customers
 @property {Stripe_Charges_Object} stripe_charges
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Stripe_Subscription_Renewal_Logs
 @property {Stripe_Subscription_Renewal_Logs_Properties} properties
 @property {Stripe_Subscription_Renewal_Logs_Has} has
 @property {Stripe_Subscription_Renewal_Logs_Is} is
 @property {Stripe_Subscription_Renewal_Logs_Object} object
 */
/**
 @typedef {Object.<any>} Stripe_Subscription_Renewal_Logs_Properties
 @property {number|int} automated_email
 @property {date|string} created
 @property {text|string} error_message
 @property {text|string} event_type
 @property {number|int} internal_customer_pkey
 @property {number|int} pkey
 @property {text|string} stripe_customer_id
 @property {text|string} stripe_event_id
 @property {text|string} stripe_invoice_id
 @property {text|string} stripe_product_price_id
 @property {text|string} stripe_subscription_id
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Stripe_Subscription_Renewal_Logs_Has
 */
/**
 @typedef {Object.<any>} Stripe_Subscription_Renewal_Logs_Is
 @property {Automated_Emails_Object} automated_emails
 */
/**
 @typedef {Object.<any>} Stripe_Subscription_Renewal_Logs_Object
 @property {?number|int} automated_email
 @property {string} automated_email_error
 @property {?date|string} created
 @property {string} created_error
 @property {?text|string} error_message
 @property {string} error_message_error
 @property {?text|string} event_type
 @property {string} event_type_error
 @property {?number|int} internal_customer_pkey
 @property {string} internal_customer_pkey_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} stripe_customer_id
 @property {string} stripe_customer_id_error
 @property {?text|string} stripe_event_id
 @property {string} stripe_event_id_error
 @property {?text|string} stripe_invoice_id
 @property {string} stripe_invoice_id_error
 @property {?text|string} stripe_product_price_id
 @property {string} stripe_product_price_id_error
 @property {?text|string} stripe_subscription_id
 @property {string} stripe_subscription_id_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Automated_Emails_Object} automated_emails
 */
/**
 @typedef {Object.<any>} Temp_Days_Off
 @property {Temp_Days_Off_Properties} properties
 @property {Temp_Days_Off_Has} has
 @property {Temp_Days_Off_Is} is
 @property {Temp_Days_Off_Object} object
 */
/**
 @typedef {Object.<any>} Temp_Days_Off_Properties
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} daysOff
 @property {number|int} engineer
 @property {date|string} modified
 @property {number|int} modifier
 @property {number|int} pkey
 @property {date|string} startDate
 @property {number|int} weekId
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Temp_Days_Off_Has
 */
/**
 @typedef {Object.<any>} Temp_Days_Off_Is
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Temp_Days_Off_Object
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} daysOff
 @property {string} daysOff_error
 @property {?number|int} engineer
 @property {string} engineer_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?date|string} startDate
 @property {string} startDate_error
 @property {?number|int} weekId
 @property {string} weekId_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Temp_Users
 @property {Temp_Users_Properties} properties
 @property {Temp_Users_Has} has
 @property {Temp_Users_Is} is
 @property {Temp_Users_Object} object
 */
/**
 @typedef {Object.<any>} Temp_Users_Properties
 @property {number|int} candidate
 @property {text|string} kt3_email
 @property {text|string} password
 @property {number|int} pkey
 @property {number|int} user
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Temp_Users_Has
 */
/**
 @typedef {Object.<any>} Temp_Users_Is
 @property {Candidates_Object} candidates
 */
/**
 @typedef {Object.<any>} Temp_Users_Object
 @property {?number|int} candidate
 @property {string} candidate_error
 @property {?text|string} kt3_email
 @property {string} kt3_email_error
 @property {?text|string} password
 @property {string} password_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Candidates_Object} candidates
 */
/**
 @typedef {Object.<any>} Ticket_Audits
 @property {Ticket_Audits_Properties} properties
 @property {Ticket_Audits_Has} has
 @property {Ticket_Audits_Is} is
 @property {Ticket_Audits_Object} object
 */
/**
 @typedef {Object.<any>} Ticket_Audits_Properties
 @property {text|string} av_result
 @property {text|string} backup_result
 @property {text|string} financial_result
 @property {text|string} hdd_result
 @property {text|string} network_result
 @property {text|string} notes_result
 @property {number|int} pkey
 @property {text|string} side_chain_result
 @property {number|int} ticket
 @property {text|string} writeup
 @property {text|string} note
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Ticket_Audits_Has
 */
/**
 @typedef {Object.<any>} Ticket_Audits_Is
 @property {Tickets_Object} tickets
 */
/**
 @typedef {Object.<any>} Ticket_Audits_Object
 @property {?text|string} av_result
 @property {string} av_result_error
 @property {?text|string} backup_result
 @property {string} backup_result_error
 @property {?text|string} financial_result
 @property {string} financial_result_error
 @property {?text|string} hdd_result
 @property {string} hdd_result_error
 @property {?text|string} network_result
 @property {string} network_result_error
 @property {?text|string} notes_result
 @property {string} notes_result_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} side_chain_result
 @property {string} side_chain_result_error
 @property {?number|int} ticket
 @property {string} ticket_error
 @property {?text|string} writeup
 @property {string} writeup_error
 @property {?text|string} note
 @property {string} note_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Tickets_Object} tickets
 */
/**
 @typedef {Object.<any>} Tickets
 @property {Tickets_Properties} properties
 @property {Tickets_Has} has
 @property {Tickets_Is} is
 @property {Tickets_Object} object
 */
/**
 @typedef {Object.<any>} Tickets_Properties
 @property {boolean} allDay
 @property {date|string} appointment_end
 @property {date|string} appointment_start
 @property {boolean} assigned
 @property {boolean} cancelled
 @property {date|string} cancelled_timestamp
 @property {number|int} cancelled_user
 @property {date|string} closed
 @property {date|string} created
 @property {number|int} creator
 @property {number|int} customer
 @property {text|string} description
 @property {number|int} field_engineer
 @property {text|string} fresh_ticket
 @property {array} incomplete_fields
 @property {number|int} incomplete_ticket
 @property {text|string} informational
 @property {number|int} location
 @property {text|string} location_closed
 @property {text|string} location_opened
 @property {text|string} location_override
 @property {text|string} location_override_coords
 @property {date|string} modified
 @property {number|int} modifier
 @property {boolean} new_existing
 @property {date|string} opened
 @property {number|int} pkey
 @property {boolean} prefers_sooner
 @property {date|string} prefers_sooner_timestamp
 @property {number|int} prefers_sooner_user
 @property {boolean} remote_work
 @property {boolean} rescheduled
 @property {date|string} rescheduled_timestamp
 @property {number|int} rescheduled_user
 @property {boolean} same_day_cancel
 @property {text|string} summary
 @property {text|string} ticket_customer
 @property {text|string} ticket_location
 @property {text|string} time_on_site
 @property {number|int} trainer_ticket
 @property {number|int} type
 @property {text|string} endAppt
 @property {text|string} filterFilledHoles
 @property {text|string} filterHoles
 @property {boolean} follow_up
 @property {boolean} formatNoteHelpdesk
 @property {string} freshImage
 @property {text|string} freshNote
 @property {text|string} id
 @property {text|string} invoice_text
 @property {text|string} location_heading_to_site
 @property {string} manager_override_signature
 @property {text|string} manager_override_signature_date
 @property {date|string} occurred_at
 @property {number|int} onboardee
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 @property {boolean} override_day_off_warning
 @property {boolean} override_revisit_warning
 @property {boolean} override_warning
 @property {text|string} ring_message
 @property {text|string} ring_phone
 @property {text|string} selectedDay
 @property {text|string} startAppt
 @property {text|string} title
 @property {number|int} week
 @property {array} workflow_attempts
 */
/**
 @typedef {Object.<any>} Tickets_Has
 @property {Tickets_Checklist_Object[]} tickets_checklists
 @property {Tickets_Financials_Object[]} tickets_financialss
 @property {Tickets_Notes_Object[]} tickets_notess
 */
/**
 @typedef {Object.<any>} Tickets_Is
 @property {Users_Object} cancelled_users
 @property {Customers_Object} customers
 @property {Customers_Locations_Object} customers_locations
 @property {Users_Object} field_engineers
 @property {Users_Object} prefers_sooner_users
 @property {Users_Object} rescheduled_users
 @property {Tickets_Types_Object} tickets_types
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Tickets_Object
 @property {?boolean} allDay
 @property {string} allDay_error
 @property {?date|string} appointment_end
 @property {string} appointment_end_error
 @property {?date|string} appointment_start
 @property {string} appointment_start_error
 @property {?boolean} assigned
 @property {string} assigned_error
 @property {?boolean} cancelled
 @property {string} cancelled_error
 @property {?date|string} cancelled_timestamp
 @property {string} cancelled_timestamp_error
 @property {?number|int} cancelled_user
 @property {string} cancelled_user_error
 @property {?date|string} closed
 @property {string} closed_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int} customer
 @property {string} customer_error
 @property {?text|string} description
 @property {string} description_error
 @property {?number|int} field_engineer
 @property {string} field_engineer_error
 @property {?text|string} fresh_ticket
 @property {string} fresh_ticket_error
 @property {?array} incomplete_fields
 @property {string} incomplete_fields_error
 @property {?number|int} incomplete_ticket
 @property {string} incomplete_ticket_error
 @property {?text|string} informational
 @property {string} informational_error
 @property {?number|int} location
 @property {string} location_error
 @property {?text|string} location_closed
 @property {string} location_closed_error
 @property {?text|string} location_opened
 @property {string} location_opened_error
 @property {?text|string} location_override
 @property {string} location_override_error
 @property {?text|string} location_override_coords
 @property {string} location_override_coords_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?boolean} new_existing
 @property {string} new_existing_error
 @property {?date|string} opened
 @property {string} opened_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?boolean} prefers_sooner
 @property {string} prefers_sooner_error
 @property {?date|string} prefers_sooner_timestamp
 @property {string} prefers_sooner_timestamp_error
 @property {?number|int} prefers_sooner_user
 @property {string} prefers_sooner_user_error
 @property {?boolean} remote_work
 @property {string} remote_work_error
 @property {?boolean} rescheduled
 @property {string} rescheduled_error
 @property {?date|string} rescheduled_timestamp
 @property {string} rescheduled_timestamp_error
 @property {?number|int} rescheduled_user
 @property {string} rescheduled_user_error
 @property {?boolean} same_day_cancel
 @property {string} same_day_cancel_error
 @property {?text|string} summary
 @property {string} summary_error
 @property {?text|string} ticket_customer
 @property {string} ticket_customer_error
 @property {?text|string} ticket_location
 @property {string} ticket_location_error
 @property {?text|string} time_on_site
 @property {string} time_on_site_error
 @property {?number|int} trainer_ticket
 @property {string} trainer_ticket_error
 @property {?number|int} type
 @property {string} type_error
 @property {?text|string} endAppt
 @property {string} endAppt_error
 @property {?text|string} filterFilledHoles
 @property {string} filterFilledHoles_error
 @property {?text|string} filterHoles
 @property {string} filterHoles_error
 @property {?boolean} follow_up
 @property {string} follow_up_error
 @property {?boolean} formatNoteHelpdesk
 @property {string} formatNoteHelpdesk_error
 @property {?string} freshImage
 @property {string} freshImage_error
 @property {?text|string} freshNote
 @property {string} freshNote_error
 @property {?text|string} id
 @property {string} id_error
 @property {?text|string} invoice_text
 @property {string} invoice_text_error
 @property {?text|string} location_heading_to_site
 @property {string} location_heading_to_site_error
 @property {?string} manager_override_signature
 @property {string} manager_override_signature_error
 @property {?text|string} manager_override_signature_date
 @property {string} manager_override_signature_date_error
 @property {?date|string} occurred_at
 @property {string} occurred_at_error
 @property {?number|int} onboardee
 @property {string} onboardee_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {?boolean} override_day_off_warning
 @property {string} override_day_off_warning_error
 @property {?boolean} override_revisit_warning
 @property {string} override_revisit_warning_error
 @property {?boolean} override_warning
 @property {string} override_warning_error
 @property {?text|string} ring_message
 @property {string} ring_message_error
 @property {?text|string} ring_phone
 @property {string} ring_phone_error
 @property {?text|string} selectedDay
 @property {string} selectedDay_error
 @property {?text|string} startAppt
 @property {string} startAppt_error
 @property {?text|string} title
 @property {string} title_error
 @property {?number|int} week
 @property {string} week_error
 @property {?array} workflow_attempts
 @property {string} workflow_attempts_error
 @property {Tickets_Checklist_Object[]} tickets_checklists
 @property {Tickets_Financials_Object[]} tickets_financialss
 @property {Tickets_Notes_Object[]} tickets_notess
 @property {Users_Object} cancelled_users
 @property {Customers_Object} customers
 @property {Customers_Locations_Object} customers_locations
 @property {Users_Object} field_engineers
 @property {Users_Object} prefers_sooner_users
 @property {Users_Object} rescheduled_users
 @property {Tickets_Types_Object} tickets_types
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Tickets_Checklist
 @property {Tickets_Checklist_Properties} properties
 @property {Tickets_Checklist_Has} has
 @property {Tickets_Checklist_Is} is
 @property {Tickets_Checklist_Object} object
 */
/**
 @typedef {Object.<any>} Tickets_Checklist_Properties
 @property {text|string} antimalware_scan
 @property {text|string} antivirus_brand
 @property {text|string} ap_age
 @property {text|string} backup_method
 @property {text|string} chkdsk_results
 @property {text|string} cpu
 @property {boolean} cpu_in_range
 @property {text|string} cpu_temp
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} device_amount
 @property {text|string} dns
 @property {text|string} drive_speed
 @property {boolean} extensions_clean
 @property {text|string} failure_smart_values
 @property {text|string} frag_lvl
 @property {boolean} ghz_setup
 @property {text|string} gpu_temp
 @property {text|string} guest_network
 @property {text|string} hd_temp
 @property {text|string} ip_address
 @property {text|string} ip_static_dynamic
 @property {boolean} ipconfig_flushdns
 @property {boolean} isca
 @property {date|string} last_crash
 @property {date|string} last_local_backup
 @property {date|string} last_offsite_backup
 @property {date|string} last_reboot
 @property {date|string} last_scan
 @property {text|string} local_backup
 @property {text|string} local_backup_size
 @property {text|string} make_ap
 @property {text|string} manufacturer
 @property {text|string} mb_temp
 @property {text|string} office_version
 @property {text|string} offsite_backup
 @property {text|string} offsite_backup_size
 @property {text|string} original_os
 @property {text|string} os
 @property {boolean} os_up_to_date
 @property {text|string} other_notes
 @property {text|string} other_software
 @property {text|string} other_software_function
 @property {boolean} patch_krack
 @property {number|int} pkey
 @property {text|string} poh
 @property {text|string} preferred_browser
 @property {text|string} qb_host_client
 @property {text|string} qb_version
 @property {text|string} ram
 @property {number|int} ram_slots_total
 @property {number|int} ram_slots_used
 @property {boolean} rec_new_fans
 @property {boolean} record_serial_key
 @property {boolean} scheduler_clean
 @property {text|string} sector_count
 @property {text|string} sfc_results
 @property {text|string} short_network_survey
 @property {text|string} smart_errors
 @property {text|string} ssid
 @property {boolean} startup_clean
 @property {text|string} system_bit
 @property {text|string} system_errors
 @property {text|string} system_model
 @property {text|string} system_warnings
 @property {boolean} temp_safe_range
 @property {boolean} temp_under_stress
 @property {text|string} third_party_plugins
 @property {boolean} up_to_date
 @property {text|string} wifi_channel
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Tickets_Checklist_Has
 */
/**
 @typedef {Object.<any>} Tickets_Checklist_Is
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Tickets_Checklist_Object
 @property {?text|string} antimalware_scan
 @property {string} antimalware_scan_error
 @property {?text|string} antivirus_brand
 @property {string} antivirus_brand_error
 @property {?text|string} ap_age
 @property {string} ap_age_error
 @property {?text|string} backup_method
 @property {string} backup_method_error
 @property {?text|string} chkdsk_results
 @property {string} chkdsk_results_error
 @property {?text|string} cpu
 @property {string} cpu_error
 @property {?boolean} cpu_in_range
 @property {string} cpu_in_range_error
 @property {?text|string} cpu_temp
 @property {string} cpu_temp_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} device_amount
 @property {string} device_amount_error
 @property {?text|string} dns
 @property {string} dns_error
 @property {?text|string} drive_speed
 @property {string} drive_speed_error
 @property {?boolean} extensions_clean
 @property {string} extensions_clean_error
 @property {?text|string} failure_smart_values
 @property {string} failure_smart_values_error
 @property {?text|string} frag_lvl
 @property {string} frag_lvl_error
 @property {?boolean} ghz_setup
 @property {string} ghz_setup_error
 @property {?text|string} gpu_temp
 @property {string} gpu_temp_error
 @property {?text|string} guest_network
 @property {string} guest_network_error
 @property {?text|string} hd_temp
 @property {string} hd_temp_error
 @property {?text|string} ip_address
 @property {string} ip_address_error
 @property {?text|string} ip_static_dynamic
 @property {string} ip_static_dynamic_error
 @property {?boolean} ipconfig_flushdns
 @property {string} ipconfig_flushdns_error
 @property {?boolean} isca
 @property {string} isca_error
 @property {?date|string} last_crash
 @property {string} last_crash_error
 @property {?date|string} last_local_backup
 @property {string} last_local_backup_error
 @property {?date|string} last_offsite_backup
 @property {string} last_offsite_backup_error
 @property {?date|string} last_reboot
 @property {string} last_reboot_error
 @property {?date|string} last_scan
 @property {string} last_scan_error
 @property {?text|string} local_backup
 @property {string} local_backup_error
 @property {?text|string} local_backup_size
 @property {string} local_backup_size_error
 @property {?text|string} make_ap
 @property {string} make_ap_error
 @property {?text|string} manufacturer
 @property {string} manufacturer_error
 @property {?text|string} mb_temp
 @property {string} mb_temp_error
 @property {?text|string} office_version
 @property {string} office_version_error
 @property {?text|string} offsite_backup
 @property {string} offsite_backup_error
 @property {?text|string} offsite_backup_size
 @property {string} offsite_backup_size_error
 @property {?text|string} original_os
 @property {string} original_os_error
 @property {?text|string} os
 @property {string} os_error
 @property {?boolean} os_up_to_date
 @property {string} os_up_to_date_error
 @property {?text|string} other_notes
 @property {string} other_notes_error
 @property {?text|string} other_software
 @property {string} other_software_error
 @property {?text|string} other_software_function
 @property {string} other_software_function_error
 @property {?boolean} patch_krack
 @property {string} patch_krack_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} poh
 @property {string} poh_error
 @property {?text|string} preferred_browser
 @property {string} preferred_browser_error
 @property {?text|string} qb_host_client
 @property {string} qb_host_client_error
 @property {?text|string} qb_version
 @property {string} qb_version_error
 @property {?text|string} ram
 @property {string} ram_error
 @property {?number|int} ram_slots_total
 @property {string} ram_slots_total_error
 @property {?number|int} ram_slots_used
 @property {string} ram_slots_used_error
 @property {?boolean} rec_new_fans
 @property {string} rec_new_fans_error
 @property {?boolean} record_serial_key
 @property {string} record_serial_key_error
 @property {?boolean} scheduler_clean
 @property {string} scheduler_clean_error
 @property {?text|string} sector_count
 @property {string} sector_count_error
 @property {?text|string} sfc_results
 @property {string} sfc_results_error
 @property {?text|string} short_network_survey
 @property {string} short_network_survey_error
 @property {?text|string} smart_errors
 @property {string} smart_errors_error
 @property {?text|string} ssid
 @property {string} ssid_error
 @property {?boolean} startup_clean
 @property {string} startup_clean_error
 @property {?text|string} system_bit
 @property {string} system_bit_error
 @property {?text|string} system_errors
 @property {string} system_errors_error
 @property {?text|string} system_model
 @property {string} system_model_error
 @property {?text|string} system_warnings
 @property {string} system_warnings_error
 @property {?boolean} temp_safe_range
 @property {string} temp_safe_range_error
 @property {?boolean} temp_under_stress
 @property {string} temp_under_stress_error
 @property {?text|string} third_party_plugins
 @property {string} third_party_plugins_error
 @property {?boolean} up_to_date
 @property {string} up_to_date_error
 @property {?text|string} wifi_channel
 @property {string} wifi_channel_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Tickets_Deposits
 @property {Tickets_Deposits_Properties} properties
 @property {Tickets_Deposits_Has} has
 @property {Tickets_Deposits_Is} is
 @property {Tickets_Deposits_Object} object
 */
/**
 @typedef {Object.<any>} Tickets_Deposits_Properties
 @property {string} cash_1
 @property {string} cash_2
 @property {string} checks_1
 @property {string} checks_2
 @property {date|string} created
 @property {number|int} creator
 @property {number|int} field_engineer
 @property {number|int} pkey
 @property {string} receipt_1
 @property {string} receipt_2
 @property {number|int} week
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Tickets_Deposits_Has
 */
/**
 @typedef {Object.<any>} Tickets_Deposits_Is
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Tickets_Deposits_Object
 @property {?string} cash_1
 @property {string} cash_1_error
 @property {?string} cash_2
 @property {string} cash_2_error
 @property {?string} checks_1
 @property {string} checks_1_error
 @property {?string} checks_2
 @property {string} checks_2_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?number|int} field_engineer
 @property {string} field_engineer_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?string} receipt_1
 @property {string} receipt_1_error
 @property {?string} receipt_2
 @property {string} receipt_2_error
 @property {?number|int} week
 @property {string} week_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Tickets_Financials
 @property {Tickets_Financials_Properties} properties
 @property {Tickets_Financials_Has} has
 @property {Tickets_Financials_Is} is
 @property {Tickets_Financials_Object} object
 */
/**
 @typedef {Object.<any>} Tickets_Financials_Properties
 @property {boolean} approved
 @property {boolean} approved_helpdesk
 @property {date|string} approved_helpdesk_timestamp
 @property {number|int} approved_helpdesk_user
 @property {date|string} created
 @property {number|int} creator
 @property {boolean} deposited
 @property {number|int|float} expected_labor
 @property {string} image
 @property {number|int|float} initial_labor
 @property {number|int|float} labor_amount
 @property {boolean} manager_override
 @property {text|string} manager_override_approver
 @property {text|string} manager_override_notes
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} notes
 @property {date|string} occurred_at
 @property {number|int|float} parts_amount
 @property {number|int} payment_type
 @property {number|int} pkey
 @property {text|string} square_url_clean
 @property {text|string} square_url_raw
 @property {number|int} ticket
 @property {number|int} user
 @property {number|int|float} virus_sales
 @property {boolean} labor_validated
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 @property {number|int|float} original_labor
 @property {text|string} original_notes
 @property {number|int|float} original_parts_amount
 @property {number|int} original_payment_type
 @property {number|int|float} original_virus_sales
 @property {string} signature
 */
/**
 @typedef {Object.<any>} Tickets_Financials_Has
 */
/**
 @typedef {Object.<any>} Tickets_Financials_Is
 @property {Tickets_Object} tickets
 @property {Tickets_Financials_Types_Object} tickets_financials_types
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Tickets_Financials_Object
 @property {?boolean} approved
 @property {string} approved_error
 @property {?boolean} approved_helpdesk
 @property {string} approved_helpdesk_error
 @property {?date|string} approved_helpdesk_timestamp
 @property {string} approved_helpdesk_timestamp_error
 @property {?number|int} approved_helpdesk_user
 @property {string} approved_helpdesk_user_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?boolean} deposited
 @property {string} deposited_error
 @property {?number|int|float} expected_labor
 @property {string} expected_labor_error
 @property {?string} image
 @property {string} image_error
 @property {?number|int|float} initial_labor
 @property {string} initial_labor_error
 @property {?number|int|float} labor_amount
 @property {string} labor_amount_error
 @property {?boolean} manager_override
 @property {string} manager_override_error
 @property {?text|string} manager_override_approver
 @property {string} manager_override_approver_error
 @property {?text|string} manager_override_notes
 @property {string} manager_override_notes_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?date|string} occurred_at
 @property {string} occurred_at_error
 @property {?number|int|float} parts_amount
 @property {string} parts_amount_error
 @property {?number|int} payment_type
 @property {string} payment_type_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} square_url_clean
 @property {string} square_url_clean_error
 @property {?text|string} square_url_raw
 @property {string} square_url_raw_error
 @property {?number|int} ticket
 @property {string} ticket_error
 @property {?number|int} user
 @property {string} user_error
 @property {?number|int|float} virus_sales
 @property {string} virus_sales_error
 @property {?boolean} labor_validated
 @property {string} labor_validated_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {?number|int|float} original_labor
 @property {string} original_labor_error
 @property {?text|string} original_notes
 @property {string} original_notes_error
 @property {?number|int|float} original_parts_amount
 @property {string} original_parts_amount_error
 @property {?number|int} original_payment_type
 @property {string} original_payment_type_error
 @property {?number|int|float} original_virus_sales
 @property {string} original_virus_sales_error
 @property {?string} signature
 @property {string} signature_error
 @property {Tickets_Object} tickets
 @property {Tickets_Financials_Types_Object} tickets_financials_types
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Tickets_Financials_Images
 @property {Tickets_Financials_Images_Properties} properties
 @property {Tickets_Financials_Images_Has} has
 @property {Tickets_Financials_Images_Is} is
 @property {Tickets_Financials_Images_Object} object
 */
/**
 @typedef {Object.<any>} Tickets_Financials_Images_Properties
 @property {boolean} approved
 @property {boolean} approved_helpdesk
 @property {date|string} approved_helpdesk_timestamp
 @property {number|int} approved_helpdesk_user
 @property {date|string} created
 @property {number|int} creator
 @property {boolean} deposited
 @property {number|int|float} expected_labor
 @property {string} image
 @property {number|int|float} initial_labor
 @property {number|int|float} labor_amount
 @property {boolean} manager_override
 @property {text|string} manager_override_approver
 @property {text|string} manager_override_notes
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} notes
 @property {date|string} occurred_at
 @property {number|int|float} parts_amount
 @property {number|int} payment_type
 @property {number|int} pkey
 @property {text|string} square_url_clean
 @property {text|string} square_url_raw
 @property {number|int} ticket
 @property {number|int} user
 @property {number|int|float} virus_sales
 @property {boolean} labor_validated
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 @property {number|int|float} original_labor
 @property {text|string} original_notes
 @property {number|int|float} original_parts_amount
 @property {number|int} original_payment_type
 @property {number|int|float} original_virus_sales
 @property {string} signature
 */
/**
 @typedef {Object.<any>} Tickets_Financials_Images_Has
 */
/**
 @typedef {Object.<any>} Tickets_Financials_Images_Is
 @property {Tickets_Object} tickets
 @property {Tickets_Financials_Types_Object} tickets_financials_types
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Tickets_Financials_Images_Object
 @property {?boolean} approved
 @property {string} approved_error
 @property {?boolean} approved_helpdesk
 @property {string} approved_helpdesk_error
 @property {?date|string} approved_helpdesk_timestamp
 @property {string} approved_helpdesk_timestamp_error
 @property {?number|int} approved_helpdesk_user
 @property {string} approved_helpdesk_user_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?boolean} deposited
 @property {string} deposited_error
 @property {?number|int|float} expected_labor
 @property {string} expected_labor_error
 @property {?string} image
 @property {string} image_error
 @property {?number|int|float} initial_labor
 @property {string} initial_labor_error
 @property {?number|int|float} labor_amount
 @property {string} labor_amount_error
 @property {?boolean} manager_override
 @property {string} manager_override_error
 @property {?text|string} manager_override_approver
 @property {string} manager_override_approver_error
 @property {?text|string} manager_override_notes
 @property {string} manager_override_notes_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?date|string} occurred_at
 @property {string} occurred_at_error
 @property {?number|int|float} parts_amount
 @property {string} parts_amount_error
 @property {?number|int} payment_type
 @property {string} payment_type_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} square_url_clean
 @property {string} square_url_clean_error
 @property {?text|string} square_url_raw
 @property {string} square_url_raw_error
 @property {?number|int} ticket
 @property {string} ticket_error
 @property {?number|int} user
 @property {string} user_error
 @property {?number|int|float} virus_sales
 @property {string} virus_sales_error
 @property {?boolean} labor_validated
 @property {string} labor_validated_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {?number|int|float} original_labor
 @property {string} original_labor_error
 @property {?text|string} original_notes
 @property {string} original_notes_error
 @property {?number|int|float} original_parts_amount
 @property {string} original_parts_amount_error
 @property {?number|int} original_payment_type
 @property {string} original_payment_type_error
 @property {?number|int|float} original_virus_sales
 @property {string} original_virus_sales_error
 @property {?string} signature
 @property {string} signature_error
 @property {Tickets_Object} tickets
 @property {Tickets_Financials_Types_Object} tickets_financials_types
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Tickets_Financials_Logs
 @property {Tickets_Financials_Logs_Properties} properties
 @property {Tickets_Financials_Logs_Has} has
 @property {Tickets_Financials_Logs_Is} is
 @property {Tickets_Financials_Logs_Object} object
 */
/**
 @typedef {Object.<any>} Tickets_Financials_Logs_Properties
 @property {date|string} date
 @property {text|string} field
 @property {number|int} financial
 @property {text|string} note
 @property {number|int} pkey
 @property {number|int} user
 @property {text|string} value_new
 @property {text|string} value_original
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Tickets_Financials_Logs_Has
 */
/**
 @typedef {Object.<any>} Tickets_Financials_Logs_Is
 @property {Tickets_Financials_Object} tickets_financials
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Tickets_Financials_Logs_Object
 @property {?date|string} date
 @property {string} date_error
 @property {?text|string} field
 @property {string} field_error
 @property {?number|int} financial
 @property {string} financial_error
 @property {?text|string} note
 @property {string} note_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} value_new
 @property {string} value_new_error
 @property {?text|string} value_original
 @property {string} value_original_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Tickets_Financials_Object} tickets_financials
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Tickets_Financials_Signatures
 @property {Tickets_Financials_Signatures_Properties} properties
 @property {Tickets_Financials_Signatures_Has} has
 @property {Tickets_Financials_Signatures_Is} is
 @property {Tickets_Financials_Signatures_Object} object
 */
/**
 @typedef {Object.<any>} Tickets_Financials_Signatures_Properties
 @property {date|string} date
 @property {number|int} pkey
 @property {string} signature
 @property {number|int} ticket
 @property {number|int} user
 @property {text|string} engineer
 @property {text|string} fresh_ticket
 @property {text|string} manager_override_approver
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Tickets_Financials_Signatures_Has
 */
/**
 @typedef {Object.<any>} Tickets_Financials_Signatures_Is
 @property {Tickets_Object} tickets
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Tickets_Financials_Signatures_Object
 @property {?date|string} date
 @property {string} date_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?string} signature
 @property {string} signature_error
 @property {?number|int} ticket
 @property {string} ticket_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} engineer
 @property {string} engineer_error
 @property {?text|string} fresh_ticket
 @property {string} fresh_ticket_error
 @property {?text|string} manager_override_approver
 @property {string} manager_override_approver_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Tickets_Object} tickets
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Tickets_Financials_Types
 @property {Tickets_Financials_Types_Properties} properties
 @property {Tickets_Financials_Types_Has} has
 @property {Tickets_Financials_Types_Is} is
 @property {Tickets_Financials_Types_Object} object
 */
/**
 @typedef {Object.<any>} Tickets_Financials_Types_Properties
 @property {text|string} name
 @property {number|int} pkey
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Tickets_Financials_Types_Has
 */
/**
 @typedef {Object.<any>} Tickets_Financials_Types_Is
 */
/**
 @typedef {Object.<any>} Tickets_Financials_Types_Object
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Tickets_Freshdesk_Attachment
 @property {Tickets_Freshdesk_Attachment_Properties} properties
 @property {Tickets_Freshdesk_Attachment_Has} has
 @property {Tickets_Freshdesk_Attachment_Is} is
 @property {Tickets_Freshdesk_Attachment_Object} object
 */
/**
 @typedef {Object.<any>} Tickets_Freshdesk_Attachment_Properties
 @property {text|string} av_result
 @property {text|string} backup_result
 @property {text|string} financial_result
 @property {text|string} hdd_result
 @property {text|string} network_result
 @property {text|string} notes_result
 @property {number|int} pkey
 @property {text|string} side_chain_result
 @property {number|int} ticket
 @property {text|string} writeup
 @property {text|string} note
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Tickets_Freshdesk_Attachment_Has
 */
/**
 @typedef {Object.<any>} Tickets_Freshdesk_Attachment_Is
 @property {Tickets_Object} tickets
 */
/**
 @typedef {Object.<any>} Tickets_Freshdesk_Attachment_Object
 @property {?text|string} av_result
 @property {string} av_result_error
 @property {?text|string} backup_result
 @property {string} backup_result_error
 @property {?text|string} financial_result
 @property {string} financial_result_error
 @property {?text|string} hdd_result
 @property {string} hdd_result_error
 @property {?text|string} network_result
 @property {string} network_result_error
 @property {?text|string} notes_result
 @property {string} notes_result_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} side_chain_result
 @property {string} side_chain_result_error
 @property {?number|int} ticket
 @property {string} ticket_error
 @property {?text|string} writeup
 @property {string} writeup_error
 @property {?text|string} note
 @property {string} note_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Tickets_Object} tickets
 */
/**
 @typedef {Object.<any>} Tickets_Headers
 @property {Tickets_Headers_Properties} properties
 @property {Tickets_Headers_Has} has
 @property {Tickets_Headers_Is} is
 @property {Tickets_Headers_Object} object
 */
/**
 @typedef {Object.<any>} Tickets_Headers_Properties
 @property {number|int} first_question
 @property {number|int} pkey
 @property {text|string} text
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Tickets_Headers_Has
 */
/**
 @typedef {Object.<any>} Tickets_Headers_Is
 */
/**
 @typedef {Object.<any>} Tickets_Headers_Object
 @property {?number|int} first_question
 @property {string} first_question_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} text
 @property {string} text_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Tickets_Images
 @property {Tickets_Images_Properties} properties
 @property {Tickets_Images_Has} has
 @property {Tickets_Images_Is} is
 @property {Tickets_Images_Object} object
 */
/**
 @typedef {Object.<any>} Tickets_Images_Properties
 @property {text|string} antivirus
 @property {text|string} backup_type
 @property {text|string} carbonite
 @property {text|string} checkup_service
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} detailed_notes
 @property {text|string} drive_smart_ids
 @property {text|string} drive_smart_value
 @property {text|string} hdd_smart_status
 @property {text|string} hhd_frag_percent
 @property {text|string} hhd_tune_result
 @property {string} images_multiple
 @property {text|string} malware_scan
 @property {text|string} mandatory_backup_note
 @property {text|string} mandatory_hdd_note
 @property {text|string} mandatory_network_note
 @property {text|string} mandatory_virus_note
 @property {number|int} pkey
 @property {text|string} positive_feedback
 @property {date|string} schedule_appt
 @property {text|string} temps
 @property {number|int} ticket
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Tickets_Images_Has
 */
/**
 @typedef {Object.<any>} Tickets_Images_Is
 @property {Tickets_Object} tickets
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Tickets_Images_Object
 @property {?text|string} antivirus
 @property {string} antivirus_error
 @property {?text|string} backup_type
 @property {string} backup_type_error
 @property {?text|string} carbonite
 @property {string} carbonite_error
 @property {?text|string} checkup_service
 @property {string} checkup_service_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} detailed_notes
 @property {string} detailed_notes_error
 @property {?text|string} drive_smart_ids
 @property {string} drive_smart_ids_error
 @property {?text|string} drive_smart_value
 @property {string} drive_smart_value_error
 @property {?text|string} hdd_smart_status
 @property {string} hdd_smart_status_error
 @property {?text|string} hhd_frag_percent
 @property {string} hhd_frag_percent_error
 @property {?text|string} hhd_tune_result
 @property {string} hhd_tune_result_error
 @property {?string} images_multiple
 @property {string} images_multiple_error
 @property {?text|string} malware_scan
 @property {string} malware_scan_error
 @property {?text|string} mandatory_backup_note
 @property {string} mandatory_backup_note_error
 @property {?text|string} mandatory_hdd_note
 @property {string} mandatory_hdd_note_error
 @property {?text|string} mandatory_network_note
 @property {string} mandatory_network_note_error
 @property {?text|string} mandatory_virus_note
 @property {string} mandatory_virus_note_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} positive_feedback
 @property {string} positive_feedback_error
 @property {?date|string} schedule_appt
 @property {string} schedule_appt_error
 @property {?text|string} temps
 @property {string} temps_error
 @property {?number|int} ticket
 @property {string} ticket_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Tickets_Object} tickets
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Tickets_Information
 @property {Tickets_Information_Properties} properties
 @property {Tickets_Information_Has} has
 @property {Tickets_Information_Is} is
 @property {Tickets_Information_Object} object
 */
/**
 @typedef {Object.<any>} Tickets_Information_Properties
 @property {boolean} anti_virus_signed
 @property {text|string} antivirus
 @property {text|string} ap_age
 @property {text|string} av_used_for_scan
 @property {text|string} backup_date
 @property {text|string} backup_method
 @property {text|string} backup_size
 @property {text|string} backup_type
 @property {text|string} carbonite
 @property {text|string} checkup_service
 @property {text|string} client_feedback_location
 @property {boolean} comp_repair_signed
 @property {text|string} cpu
 @property {date|string} created
 @property {number|int} creator
 @property {boolean} data_backup_signed
 @property {text|string} detailed_notes
 @property {text|string} device_amount
 @property {text|string} device_backed_up_on
 @property {boolean} discussed_av
 @property {boolean} dism_complete
 @property {text|string} dns
 @property {text|string} drive_smart_ids
 @property {text|string} drive_speed
 @property {boolean} event_signed
 @property {text|string} failure_smart_values
 @property {text|string} frag_lvl
 @property {boolean} ghz_setup
 @property {text|string} guest_network
 @property {text|string} hdd_frag_percent
 @property {boolean} hdd_inspection_signed
 @property {text|string} hdd_smart_status
 @property {text|string} hdd_smart_values
 @property {text|string} hdd_temps
 @property {text|string} hdd_tune_result
 @property {boolean} infections_found
 @property {text|string} ip_address
 @property {text|string} ip_static_dynamic
 @property {boolean} isca
 @property {text|string} last_backup
 @property {text|string} last_scan
 @property {text|string} last_ticket_screen
 @property {text|string} make_ap
 @property {text|string} mandatory_backup_note
 @property {text|string} mandatory_hdd_note
 @property {text|string} mandatory_network_note
 @property {text|string} mandatory_virus_note
 @property {text|string} manufacturer
 @property {boolean} network_signed
 @property {text|string} original_os
 @property {text|string} os
 @property {boolean} os_up_to_date
 @property {text|string} other_notes
 @property {boolean} patch_krack
 @property {number|int} pkey
 @property {text|string} poh
 @property {text|string} positive_feedback
 @property {text|string} ram
 @property {number|int} ram_slots_total
 @property {number|int} ram_slots_used
 @property {boolean} refused_av_waiver
 @property {boolean} refused_backup_waiver
 @property {boolean} refused_comp_waiver
 @property {boolean} refused_inspection_waiver
 @property {text|string} scan_amount
 @property {text|string} scan_time
 @property {date|string} schedule_appt
 @property {text|string} sector_count
 @property {boolean} sfc_complete
 @property {text|string} short_network_survey
 @property {text|string} smart_errors
 @property {text|string} spec_temps
 @property {text|string} ssid
 @property {text|string} system_bit
 @property {text|string} system_errors
 @property {text|string} system_warnings
 @property {number|int} ticket
 @property {boolean} ticket_list_completed
 @property {boolean} ticket_list_filled
 @property {boolean} up_to_date
 @property {boolean} virus_removal_complete
 @property {text|string} wifi_channel
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Tickets_Information_Has
 */
/**
 @typedef {Object.<any>} Tickets_Information_Is
 @property {Tickets_Object} tickets
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Tickets_Information_Object
 @property {?boolean} anti_virus_signed
 @property {string} anti_virus_signed_error
 @property {?text|string} antivirus
 @property {string} antivirus_error
 @property {?text|string} ap_age
 @property {string} ap_age_error
 @property {?text|string} av_used_for_scan
 @property {string} av_used_for_scan_error
 @property {?text|string} backup_date
 @property {string} backup_date_error
 @property {?text|string} backup_method
 @property {string} backup_method_error
 @property {?text|string} backup_size
 @property {string} backup_size_error
 @property {?text|string} backup_type
 @property {string} backup_type_error
 @property {?text|string} carbonite
 @property {string} carbonite_error
 @property {?text|string} checkup_service
 @property {string} checkup_service_error
 @property {?text|string} client_feedback_location
 @property {string} client_feedback_location_error
 @property {?boolean} comp_repair_signed
 @property {string} comp_repair_signed_error
 @property {?text|string} cpu
 @property {string} cpu_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?boolean} data_backup_signed
 @property {string} data_backup_signed_error
 @property {?text|string} detailed_notes
 @property {string} detailed_notes_error
 @property {?text|string} device_amount
 @property {string} device_amount_error
 @property {?text|string} device_backed_up_on
 @property {string} device_backed_up_on_error
 @property {?boolean} discussed_av
 @property {string} discussed_av_error
 @property {?boolean} dism_complete
 @property {string} dism_complete_error
 @property {?text|string} dns
 @property {string} dns_error
 @property {?text|string} drive_smart_ids
 @property {string} drive_smart_ids_error
 @property {?text|string} drive_speed
 @property {string} drive_speed_error
 @property {?boolean} event_signed
 @property {string} event_signed_error
 @property {?text|string} failure_smart_values
 @property {string} failure_smart_values_error
 @property {?text|string} frag_lvl
 @property {string} frag_lvl_error
 @property {?boolean} ghz_setup
 @property {string} ghz_setup_error
 @property {?text|string} guest_network
 @property {string} guest_network_error
 @property {?text|string} hdd_frag_percent
 @property {string} hdd_frag_percent_error
 @property {?boolean} hdd_inspection_signed
 @property {string} hdd_inspection_signed_error
 @property {?text|string} hdd_smart_status
 @property {string} hdd_smart_status_error
 @property {?text|string} hdd_smart_values
 @property {string} hdd_smart_values_error
 @property {?text|string} hdd_temps
 @property {string} hdd_temps_error
 @property {?text|string} hdd_tune_result
 @property {string} hdd_tune_result_error
 @property {?boolean} infections_found
 @property {string} infections_found_error
 @property {?text|string} ip_address
 @property {string} ip_address_error
 @property {?text|string} ip_static_dynamic
 @property {string} ip_static_dynamic_error
 @property {?boolean} isca
 @property {string} isca_error
 @property {?text|string} last_backup
 @property {string} last_backup_error
 @property {?text|string} last_scan
 @property {string} last_scan_error
 @property {?text|string} last_ticket_screen
 @property {string} last_ticket_screen_error
 @property {?text|string} make_ap
 @property {string} make_ap_error
 @property {?text|string} mandatory_backup_note
 @property {string} mandatory_backup_note_error
 @property {?text|string} mandatory_hdd_note
 @property {string} mandatory_hdd_note_error
 @property {?text|string} mandatory_network_note
 @property {string} mandatory_network_note_error
 @property {?text|string} mandatory_virus_note
 @property {string} mandatory_virus_note_error
 @property {?text|string} manufacturer
 @property {string} manufacturer_error
 @property {?boolean} network_signed
 @property {string} network_signed_error
 @property {?text|string} original_os
 @property {string} original_os_error
 @property {?text|string} os
 @property {string} os_error
 @property {?boolean} os_up_to_date
 @property {string} os_up_to_date_error
 @property {?text|string} other_notes
 @property {string} other_notes_error
 @property {?boolean} patch_krack
 @property {string} patch_krack_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} poh
 @property {string} poh_error
 @property {?text|string} positive_feedback
 @property {string} positive_feedback_error
 @property {?text|string} ram
 @property {string} ram_error
 @property {?number|int} ram_slots_total
 @property {string} ram_slots_total_error
 @property {?number|int} ram_slots_used
 @property {string} ram_slots_used_error
 @property {?boolean} refused_av_waiver
 @property {string} refused_av_waiver_error
 @property {?boolean} refused_backup_waiver
 @property {string} refused_backup_waiver_error
 @property {?boolean} refused_comp_waiver
 @property {string} refused_comp_waiver_error
 @property {?boolean} refused_inspection_waiver
 @property {string} refused_inspection_waiver_error
 @property {?text|string} scan_amount
 @property {string} scan_amount_error
 @property {?text|string} scan_time
 @property {string} scan_time_error
 @property {?date|string} schedule_appt
 @property {string} schedule_appt_error
 @property {?text|string} sector_count
 @property {string} sector_count_error
 @property {?boolean} sfc_complete
 @property {string} sfc_complete_error
 @property {?text|string} short_network_survey
 @property {string} short_network_survey_error
 @property {?text|string} smart_errors
 @property {string} smart_errors_error
 @property {?text|string} spec_temps
 @property {string} spec_temps_error
 @property {?text|string} ssid
 @property {string} ssid_error
 @property {?text|string} system_bit
 @property {string} system_bit_error
 @property {?text|string} system_errors
 @property {string} system_errors_error
 @property {?text|string} system_warnings
 @property {string} system_warnings_error
 @property {?number|int} ticket
 @property {string} ticket_error
 @property {?boolean} ticket_list_completed
 @property {string} ticket_list_completed_error
 @property {?boolean} ticket_list_filled
 @property {string} ticket_list_filled_error
 @property {?boolean} up_to_date
 @property {string} up_to_date_error
 @property {?boolean} virus_removal_complete
 @property {string} virus_removal_complete_error
 @property {?text|string} wifi_channel
 @property {string} wifi_channel_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Tickets_Object} tickets
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Tickets_Lists
 @property {Tickets_Lists_Properties} properties
 @property {Tickets_Lists_Has} has
 @property {Tickets_Lists_Is} is
 @property {Tickets_Lists_Object} object
 */
/**
 @typedef {Object.<any>} Tickets_Lists_Properties
 @property {boolean} completed
 @property {text|string} completed_reasoning
 @property {text|string} header
 @property {text|string} information
 @property {date|string} occurred_at
 @property {number|int} pkey
 @property {number|int} ticket
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 @property {text|string} tasks
 */
/**
 @typedef {Object.<any>} Tickets_Lists_Has
 */
/**
 @typedef {Object.<any>} Tickets_Lists_Is
 @property {Tickets_Object} tickets
 */
/**
 @typedef {Object.<any>} Tickets_Lists_Object
 @property {?boolean} completed
 @property {string} completed_error
 @property {?text|string} completed_reasoning
 @property {string} completed_reasoning_error
 @property {?text|string} header
 @property {string} header_error
 @property {?text|string} information
 @property {string} information_error
 @property {?date|string} occurred_at
 @property {string} occurred_at_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} ticket
 @property {string} ticket_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {?text|string} tasks
 @property {string} tasks_error
 @property {Tickets_Object} tickets
 */
/**
 @typedef {Object.<any>} Tickets_Logs
 @property {Tickets_Logs_Properties} properties
 @property {Tickets_Logs_Has} has
 @property {Tickets_Logs_Is} is
 @property {Tickets_Logs_Object} object
 */
/**
 @typedef {Object.<any>} Tickets_Logs_Properties
 @property {date|string} date
 @property {text|string} display_new
 @property {text|string} display_original
 @property {text|string} field
 @property {text|string} note
 @property {number|int} pkey
 @property {number|int} ticket
 @property {number|int} user
 @property {text|string} value_new
 @property {text|string} value_original
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Tickets_Logs_Has
 */
/**
 @typedef {Object.<any>} Tickets_Logs_Is
 @property {Tickets_Object} tickets
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Tickets_Logs_Object
 @property {?date|string} date
 @property {string} date_error
 @property {?text|string} display_new
 @property {string} display_new_error
 @property {?text|string} display_original
 @property {string} display_original_error
 @property {?text|string} field
 @property {string} field_error
 @property {?text|string} note
 @property {string} note_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} ticket
 @property {string} ticket_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} value_new
 @property {string} value_new_error
 @property {?text|string} value_original
 @property {string} value_original_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Tickets_Object} tickets
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Tickets_Notes
 @property {Tickets_Notes_Properties} properties
 @property {Tickets_Notes_Has} has
 @property {Tickets_Notes_Is} is
 @property {Tickets_Notes_Object} object
 */
/**
 @typedef {Object.<any>} Tickets_Notes_Properties
 @property {text|string} antivirus
 @property {text|string} backup_type
 @property {text|string} carbonite
 @property {text|string} checkup_service
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} detailed_notes
 @property {text|string} drive_smart_ids
 @property {text|string} drive_smart_value
 @property {text|string} hdd_smart_status
 @property {text|string} hhd_frag_percent
 @property {text|string} hhd_tune_result
 @property {string} images_multiple
 @property {text|string} malware_scan
 @property {text|string} mandatory_backup_note
 @property {text|string} mandatory_hdd_note
 @property {text|string} mandatory_network_note
 @property {text|string} mandatory_virus_note
 @property {number|int} pkey
 @property {text|string} positive_feedback
 @property {date|string} schedule_appt
 @property {text|string} temps
 @property {number|int} ticket
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Tickets_Notes_Has
 */
/**
 @typedef {Object.<any>} Tickets_Notes_Is
 @property {Tickets_Object} tickets
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Tickets_Notes_Object
 @property {?text|string} antivirus
 @property {string} antivirus_error
 @property {?text|string} backup_type
 @property {string} backup_type_error
 @property {?text|string} carbonite
 @property {string} carbonite_error
 @property {?text|string} checkup_service
 @property {string} checkup_service_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} detailed_notes
 @property {string} detailed_notes_error
 @property {?text|string} drive_smart_ids
 @property {string} drive_smart_ids_error
 @property {?text|string} drive_smart_value
 @property {string} drive_smart_value_error
 @property {?text|string} hdd_smart_status
 @property {string} hdd_smart_status_error
 @property {?text|string} hhd_frag_percent
 @property {string} hhd_frag_percent_error
 @property {?text|string} hhd_tune_result
 @property {string} hhd_tune_result_error
 @property {?string} images_multiple
 @property {string} images_multiple_error
 @property {?text|string} malware_scan
 @property {string} malware_scan_error
 @property {?text|string} mandatory_backup_note
 @property {string} mandatory_backup_note_error
 @property {?text|string} mandatory_hdd_note
 @property {string} mandatory_hdd_note_error
 @property {?text|string} mandatory_network_note
 @property {string} mandatory_network_note_error
 @property {?text|string} mandatory_virus_note
 @property {string} mandatory_virus_note_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} positive_feedback
 @property {string} positive_feedback_error
 @property {?date|string} schedule_appt
 @property {string} schedule_appt_error
 @property {?text|string} temps
 @property {string} temps_error
 @property {?number|int} ticket
 @property {string} ticket_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Tickets_Object} tickets
 @property {Users_Object} users_related_by_creator
 */
/**
 @typedef {Object.<any>} Tickets_Questions
 @property {Tickets_Questions_Properties} properties
 @property {Tickets_Questions_Has} has
 @property {Tickets_Questions_Is} is
 @property {Tickets_Questions_Object} object
 */
/**
 @typedef {Object.<any>} Tickets_Questions_Properties
 @property {number|int} header
 @property {number|int} pkey
 @property {text|string} text
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Tickets_Questions_Has
 */
/**
 @typedef {Object.<any>} Tickets_Questions_Is
 @property {Tickets_Headers_Object} ticket_headers
 */
/**
 @typedef {Object.<any>} Tickets_Questions_Object
 @property {?number|int} header
 @property {string} header_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} text
 @property {string} text_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Tickets_Headers_Object} ticket_headers
 */
/**
 @typedef {Object.<any>} Tickets_Types
 @property {Tickets_Types_Properties} properties
 @property {Tickets_Types_Has} has
 @property {Tickets_Types_Is} is
 @property {Tickets_Types_Object} object
 */
/**
 @typedef {Object.<any>} Tickets_Types_Properties
 @property {text|string} name
 @property {number|int} pkey
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Tickets_Types_Has
 */
/**
 @typedef {Object.<any>} Tickets_Types_Is
 */
/**
 @typedef {Object.<any>} Tickets_Types_Object
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Tickets_Wizard
 @property {Tickets_Wizard_Properties} properties
 @property {Tickets_Wizard_Has} has
 @property {Tickets_Wizard_Is} is
 @property {Tickets_Wizard_Object} object
 */
/**
 @typedef {Object.<any>} Tickets_Wizard_Properties
 @property {text|string} antimalware_scan
 @property {text|string} antivirus
 @property {text|string} antivirus_brand
 @property {number|int} ap_age
 @property {text|string} backup_method
 @property {text|string} backup_type
 @property {text|string} carbonite
 @property {text|string} checkup_service
 @property {text|string} chkdsk_results
 @property {text|string} cpu
 @property {boolean} cpu_in_range
 @property {text|string} cpu_temp
 @property {text|string} detailed_notes
 @property {number|int} device_amount
 @property {text|string} dns
 @property {text|string} drive_smart_ids
 @property {text|string} drive_smart_value
 @property {text|string} drive_speed
 @property {number|int} expected_labor
 @property {boolean} extensions_clean
 @property {text|string} failure_smart_values
 @property {text|string} frag_lvl
 @property {boolean} ghz_setup
 @property {text|string} gpu_temp
 @property {text|string} guest_network
 @property {text|string} hd_temp
 @property {text|string} hdd_smart_status
 @property {text|string} hhd_frag_percent
 @property {text|string} hhd_tune_result
 @property {text|string} ip_address
 @property {text|string} ip_static_dynamic
 @property {boolean} ipconfig_flushdns
 @property {boolean} isca
 @property {number|int} labor_amount
 @property {date|string} last_crash
 @property {date|string} last_local_backup
 @property {date|string} last_offsite_backup
 @property {date|string} last_reboot
 @property {date|string} last_scan
 @property {text|string} local_backup
 @property {text|string} local_backup_size
 @property {text|string} make_ap
 @property {text|string} malware_scan
 @property {text|string} mandatory_backup_note
 @property {text|string} mandatory_hdd_note
 @property {text|string} mandatory_network_note
 @property {text|string} mandatory_virus_note
 @property {text|string} manufacturer
 @property {text|string} mb_temp
 @property {text|string} notes
 @property {text|string} office_version
 @property {text|string} offsite_backup
 @property {text|string} offsite_backup_size
 @property {text|string} original_os
 @property {text|string} os
 @property {boolean} os_up_to_date
 @property {text|string} other_notes
 @property {text|string} other_software
 @property {text|string} other_software_function
 @property {number|int} parts_amount
 @property {boolean} patch_krack
 @property {number|int} payment_type
 @property {number|int} pkey
 @property {text|string} poh
 @property {text|string} positive_feedback
 @property {text|string} preferred_browser
 @property {text|string} qb_host_client
 @property {text|string} qb_version
 @property {text|string} ram
 @property {number|int} ram_slots_total
 @property {number|int} ram_slots_used
 @property {boolean} rec_new_fans
 @property {boolean} record_serial_key
 @property {date|string} schedule_appt
 @property {boolean} scheduler_clean
 @property {text|string} sector_count
 @property {text|string} sfc_results
 @property {text|string} short_network_survey
 @property {text|string} smart_errors
 @property {text|string} ssid
 @property {boolean} startup_clean
 @property {text|string} system_bit
 @property {text|string} system_errors
 @property {text|string} system_model
 @property {text|string} system_warnings
 @property {boolean} temp_safe_range
 @property {boolean} temp_under_stress
 @property {text|string} temps
 @property {text|string} third_party_plugins
 @property {boolean} up_to_date
 @property {number|int} virus_sales
 @property {text|string} wifi_channel
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Tickets_Wizard_Has
 */
/**
 @typedef {Object.<any>} Tickets_Wizard_Is
 @property {Tickets_Object} tickets
 @property {Tickets_Financials_Types_Object} tickets_financials_types
 */
/**
 @typedef {Object.<any>} Tickets_Wizard_Object
 @property {?text|string} antimalware_scan
 @property {string} antimalware_scan_error
 @property {?text|string} antivirus
 @property {string} antivirus_error
 @property {?text|string} antivirus_brand
 @property {string} antivirus_brand_error
 @property {?number|int} ap_age
 @property {string} ap_age_error
 @property {?text|string} backup_method
 @property {string} backup_method_error
 @property {?text|string} backup_type
 @property {string} backup_type_error
 @property {?text|string} carbonite
 @property {string} carbonite_error
 @property {?text|string} checkup_service
 @property {string} checkup_service_error
 @property {?text|string} chkdsk_results
 @property {string} chkdsk_results_error
 @property {?text|string} cpu
 @property {string} cpu_error
 @property {?boolean} cpu_in_range
 @property {string} cpu_in_range_error
 @property {?text|string} cpu_temp
 @property {string} cpu_temp_error
 @property {?text|string} detailed_notes
 @property {string} detailed_notes_error
 @property {?number|int} device_amount
 @property {string} device_amount_error
 @property {?text|string} dns
 @property {string} dns_error
 @property {?text|string} drive_smart_ids
 @property {string} drive_smart_ids_error
 @property {?text|string} drive_smart_value
 @property {string} drive_smart_value_error
 @property {?text|string} drive_speed
 @property {string} drive_speed_error
 @property {?number|int} expected_labor
 @property {string} expected_labor_error
 @property {?boolean} extensions_clean
 @property {string} extensions_clean_error
 @property {?text|string} failure_smart_values
 @property {string} failure_smart_values_error
 @property {?text|string} frag_lvl
 @property {string} frag_lvl_error
 @property {?boolean} ghz_setup
 @property {string} ghz_setup_error
 @property {?text|string} gpu_temp
 @property {string} gpu_temp_error
 @property {?text|string} guest_network
 @property {string} guest_network_error
 @property {?text|string} hd_temp
 @property {string} hd_temp_error
 @property {?text|string} hdd_smart_status
 @property {string} hdd_smart_status_error
 @property {?text|string} hhd_frag_percent
 @property {string} hhd_frag_percent_error
 @property {?text|string} hhd_tune_result
 @property {string} hhd_tune_result_error
 @property {?text|string} ip_address
 @property {string} ip_address_error
 @property {?text|string} ip_static_dynamic
 @property {string} ip_static_dynamic_error
 @property {?boolean} ipconfig_flushdns
 @property {string} ipconfig_flushdns_error
 @property {?boolean} isca
 @property {string} isca_error
 @property {?number|int} labor_amount
 @property {string} labor_amount_error
 @property {?date|string} last_crash
 @property {string} last_crash_error
 @property {?date|string} last_local_backup
 @property {string} last_local_backup_error
 @property {?date|string} last_offsite_backup
 @property {string} last_offsite_backup_error
 @property {?date|string} last_reboot
 @property {string} last_reboot_error
 @property {?date|string} last_scan
 @property {string} last_scan_error
 @property {?text|string} local_backup
 @property {string} local_backup_error
 @property {?text|string} local_backup_size
 @property {string} local_backup_size_error
 @property {?text|string} make_ap
 @property {string} make_ap_error
 @property {?text|string} malware_scan
 @property {string} malware_scan_error
 @property {?text|string} mandatory_backup_note
 @property {string} mandatory_backup_note_error
 @property {?text|string} mandatory_hdd_note
 @property {string} mandatory_hdd_note_error
 @property {?text|string} mandatory_network_note
 @property {string} mandatory_network_note_error
 @property {?text|string} mandatory_virus_note
 @property {string} mandatory_virus_note_error
 @property {?text|string} manufacturer
 @property {string} manufacturer_error
 @property {?text|string} mb_temp
 @property {string} mb_temp_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?text|string} office_version
 @property {string} office_version_error
 @property {?text|string} offsite_backup
 @property {string} offsite_backup_error
 @property {?text|string} offsite_backup_size
 @property {string} offsite_backup_size_error
 @property {?text|string} original_os
 @property {string} original_os_error
 @property {?text|string} os
 @property {string} os_error
 @property {?boolean} os_up_to_date
 @property {string} os_up_to_date_error
 @property {?text|string} other_notes
 @property {string} other_notes_error
 @property {?text|string} other_software
 @property {string} other_software_error
 @property {?text|string} other_software_function
 @property {string} other_software_function_error
 @property {?number|int} parts_amount
 @property {string} parts_amount_error
 @property {?boolean} patch_krack
 @property {string} patch_krack_error
 @property {?number|int} payment_type
 @property {string} payment_type_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} poh
 @property {string} poh_error
 @property {?text|string} positive_feedback
 @property {string} positive_feedback_error
 @property {?text|string} preferred_browser
 @property {string} preferred_browser_error
 @property {?text|string} qb_host_client
 @property {string} qb_host_client_error
 @property {?text|string} qb_version
 @property {string} qb_version_error
 @property {?text|string} ram
 @property {string} ram_error
 @property {?number|int} ram_slots_total
 @property {string} ram_slots_total_error
 @property {?number|int} ram_slots_used
 @property {string} ram_slots_used_error
 @property {?boolean} rec_new_fans
 @property {string} rec_new_fans_error
 @property {?boolean} record_serial_key
 @property {string} record_serial_key_error
 @property {?date|string} schedule_appt
 @property {string} schedule_appt_error
 @property {?boolean} scheduler_clean
 @property {string} scheduler_clean_error
 @property {?text|string} sector_count
 @property {string} sector_count_error
 @property {?text|string} sfc_results
 @property {string} sfc_results_error
 @property {?text|string} short_network_survey
 @property {string} short_network_survey_error
 @property {?text|string} smart_errors
 @property {string} smart_errors_error
 @property {?text|string} ssid
 @property {string} ssid_error
 @property {?boolean} startup_clean
 @property {string} startup_clean_error
 @property {?text|string} system_bit
 @property {string} system_bit_error
 @property {?text|string} system_errors
 @property {string} system_errors_error
 @property {?text|string} system_model
 @property {string} system_model_error
 @property {?text|string} system_warnings
 @property {string} system_warnings_error
 @property {?boolean} temp_safe_range
 @property {string} temp_safe_range_error
 @property {?boolean} temp_under_stress
 @property {string} temp_under_stress_error
 @property {?text|string} temps
 @property {string} temps_error
 @property {?text|string} third_party_plugins
 @property {string} third_party_plugins_error
 @property {?boolean} up_to_date
 @property {string} up_to_date_error
 @property {?number|int} virus_sales
 @property {string} virus_sales_error
 @property {?text|string} wifi_channel
 @property {string} wifi_channel_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Tickets_Object} tickets
 @property {Tickets_Financials_Types_Object} tickets_financials_types
 */
/**
 @typedef {Object.<any>} Time_Off
 @property {Time_Off_Properties} properties
 @property {Time_Off_Has} has
 @property {Time_Off_Is} is
 @property {Time_Off_Object} object
 */
/**
 @typedef {Object.<any>} Time_Off_Properties
 @property {text|string} calendars_linked
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} freshdesk
 @property {boolean} full_day
 @property {boolean} full_day_am_pm
 @property {string} image
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} notes
 @property {number|int} pkey
 @property {number|int} reason
 @property {date|string} requested_date_end
 @property {date|string} requested_date_start
 @property {number|int} requested_for
 @property {number|int} status
 @property {number|int} status_changed_by
 @property {date|string} status_date
 @property {text|string} time_slots
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 @property {text|string} requested_by
 */
/**
 @typedef {Object.<any>} Time_Off_Has
 */
/**
 @typedef {Object.<any>} Time_Off_Is
 @property {Time_Off_Reasons_Object} time_off_reasons
 @property {Time_Off_Status_Object} time_off_status
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Time_Off_Object
 @property {?text|string} calendars_linked
 @property {string} calendars_linked_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} freshdesk
 @property {string} freshdesk_error
 @property {?boolean} full_day
 @property {string} full_day_error
 @property {?boolean} full_day_am_pm
 @property {string} full_day_am_pm_error
 @property {?string} image
 @property {string} image_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} reason
 @property {string} reason_error
 @property {?date|string} requested_date_end
 @property {string} requested_date_end_error
 @property {?date|string} requested_date_start
 @property {string} requested_date_start_error
 @property {?number|int} requested_for
 @property {string} requested_for_error
 @property {?number|int} status
 @property {string} status_error
 @property {?number|int} status_changed_by
 @property {string} status_changed_by_error
 @property {?date|string} status_date
 @property {string} status_date_error
 @property {?text|string} time_slots
 @property {string} time_slots_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {?text|string} requested_by
 @property {string} requested_by_error
 @property {Time_Off_Reasons_Object} time_off_reasons
 @property {Time_Off_Status_Object} time_off_status
 @property {Users_Object} users
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Time_Off_Reasons
 @property {Time_Off_Reasons_Properties} properties
 @property {Time_Off_Reasons_Has} has
 @property {Time_Off_Reasons_Is} is
 @property {Time_Off_Reasons_Object} object
 */
/**
 @typedef {Object.<any>} Time_Off_Reasons_Properties
 @property {text|string} name
 @property {number|int} pkey
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Time_Off_Reasons_Has
 */
/**
 @typedef {Object.<any>} Time_Off_Reasons_Is
 */
/**
 @typedef {Object.<any>} Time_Off_Reasons_Object
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Time_Off_Status
 @property {Time_Off_Status_Properties} properties
 @property {Time_Off_Status_Has} has
 @property {Time_Off_Status_Is} is
 @property {Time_Off_Status_Object} object
 */
/**
 @typedef {Object.<any>} Time_Off_Status_Properties
 @property {number|int} pkey
 @property {text|string} status
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Time_Off_Status_Has
 */
/**
 @typedef {Object.<any>} Time_Off_Status_Is
 */
/**
 @typedef {Object.<any>} Time_Off_Status_Object
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} status
 @property {string} status_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Trip_Fees
 @property {Trip_Fees_Properties} properties
 @property {Trip_Fees_Has} has
 @property {Trip_Fees_Is} is
 @property {Trip_Fees_Object} object
 */
/**
 @typedef {Object.<any>} Trip_Fees_Properties
 @property {text|string} coords
 @property {number|int} pkey
 @property {number|int} region
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Trip_Fees_Has
 */
/**
 @typedef {Object.<any>} Trip_Fees_Is
 @property {Regions_Object} regions
 */
/**
 @typedef {Object.<any>} Trip_Fees_Object
 @property {?text|string} coords
 @property {string} coords_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} region
 @property {string} region_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Regions_Object} regions
 */
/**
 @typedef {Object.<any>} Unexpected_Errors
 @property {Unexpected_Errors_Properties} properties
 @property {Unexpected_Errors_Has} has
 @property {Unexpected_Errors_Is} is
 @property {Unexpected_Errors_Object} object
 */
/**
 @typedef {Object.<any>} Unexpected_Errors_Properties
 @property {number|int} account
 @property {text|string} message
 @property {text|string} path
 @property {number|int} pkey
 @property {text|string} stack
 @property {number|int} user
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Unexpected_Errors_Has
 */
/**
 @typedef {Object.<any>} Unexpected_Errors_Is
 */
/**
 @typedef {Object.<any>} Unexpected_Errors_Object
 @property {?number|int} account
 @property {string} account_error
 @property {?text|string} message
 @property {string} message_error
 @property {?text|string} path
 @property {string} path_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} stack
 @property {string} stack_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Users
 @property {Users_Properties} properties
 @property {Users_Has} has
 @property {Users_Is} is
 @property {Users_Object} object
 */
/**
 @typedef {Object.<any>} Users_Properties
 @property {number|int} account
 @property {boolean} active
 @property {number|int} base_pay
 @property {boolean} calendarException
 @property {number|int} carrier
 @property {text|string} city
 @property {number|int} commission
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} dd_account
 @property {text|string} dd_routing
 @property {boolean} deep_sleep
 @property {email} email
 @property {text|string} eventColor
 @property {number|int} fe_work_order_amount
 @property {boolean} fill_hold
 @property {date|string} last_approved_week
 @property {text|string} last_day_calendars_linked
 @property {date|string} last_day_working
 @property {text|string} last_passwords
 @property {number|int|float} latitude
 @property {number|int|float} longitude
 @property {number|int} main_role
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name_first
 @property {text|string} name_last
 @property {text|string} name_middle
 @property {date|string} onboarding_date
 @property {string} password
 @property {date|string} password_updated_at
 @property {text|string} phone_cell
 @property {text|string} phone_home
 @property {text|string} phone_work
 @property {number|int} pkey
 @property {number|int} region
 @property {text|string} state
 @property {text|string} street_1
 @property {date|string} temp_fifth
 @property {text|string} workingDays
 @property {text|string} zip
 @property {text|string} auth_code
 @property {boolean} b_checkbox
 @property {text|string} business_name
 @property {text|string} code
 @property {text|string} code_hash
 @property {number|int} code_pkey
 @property {date|string} consumed_at
 @property {text|string} consumed_device
 @property {text|string} consumed_display_time
 @property {boolean} consumed_offline
 @property {boolean} dd_pending
 @property {boolean} delayed
 @property {string} dl_back
 @property {string} dl_front
 @property {text|string} ein
 @property {text|string} event_type
 @property {text|string} llc_class
 @property {text|string} main_role_name
 @property {text|string} name
 @property {date|string} occurred_at
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 @property {text|string} other
 @property {text|string} reason
 @property {array} roles
 @property {text|string} schedule
 @property {text|string} secure_auth
 @property {number|int|float} service_latitude
 @property {number|int|float} service_longitude
 @property {number|int} service_radius
 @property {text|string} ssn
 @property {number|int} target_user
 @property {number|int} tax_classification
 @property {text|string} token
 @property {boolean} tos_checkbox
 @property {text|string} tos_signature
 @property {number|int} user
 @property {text|string} w9
 @property {text|string} w9_signature
 */
/**
 @typedef {Object.<any>} Users_Has
 @property {Users_Roles_Object[]} users_roless
 */
/**
 @typedef {Object.<any>} Users_Is
 @property {Accounts_Object} accounts
 @property {Carriers_Object} carriers
 @property {Regions_Object} regions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Users_Object
 @property {?number|int} account
 @property {string} account_error
 @property {?boolean} active
 @property {string} active_error
 @property {?number|int} base_pay
 @property {string} base_pay_error
 @property {?boolean} calendarException
 @property {string} calendarException_error
 @property {?number|int} carrier
 @property {string} carrier_error
 @property {?text|string} city
 @property {string} city_error
 @property {?number|int} commission
 @property {string} commission_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} dd_account
 @property {string} dd_account_error
 @property {?text|string} dd_routing
 @property {string} dd_routing_error
 @property {?boolean} deep_sleep
 @property {string} deep_sleep_error
 @property {?email} email
 @property {string} email_error
 @property {?text|string} eventColor
 @property {string} eventColor_error
 @property {?number|int} fe_work_order_amount
 @property {string} fe_work_order_amount_error
 @property {?boolean} fill_hold
 @property {string} fill_hold_error
 @property {?date|string} last_approved_week
 @property {string} last_approved_week_error
 @property {?text|string} last_day_calendars_linked
 @property {string} last_day_calendars_linked_error
 @property {?date|string} last_day_working
 @property {string} last_day_working_error
 @property {?text|string} last_passwords
 @property {string} last_passwords_error
 @property {?number|int|float} latitude
 @property {string} latitude_error
 @property {?number|int|float} longitude
 @property {string} longitude_error
 @property {?number|int} main_role
 @property {string} main_role_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name_first
 @property {string} name_first_error
 @property {?text|string} name_last
 @property {string} name_last_error
 @property {?text|string} name_middle
 @property {string} name_middle_error
 @property {?date|string} onboarding_date
 @property {string} onboarding_date_error
 @property {?string} password
 @property {string} password_error
 @property {?date|string} password_updated_at
 @property {string} password_updated_at_error
 @property {?text|string} phone_cell
 @property {string} phone_cell_error
 @property {?text|string} phone_home
 @property {string} phone_home_error
 @property {?text|string} phone_work
 @property {string} phone_work_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} region
 @property {string} region_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?date|string} temp_fifth
 @property {string} temp_fifth_error
 @property {?text|string} workingDays
 @property {string} workingDays_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {?text|string} auth_code
 @property {string} auth_code_error
 @property {?boolean} b_checkbox
 @property {string} b_checkbox_error
 @property {?text|string} business_name
 @property {string} business_name_error
 @property {?text|string} code
 @property {string} code_error
 @property {?text|string} code_hash
 @property {string} code_hash_error
 @property {?number|int} code_pkey
 @property {string} code_pkey_error
 @property {?date|string} consumed_at
 @property {string} consumed_at_error
 @property {?text|string} consumed_device
 @property {string} consumed_device_error
 @property {?text|string} consumed_display_time
 @property {string} consumed_display_time_error
 @property {?boolean} consumed_offline
 @property {string} consumed_offline_error
 @property {?boolean} dd_pending
 @property {string} dd_pending_error
 @property {?boolean} delayed
 @property {string} delayed_error
 @property {?string} dl_back
 @property {string} dl_back_error
 @property {?string} dl_front
 @property {string} dl_front_error
 @property {?text|string} ein
 @property {string} ein_error
 @property {?text|string} event_type
 @property {string} event_type_error
 @property {?text|string} llc_class
 @property {string} llc_class_error
 @property {?text|string} main_role_name
 @property {string} main_role_name_error
 @property {?text|string} name
 @property {string} name_error
 @property {?date|string} occurred_at
 @property {string} occurred_at_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {?text|string} other
 @property {string} other_error
 @property {?text|string} reason
 @property {string} reason_error
 @property {?array} roles
 @property {string} roles_error
 @property {?text|string} schedule
 @property {string} schedule_error
 @property {?text|string} secure_auth
 @property {string} secure_auth_error
 @property {?number|int|float} service_latitude
 @property {string} service_latitude_error
 @property {?number|int|float} service_longitude
 @property {string} service_longitude_error
 @property {?number|int} service_radius
 @property {string} service_radius_error
 @property {?text|string} ssn
 @property {string} ssn_error
 @property {?number|int} target_user
 @property {string} target_user_error
 @property {?number|int} tax_classification
 @property {string} tax_classification_error
 @property {?text|string} token
 @property {string} token_error
 @property {?boolean} tos_checkbox
 @property {string} tos_checkbox_error
 @property {?text|string} tos_signature
 @property {string} tos_signature_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} w9
 @property {string} w9_error
 @property {?text|string} w9_signature
 @property {string} w9_signature_error
 @property {Users_Roles_Object[]} users_roless
 @property {Accounts_Object} accounts
 @property {Carriers_Object} carriers
 @property {Regions_Object} regions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Users_Active
 @property {Users_Active_Properties} properties
 @property {Users_Active_Has} has
 @property {Users_Active_Is} is
 @property {Users_Active_Object} object
 */
/**
 @typedef {Object.<any>} Users_Active_Properties
 @property {boolean} active
 @property {date|string} date
 @property {text|string} last_action
 @property {number|int} pkey
 @property {number|int} user
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Users_Active_Has
 */
/**
 @typedef {Object.<any>} Users_Active_Is
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Users_Active_Object
 @property {?boolean} active
 @property {string} active_error
 @property {?date|string} date
 @property {string} date_error
 @property {?text|string} last_action
 @property {string} last_action_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Users_Favorites
 @property {Users_Favorites_Properties} properties
 @property {Users_Favorites_Has} has
 @property {Users_Favorites_Is} is
 @property {Users_Favorites_Object} object
 */
/**
 @typedef {Object.<any>} Users_Favorites_Properties
 @property {text|string} favorites
 @property {number|int} pkey
 @property {number|int} user
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Users_Favorites_Has
 */
/**
 @typedef {Object.<any>} Users_Favorites_Is
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Users_Favorites_Object
 @property {?text|string} favorites
 @property {string} favorites_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Users_Help_Desk
 @property {Users_Help_Desk_Properties} properties
 @property {Users_Help_Desk_Has} has
 @property {Users_Help_Desk_Is} is
 @property {Users_Help_Desk_Object} object
 */
/**
 @typedef {Object.<any>} Users_Help_Desk_Properties
 @property {number|int} account
 @property {boolean} active
 @property {number|int} base_pay
 @property {boolean} calendarException
 @property {number|int} carrier
 @property {text|string} city
 @property {number|int} commission
 @property {date|string} created
 @property {number|int} creator
 @property {text|string} dd_account
 @property {text|string} dd_routing
 @property {boolean} deep_sleep
 @property {email} email
 @property {text|string} eventColor
 @property {number|int} fe_work_order_amount
 @property {boolean} fill_hold
 @property {date|string} last_approved_week
 @property {text|string} last_day_calendars_linked
 @property {date|string} last_day_working
 @property {text|string} last_passwords
 @property {number|int|float} latitude
 @property {number|int|float} longitude
 @property {number|int} main_role
 @property {date|string} modified
 @property {number|int} modifier
 @property {text|string} name_first
 @property {text|string} name_last
 @property {text|string} name_middle
 @property {date|string} onboarding_date
 @property {string} password
 @property {date|string} password_updated_at
 @property {text|string} phone_cell
 @property {text|string} phone_home
 @property {text|string} phone_work
 @property {number|int} pkey
 @property {number|int} region
 @property {text|string} state
 @property {text|string} street_1
 @property {date|string} temp_fifth
 @property {text|string} workingDays
 @property {text|string} zip
 @property {text|string} auth_code
 @property {boolean} b_checkbox
 @property {text|string} business_name
 @property {text|string} code
 @property {text|string} code_hash
 @property {number|int} code_pkey
 @property {date|string} consumed_at
 @property {text|string} consumed_device
 @property {text|string} consumed_display_time
 @property {boolean} consumed_offline
 @property {boolean} dd_pending
 @property {boolean} delayed
 @property {string} dl_back
 @property {string} dl_front
 @property {text|string} ein
 @property {text|string} event_type
 @property {text|string} llc_class
 @property {text|string} main_role_name
 @property {text|string} name
 @property {date|string} occurred_at
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 @property {text|string} other
 @property {text|string} reason
 @property {array} roles
 @property {text|string} schedule
 @property {text|string} secure_auth
 @property {number|int|float} service_latitude
 @property {number|int|float} service_longitude
 @property {number|int} service_radius
 @property {text|string} ssn
 @property {number|int} target_user
 @property {number|int} tax_classification
 @property {text|string} token
 @property {boolean} tos_checkbox
 @property {text|string} tos_signature
 @property {number|int} user
 @property {text|string} w9
 @property {text|string} w9_signature
 */
/**
 @typedef {Object.<any>} Users_Help_Desk_Has
 @property {Users_Roles_Object[]} users_roless
 */
/**
 @typedef {Object.<any>} Users_Help_Desk_Is
 @property {Accounts_Object} accounts
 @property {Carriers_Object} carriers
 @property {Regions_Object} regions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Users_Help_Desk_Object
 @property {?number|int} account
 @property {string} account_error
 @property {?boolean} active
 @property {string} active_error
 @property {?number|int} base_pay
 @property {string} base_pay_error
 @property {?boolean} calendarException
 @property {string} calendarException_error
 @property {?number|int} carrier
 @property {string} carrier_error
 @property {?text|string} city
 @property {string} city_error
 @property {?number|int} commission
 @property {string} commission_error
 @property {?date|string} created
 @property {string} created_error
 @property {?number|int} creator
 @property {string} creator_error
 @property {?text|string} dd_account
 @property {string} dd_account_error
 @property {?text|string} dd_routing
 @property {string} dd_routing_error
 @property {?boolean} deep_sleep
 @property {string} deep_sleep_error
 @property {?email} email
 @property {string} email_error
 @property {?text|string} eventColor
 @property {string} eventColor_error
 @property {?number|int} fe_work_order_amount
 @property {string} fe_work_order_amount_error
 @property {?boolean} fill_hold
 @property {string} fill_hold_error
 @property {?date|string} last_approved_week
 @property {string} last_approved_week_error
 @property {?text|string} last_day_calendars_linked
 @property {string} last_day_calendars_linked_error
 @property {?date|string} last_day_working
 @property {string} last_day_working_error
 @property {?text|string} last_passwords
 @property {string} last_passwords_error
 @property {?number|int|float} latitude
 @property {string} latitude_error
 @property {?number|int|float} longitude
 @property {string} longitude_error
 @property {?number|int} main_role
 @property {string} main_role_error
 @property {?date|string} modified
 @property {string} modified_error
 @property {?number|int} modifier
 @property {string} modifier_error
 @property {?text|string} name_first
 @property {string} name_first_error
 @property {?text|string} name_last
 @property {string} name_last_error
 @property {?text|string} name_middle
 @property {string} name_middle_error
 @property {?date|string} onboarding_date
 @property {string} onboarding_date_error
 @property {?string} password
 @property {string} password_error
 @property {?date|string} password_updated_at
 @property {string} password_updated_at_error
 @property {?text|string} phone_cell
 @property {string} phone_cell_error
 @property {?text|string} phone_home
 @property {string} phone_home_error
 @property {?text|string} phone_work
 @property {string} phone_work_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} region
 @property {string} region_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?date|string} temp_fifth
 @property {string} temp_fifth_error
 @property {?text|string} workingDays
 @property {string} workingDays_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {?text|string} auth_code
 @property {string} auth_code_error
 @property {?boolean} b_checkbox
 @property {string} b_checkbox_error
 @property {?text|string} business_name
 @property {string} business_name_error
 @property {?text|string} code
 @property {string} code_error
 @property {?text|string} code_hash
 @property {string} code_hash_error
 @property {?number|int} code_pkey
 @property {string} code_pkey_error
 @property {?date|string} consumed_at
 @property {string} consumed_at_error
 @property {?text|string} consumed_device
 @property {string} consumed_device_error
 @property {?text|string} consumed_display_time
 @property {string} consumed_display_time_error
 @property {?boolean} consumed_offline
 @property {string} consumed_offline_error
 @property {?boolean} dd_pending
 @property {string} dd_pending_error
 @property {?boolean} delayed
 @property {string} delayed_error
 @property {?string} dl_back
 @property {string} dl_back_error
 @property {?string} dl_front
 @property {string} dl_front_error
 @property {?text|string} ein
 @property {string} ein_error
 @property {?text|string} event_type
 @property {string} event_type_error
 @property {?text|string} llc_class
 @property {string} llc_class_error
 @property {?text|string} main_role_name
 @property {string} main_role_name_error
 @property {?text|string} name
 @property {string} name_error
 @property {?date|string} occurred_at
 @property {string} occurred_at_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {?text|string} other
 @property {string} other_error
 @property {?text|string} reason
 @property {string} reason_error
 @property {?array} roles
 @property {string} roles_error
 @property {?text|string} schedule
 @property {string} schedule_error
 @property {?text|string} secure_auth
 @property {string} secure_auth_error
 @property {?number|int|float} service_latitude
 @property {string} service_latitude_error
 @property {?number|int|float} service_longitude
 @property {string} service_longitude_error
 @property {?number|int} service_radius
 @property {string} service_radius_error
 @property {?text|string} ssn
 @property {string} ssn_error
 @property {?number|int} target_user
 @property {string} target_user_error
 @property {?number|int} tax_classification
 @property {string} tax_classification_error
 @property {?text|string} token
 @property {string} token_error
 @property {?boolean} tos_checkbox
 @property {string} tos_checkbox_error
 @property {?text|string} tos_signature
 @property {string} tos_signature_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} w9
 @property {string} w9_error
 @property {?text|string} w9_signature
 @property {string} w9_signature_error
 @property {Users_Roles_Object[]} users_roless
 @property {Accounts_Object} accounts
 @property {Carriers_Object} carriers
 @property {Regions_Object} regions
 @property {Users_Object} users_related_by_creator
 @property {Users_Object} users_related_by_modifier
 */
/**
 @typedef {Object.<any>} Users_Inactive
 @property {Users_Inactive_Properties} properties
 @property {Users_Inactive_Has} has
 @property {Users_Inactive_Is} is
 @property {Users_Inactive_Object} object
 */
/**
 @typedef {Object.<any>} Users_Inactive_Properties
 @property {number|int} pkey
 @property {text|string} reasoning
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Users_Inactive_Has
 */
/**
 @typedef {Object.<any>} Users_Inactive_Is
 */
/**
 @typedef {Object.<any>} Users_Inactive_Object
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} reasoning
 @property {string} reasoning_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Users_Mouse_Movement
 @property {Users_Mouse_Movement_Properties} properties
 @property {Users_Mouse_Movement_Has} has
 @property {Users_Mouse_Movement_Is} is
 @property {Users_Mouse_Movement_Object} object
 */
/**
 @typedef {Object.<any>} Users_Mouse_Movement_Properties
 @property {text|string} city
 @property {date|string} date
 @property {email} email
 @property {text|string} name_first
 @property {text|string} name_last
 @property {text|string} name_middle
 @property {string} password
 @property {number|int} pkey
 @property {text|string} position
 @property {text|string} state
 @property {text|string} street_1
 @property {number|int} user
 @property {text|string} zip
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Users_Mouse_Movement_Has
 */
/**
 @typedef {Object.<any>} Users_Mouse_Movement_Is
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Users_Mouse_Movement_Object
 @property {?text|string} city
 @property {string} city_error
 @property {?date|string} date
 @property {string} date_error
 @property {?email} email
 @property {string} email_error
 @property {?text|string} name_first
 @property {string} name_first_error
 @property {?text|string} name_last
 @property {string} name_last_error
 @property {?text|string} name_middle
 @property {string} name_middle_error
 @property {?string} password
 @property {string} password_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} position
 @property {string} position_error
 @property {?text|string} state
 @property {string} state_error
 @property {?text|string} street_1
 @property {string} street_1_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} zip
 @property {string} zip_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Users_Stats
 @property {Users_Stats_Properties} properties
 @property {Users_Stats_Has} has
 @property {Users_Stats_Is} is
 @property {Users_Stats_Object} object
 */
/**
 @typedef {Object.<any>} Users_Stats_Properties
 @property {number|int|float} anti_virus_30day
 @property {number|int|float} carbonite_30day
 @property {number|int|float} daily_total
 @property {number|int} pkey
 @property {number|int|float} total_stats_30day
 @property {number|int|float} total_stats_7day
 @property {number|int|float} total_stats_today
 @property {number|int|float} total_stats_yesterday
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Users_Stats_Has
 */
/**
 @typedef {Object.<any>} Users_Stats_Is
 */
/**
 @typedef {Object.<any>} Users_Stats_Object
 @property {?number|int|float} anti_virus_30day
 @property {string} anti_virus_30day_error
 @property {?number|int|float} carbonite_30day
 @property {string} carbonite_30day_error
 @property {?number|int|float} daily_total
 @property {string} daily_total_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int|float} total_stats_30day
 @property {string} total_stats_30day_error
 @property {?number|int|float} total_stats_7day
 @property {string} total_stats_7day_error
 @property {?number|int|float} total_stats_today
 @property {string} total_stats_today_error
 @property {?number|int|float} total_stats_yesterday
 @property {string} total_stats_yesterday_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Version
 @property {Version_Properties} properties
 @property {Version_Has} has
 @property {Version_Is} is
 @property {Version_Object} object
 */
/**
 @typedef {Object.<any>} Version_Properties
 @property {number|int} pkey
 @property {text|string} version_number
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Version_Has
 */
/**
 @typedef {Object.<any>} Version_Is
 */
/**
 @typedef {Object.<any>} Version_Object
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} version_number
 @property {string} version_number_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Videos
 @property {Videos_Properties} properties
 @property {Videos_Has} has
 @property {Videos_Is} is
 @property {Videos_Object} object
 */
/**
 @typedef {Object.<any>} Videos_Properties
 @property {number|int} category
 @property {text|string} information
 @property {number|int} pkey
 @property {number|int} sub_category
 @property {text|string} title
 @property {text|string} url
 @property {text|string} user_accesses
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Videos_Has
 */
/**
 @typedef {Object.<any>} Videos_Is
 @property {Categories_Object} categories
 @property {Sub_Categories_Object} sub_categories
 */
/**
 @typedef {Object.<any>} Videos_Object
 @property {?number|int} category
 @property {string} category_error
 @property {?text|string} information
 @property {string} information_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} sub_category
 @property {string} sub_category_error
 @property {?text|string} title
 @property {string} title_error
 @property {?text|string} url
 @property {string} url_error
 @property {?text|string} user_accesses
 @property {string} user_accesses_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Categories_Object} categories
 @property {Sub_Categories_Object} sub_categories
 */
/**
 @typedef {Object.<any>} Wo_Clear_Codes
 @property {Wo_Clear_Codes_Properties} properties
 @property {Wo_Clear_Codes_Has} has
 @property {Wo_Clear_Codes_Is} is
 @property {Wo_Clear_Codes_Object} object
 */
/**
 @typedef {Object.<any>} Wo_Clear_Codes_Properties
 @property {date|string} consumed_at
 @property {text|string} consumed_device
 @property {boolean} consumed_offline
 @property {date|string} consumed_reported_at
 @property {date|string} created
 @property {date|string} issued_at
 @property {number|int} issued_by
 @property {text|string} issued_by_label
 @property {number|int} pkey
 @property {text|string} purpose
 @property {text|string} reason
 @property {number|int} user
 @property {text|string} engineer_name
 @property {text|string} issuer_name
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Wo_Clear_Codes_Has
 */
/**
 @typedef {Object.<any>} Wo_Clear_Codes_Is
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Wo_Clear_Codes_Object
 @property {?date|string} consumed_at
 @property {string} consumed_at_error
 @property {?text|string} consumed_device
 @property {string} consumed_device_error
 @property {?boolean} consumed_offline
 @property {string} consumed_offline_error
 @property {?date|string} consumed_reported_at
 @property {string} consumed_reported_at_error
 @property {?date|string} created
 @property {string} created_error
 @property {?date|string} issued_at
 @property {string} issued_at_error
 @property {?number|int} issued_by
 @property {string} issued_by_error
 @property {?text|string} issued_by_label
 @property {string} issued_by_label_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} purpose
 @property {string} purpose_error
 @property {?text|string} reason
 @property {string} reason_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} engineer_name
 @property {string} engineer_name_error
 @property {?text|string} issuer_name
 @property {string} issuer_name_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Workflow_Attempts
 @property {Workflow_Attempts_Properties} properties
 @property {Workflow_Attempts_Has} has
 @property {Workflow_Attempts_Is} is
 @property {Workflow_Attempts_Object} object
 */
/**
 @typedef {Object.<any>} Workflow_Attempts_Properties
 @property {number|int} attempt_no
 @property {text|string} command
 @property {boolean} discussed_av
 @property {text|string} image_field_key
 @property {boolean} infections_found
 @property {text|string} notes
 @property {date|string} occurred_at
 @property {text|string} outcome
 @property {number|int} pkey
 @property {text|string} process
 @property {text|string} stage
 @property {number|int} ticket
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Workflow_Attempts_Has
 */
/**
 @typedef {Object.<any>} Workflow_Attempts_Is
 @property {Tickets_Object} tickets
 */
/**
 @typedef {Object.<any>} Workflow_Attempts_Object
 @property {?number|int} attempt_no
 @property {string} attempt_no_error
 @property {?text|string} command
 @property {string} command_error
 @property {?boolean} discussed_av
 @property {string} discussed_av_error
 @property {?text|string} image_field_key
 @property {string} image_field_key_error
 @property {?boolean} infections_found
 @property {string} infections_found_error
 @property {?text|string} notes
 @property {string} notes_error
 @property {?date|string} occurred_at
 @property {string} occurred_at_error
 @property {?text|string} outcome
 @property {string} outcome_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} process
 @property {string} process_error
 @property {?text|string} stage
 @property {string} stage_error
 @property {?number|int} ticket
 @property {string} ticket_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Tickets_Object} tickets
 */
/**
 @typedef {Object.<any>} States
 @property {States_Properties} properties
 @property {States_Has} has
 @property {States_Is} is
 @property {States_Object} object
 */
/**
 @typedef {Object.<any>} States_Properties
 @property {text|string} name
 @property {number|int} pkey
 @property {text|string} short
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} States_Has
 */
/**
 @typedef {Object.<any>} States_Is
 */
/**
 @typedef {Object.<any>} States_Object
 @property {?text|string} name
 @property {string} name_error
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?text|string} short
 @property {string} short_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 */
/**
 @typedef {Object.<any>} Users_Roles
 @property {Users_Roles_Properties} properties
 @property {Users_Roles_Has} has
 @property {Users_Roles_Is} is
 @property {Users_Roles_Object} object
 */
/**
 @typedef {Object.<any>} Users_Roles_Properties
 @property {number|int} pkey
 @property {number|int} role
 @property {number|int} user
 @property {text|string} operation_scope
 @property {text|string} operation_uuid
 */
/**
 @typedef {Object.<any>} Users_Roles_Has
 */
/**
 @typedef {Object.<any>} Users_Roles_Is
 @property {Roles_Object} roles
 @property {Users_Object} users
 */
/**
 @typedef {Object.<any>} Users_Roles_Object
 @property {?number|int} pkey
 @property {string} pkey_error
 @property {?number|int} role
 @property {string} role_error
 @property {?number|int} user
 @property {string} user_error
 @property {?text|string} operation_scope
 @property {string} operation_scope_error
 @property {?text|string} operation_uuid
 @property {string} operation_uuid_error
 @property {Roles_Object} roles
 @property {Users_Object} users
 */
const Types = {
	Accolades : {
		_name : "Accolades",
	},
	Accounts : {
		_name : "Accounts",
	},
	Actionable_Calendars : {
		_name : "Actionable_Calendars",
	},
	Activity_Logs : {
		_name : "Activity_Logs",
	},
	Activity_Types : {
		_name : "Activity_Types",
	},
	Admins : {
		_name : "Admins",
	},
	Alerts : {
		_name : "Alerts",
	},
	Auth_Codes : {
		_name : "Auth_Codes",
	},
	Automated_Emails : {
		_name : "Automated_Emails",
	},
	Av_Center : {
		_name : "Av_Center",
	},
	Av_Center_Audit : {
		_name : "Av_Center_Audit",
	},
	Av_Keys : {
		_name : "Av_Keys",
	},
	Av_Links : {
		_name : "Av_Links",
	},
	Av_Upcoming_Renewals : {
		_name : "Av_Upcoming_Renewals",
	},
	Business_Cards : {
		_name : "Business_Cards",
	},
	Calendar : {
		_name : "Calendar",
	},
	Calendar_Alerts : {
		_name : "Calendar_Alerts",
	},
	Calendar_Help_Desk_Checked : {
		_name : "Calendar_Help_Desk_Checked",
	},
	Calendar_Help_Desk_Notes : {
		_name : "Calendar_Help_Desk_Notes",
	},
	Calendar_Logs : {
		_name : "Calendar_Logs",
	},
	Calendar_Resources : {
		_name : "Calendar_Resources",
	},
	Call_Types : {
		_name : "Call_Types",
	},
	Candidate_Statuses : {
		_name : "Candidate_Statuses",
	},
	Candidates_Notes : {
		_name : "Candidates_Notes",
	},
	Carbonite_Sales : {
		_name : "Carbonite_Sales",
	},
	Carriers : {
		_name : "Carriers",
	},
	Categories : {
		_name : "Categories",
	},
	Categories_Subs : {
		_name : "Categories_Subs",
	},
	Copyables : {
		_name : "Copyables",
	},
	Count_Variables : {
		_name : "Count_Variables",
	},
	Customers : {
		_name : "Customers",
	},
	Customers_Changes : {
		_name : "Customers_Changes",
	},
	Customers_Locations : {
		_name : "Customers_Locations",
	},
	Customers_Locations_Logs : {
		_name : "Customers_Locations_Logs",
	},
	Customers_Logs : {
		_name : "Customers_Logs",
	},
	Department_Overrides : {
		_name : "Department_Overrides",
	},
	Dispatch : {
		_name : "Dispatch",
	},
	Dispatch_Calendars : {
		_name : "Dispatch_Calendars",
	},
	Dispatch_Daily_Workflow : {
		_name : "Dispatch_Daily_Workflow",
	},
	Dispatch_Scores : {
		_name : "Dispatch_Scores",
	},
	Engineer_Scores : {
		_name : "Engineer_Scores",
	},
	Engineer_Stats : {
		_name : "Engineer_Stats",
	},
	Engineers_Reviews : {
		_name : "Engineers_Reviews",
	},
	Engineers_Service_Regions : {
		_name : "Engineers_Service_Regions",
	},
	Engineers_Status : {
		_name : "Engineers_Status",
	},
	Engineers_Ticket_Status : {
		_name : "Engineers_Ticket_Status",
	},
	Executives : {
		_name : "Executives",
	},
	Fe_Metrics : {
		_name : "Fe_Metrics",
	},
	Feedback_Locations : {
		_name : "Feedback_Locations",
	},
	Feedback_Responses : {
		_name : "Feedback_Responses",
	},
	Financial_Edits : {
		_name : "Financial_Edits",
	},
	Financials : {
		_name : "Financials",
	},
	Financials_Invoice : {
		_name : "Financials_Invoice",
	},
	Forms : {
		_name : "Forms",
	},
	Forms_All : {
		_name : "Forms_All",
	},
	Forms_Results : {
		_name : "Forms_Results",
	},
	Freshdesk_Counts : {
		_name : "Freshdesk_Counts",
	},
	Freshdesk_Merge_Subjects : {
		_name : "Freshdesk_Merge_Subjects",
	},
	Geo_Coords : {
		_name : "Geo_Coords",
	},
	Help_Desks : {
		_name : "Help_Desks",
	},
	Help_Desks_Contacted : {
		_name : "Help_Desks_Contacted",
	},
	Helpdesk_Scores : {
		_name : "Helpdesk_Scores",
	},
	Hiring : {
		_name : "Hiring",
	},
	Hiring_Candidate : {
		_name : "Hiring_Candidate",
	},
	Hiring_Zone : {
		_name : "Hiring_Zone",
	},
	Hiring_Scores : {
		_name : "Hiring_Scores",
	},
	Inactive_Av_Subscriptions : {
		_name : "Inactive_Av_Subscriptions",
	},
	Kpi_Metrics : {
		_name : "Kpi_Metrics",
	},
	Links : {
		_name : "Links",
	},
	Manager_Logs : {
		_name : "Manager_Logs",
	},
	Manager_Tasks : {
		_name : "Manager_Tasks",
	},
	Manager_Tasks_Comments : {
		_name : "Manager_Tasks_Comments",
	},
	Managers : {
		_name : "Managers",
	},
	Missing_Financial_Workflows : {
		_name : "Missing_Financial_Workflows",
	},
	Notification_Types : {
		_name : "Notification_Types",
	},
	Notifications : {
		_name : "Notifications",
	},
	Outstanding_Invoices : {
		_name : "Outstanding_Invoices",
	},
	Payment_Pay : {
		_name : "Payment_Pay",
	},
	Payments : {
		_name : "Payments",
	},
	Phone_Logs : {
		_name : "Phone_Logs",
	},
	Phone_Logs_Regions : {
		_name : "Phone_Logs_Regions",
	},
	Phone_Logs_Users : {
		_name : "Phone_Logs_Users",
	},
	Recurring_Tasks : {
		_name : "Recurring_Tasks",
	},
	Recurring_Tasks_Clicked : {
		_name : "Recurring_Tasks_Clicked",
	},
	Recurring_Tasks_Logs : {
		_name : "Recurring_Tasks_Logs",
	},
	Recurring_Tasks_Order : {
		_name : "Recurring_Tasks_Order",
	},
	Refunds : {
		_name : "Refunds",
	},
	Regions : {
		_name : "Regions",
	},
	Regions_Feedback : {
		_name : "Regions_Feedback",
	},
	Reviews : {
		_name : "Reviews",
	},
	Roles : {
		_name : "Roles",
	},
	Schedule_Approvals : {
		_name : "Schedule_Approvals",
	},
	Schedules : {
		_name : "Schedules",
	},
	Scores : {
		_name : "Scores",
	},
	Scores_Highs : {
		_name : "Scores_Highs",
	},
	Scores_Names : {
		_name : "Scores_Names",
	},
	Scores_Parts : {
		_name : "Scores_Parts",
	},
	Stripe : {
		_name : "Stripe",
	},
	Stripe_Charges : {
		_name : "Stripe_Charges",
	},
	Stripe_Products : {
		_name : "Stripe_Products",
	},
	Stripe_Av_Unmatched : {
		_name : "Stripe_Av_Unmatched",
	},
	Stripe_Subscription_Renewal_Logs : {
		_name : "Stripe_Subscription_Renewal_Logs",
	},
	Temp_Days_Off : {
		_name : "Temp_Days_Off",
	},
	Temp_Users : {
		_name : "Temp_Users",
	},
	Ticket_Audits : {
		_name : "Ticket_Audits",
	},
	Tickets : {
		_name : "Tickets",
	},
	Tickets_Checklist : {
		_name : "Tickets_Checklist",
	},
	Tickets_Deposits : {
		_name : "Tickets_Deposits",
	},
	Tickets_Financials : {
		_name : "Tickets_Financials",
	},
	Tickets_Financials_Images : {
		_name : "Tickets_Financials_Images",
	},
	Tickets_Financials_Logs : {
		_name : "Tickets_Financials_Logs",
	},
	Tickets_Financials_Signatures : {
		_name : "Tickets_Financials_Signatures",
	},
	Tickets_Financials_Types : {
		_name : "Tickets_Financials_Types",
	},
	Tickets_Freshdesk_Attachment : {
		_name : "Tickets_Freshdesk_Attachment",
	},
	Tickets_Headers : {
		_name : "Tickets_Headers",
	},
	Tickets_Images : {
		_name : "Tickets_Images",
	},
	Tickets_Information : {
		_name : "Tickets_Information",
	},
	Tickets_Lists : {
		_name : "Tickets_Lists",
	},
	Tickets_Logs : {
		_name : "Tickets_Logs",
	},
	Tickets_Notes : {
		_name : "Tickets_Notes",
	},
	Tickets_Questions : {
		_name : "Tickets_Questions",
	},
	Tickets_Types : {
		_name : "Tickets_Types",
	},
	Tickets_Wizard : {
		_name : "Tickets_Wizard",
	},
	Time_Off : {
		_name : "Time_Off",
	},
	Time_Off_Reasons : {
		_name : "Time_Off_Reasons",
	},
	Time_Off_Status : {
		_name : "Time_Off_Status",
	},
	Trip_Fees : {
		_name : "Trip_Fees",
	},
	Unexpected_Errors : {
		_name : "Unexpected_Errors",
	},
	Users : {
		_name : "Users",
	},
	Users_Active : {
		_name : "Users_Active",
	},
	Users_Favorites : {
		_name : "Users_Favorites",
	},
	Users_Help_Desk : {
		_name : "Users_Help_Desk",
	},
	Users_Inactive : {
		_name : "Users_Inactive",
	},
	Users_Mouse_Movement : {
		_name : "Users_Mouse_Movement",
	},
	Users_Stats : {
		_name : "Users_Stats",
	},
	Version : {
		_name : "Version",
	},
	Videos : {
		_name : "Videos",
	},
	Wo_Clear_Codes : {
		_name : "Wo_Clear_Codes",
	},
	Workflow_Attempts : {
		_name : "Workflow_Attempts",
	},
	States : {
		_name : "States",
	},
	Users_Roles : {
		_name : "Users_Roles",
	},
};
export default Types;
